import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CamelizedJson: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

/** Access entity */
export type Access = {
  __typename?: 'Access';
  /** Component name (Access control component) */
  component: AccessComponentEnum;
  /** Related items IDs */
  itemIds: Array<Scalars['ID']['output']>;
  /** Level of access */
  level: Maybe<AccessLevelEnum>;
  /** Policy type */
  policy: Maybe<AccessPolicyEnum>;
  /** Scope level */
  scopeLevel: Maybe<AccessScopeLevelEnum>;
};

/** Available components */
export enum AccessComponentEnum {
  /** Assets counter reading (index adding) */
  AssetsCounterReading = 'ASSETS_COUNTER_READING',
  /** Assets management */
  AssetsManagement = 'ASSETS_MANAGEMENT',
  /** Assets management in asset categories only */
  AssetsManagementCategoriesScope = 'ASSETS_MANAGEMENT_CATEGORIES_SCOPE',
  /** Asset categories management */
  AssetCategoriesManagement = 'ASSET_CATEGORIES_MANAGEMENT',
  /** Form categories management */
  FormCategoriesManagement = 'FORM_CATEGORIES_MANAGEMENT',
  /** Home page management */
  HomePageManagement = 'HOME_PAGE_MANAGEMENT',
  /** Interventions management */
  InterventionsManagement = 'INTERVENTIONS_MANAGEMENT',
  /** Interventions management in intervention categories only */
  InterventionsManagementCategoriesScope = 'INTERVENTIONS_MANAGEMENT_CATEGORIES_SCOPE',
  /** Intervention categories management */
  InterventionCategoriesManagement = 'INTERVENTION_CATEGORIES_MANAGEMENT',
  /** Sites management */
  SitesManagement = 'SITES_MANAGEMENT',
  /** Tasks management */
  TasksManagement = 'TASKS_MANAGEMENT',
  /** Tasks performing */
  TasksPerforming = 'TASKS_PERFORMING',
  /** Users and teams management */
  UsersManagement = 'USERS_MANAGEMENT'
}

/** Access attributes */
export type AccessCuInputObject = {
  /** Destroy access */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Component name (Access control component) */
  component: AccessComponentEnum;
  /** Scope items attributes array */
  items?: InputMaybe<Array<LinkingInputObject>>;
  /** Level of access (for non-scope access) */
  level?: InputMaybe<AccessLevelEnum>;
  /** Scope level of access (for scope access) */
  scopeLevel?: InputMaybe<AccessScopeLevelEnum>;
};

/** Available levels of access */
export enum AccessLevelEnum {
  LimitedRead = 'LIMITED_READ',
  Read = 'READ',
  Write = 'WRITE'
}

/** Available policies of accesses based on every possible setup */
export enum AccessPolicyEnum {
  CompanyPlan = 'COMPANY_PLAN',
  Default = 'DEFAULT',
  Team = 'TEAM',
  User = 'USER'
}

/** Available scope levels of access */
export enum AccessScopeLevelEnum {
  All = 'ALL',
  Selected = 'SELECTED'
}

/** API Token */
export type ApiToken = TimestampInterface & {
  __typename?: 'ApiToken';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ApiToken ID */
  id: Scalars['ID']['output'];
  /** Label */
  label: Maybe<Scalars['String']['output']>;
  /** Last activity time */
  lastActivityAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status */
  status: Maybe<ApiTokenStatusEnum>;
  /** Token (can be accessed once only after creation) */
  token: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** ApiTokenCollection type */
export type ApiTokenCollection = {
  __typename?: 'ApiTokenCollection';
  /** A collection of paginated ApiTokenCollection */
  collection: Array<ApiToken>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type ApiTokenCreateInput = {
  /** Create attributes */
  attributes: ApiTokenCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** ApiToken attributes */
export type ApiTokenCreateInputObject = {
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type ApiTokenDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ApiToken ID */
  id: Scalars['ID']['input'];
};

/** Available statuses */
export enum ApiTokenStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Description from base input object. Please set your description for child object. */
export type ApiTokenUpdateInput = {
  /** Update attributes */
  attributes: ApiTokenUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ApiToken ID */
  id: Scalars['ID']['input'];
};

/** ApiToken attributes */
export type ApiTokenUpdateInputObject = {
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Status */
  status?: InputMaybe<ApiTokenStatusEnum>;
};

/** Asset entity */
export type Asset = TimestampInterface & {
  __typename?: 'Asset';
  canDestroy: AuthorizationResult;
  /**
   * Asset Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<AssetCategory>;
  /** Asset Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Counter count */
  countersCount: Maybe<Scalars['Int']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Asset icon */
  iconAttached: Maybe<Attachment>;
  /** Asset ID */
  id: Scalars['ID']['output'];
  /** Manufacturer */
  manufacturer: Maybe<Scalars['String']['output']>;
  /** Model */
  model: Maybe<Scalars['String']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi: Scalars['Boolean']['output'];
  /** QR code prefix */
  qrPrefix: Maybe<Scalars['String']['output']>;
  /** Serial number */
  serialNumber: Maybe<Scalars['String']['output']>;
  /** Service date */
  serviceDate: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates number of nomenclatures where is used */
  usesAsNomenclatureCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type AssetBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** Asset Category entity */
export type AssetCategory = TimestampInterface & {
  __typename?: 'AssetCategory';
  /** Assets collection */
  assets: AssetCollection;
  canDestroy: AuthorizationResult;
  /** Color */
  color: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Asset Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Prefix */
  prefix: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of visible Assets */
  visibleAssetsCount: Scalars['Int']['output'];
};


/** Asset Category entity */
export type AssetCategoryAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** AssetCategoryCollection type */
export type AssetCategoryCollection = {
  __typename?: 'AssetCategoryCollection';
  /** A collection of paginated AssetCategoryCollection */
  collection: Array<AssetCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryCreateInput = {
  /** Create attributes */
  attributes: AssetCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Asset Category attributes */
export type AssetCategoryCreateInputObject = {
  /** Color */
  color: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
  /** Prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category ID */
  id: Scalars['ID']['input'];
};

/** Asset Category filters */
export type AssetCategoryFilterInputObject = {
  /** Asset Category ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Asset Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Asset Category sorts */
export type AssetCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of visible Assets in this category */
  visibleAssetsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCategoryUpdateInput = {
  /** Update attributes */
  attributes: AssetCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset Category ID */
  id: Scalars['ID']['input'];
  /** Refresh QR prefix for related assets */
  refreshQrPrefixForAssets?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Asset Category attributes */
export type AssetCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/** AssetCollection type */
export type AssetCollection = {
  __typename?: 'AssetCollection';
  /** A collection of paginated AssetCollection */
  collection: Array<Asset>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type AssetCreateInput = {
  /** Create attributes */
  attributes: AssetCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Asset attributes */
export type AssetCreateInputObject = {
  /** Asset Category ID */
  categoryId: Scalars['ID']['input'];
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Service date */
  serviceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Site ID */
  siteId: Scalars['ID']['input'];
};

/** Asset filters */
export type AssetFilterInputObject = {
  /** Asset Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Asset Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Asset code */
  code?: InputMaybe<FilterInputObject>;
  /** Counter count */
  countersCount?: InputMaybe<FilterIntInputObject>;
  /** Asset ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Asset manufacturer */
  manufacturer?: InputMaybe<FilterInputObject>;
  /** Asset name */
  name?: InputMaybe<FilterInputObject>;
  /** QR prefix */
  qrPrefix?: InputMaybe<FilterInputObject>;
  /** Asset serial number */
  serialNumber?: InputMaybe<FilterInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Site Sector ID */
  siteSectorId?: InputMaybe<FilterIdInputObject>;
};

/** Asset attributes */
export type AssetFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Asset sorts */
export type AssetSortInputObject = {
  /** Asset Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Asset manufacturer */
  manufacturer?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Asset serial number */
  serialNumber?: InputMaybe<SortDirectionEnum>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site code */
  siteCode?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AssetUpdateInput = {
  /** Update attributes */
  attributes: AssetUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Asset ID */
  id: Scalars['ID']['input'];
};

/** Asset attributes */
export type AssetUpdateInputObject = {
  /** Asset Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Manufacturer */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** Model */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if asset location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Service date */
  serviceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Update QR prefix (if true, QR prefix will be used from asset category prefix) */
  updateQrPrefix?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Attachment */
export type Attachment = {
  __typename?: 'Attachment';
  /** Raw file data JSON (to copy attached files from one object to another without reprocessing) */
  fileData: Maybe<Scalars['JSON']['output']>;
  /** Any string to identify file in CDN (content delivery network) (e.g. some default icon or image or whatever) */
  fileTag: Maybe<Scalars['String']['output']>;
  /** Filename */
  filename: Maybe<Scalars['String']['output']>;
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** {description: "Metadata", fields: {intended_use: "Intended use"}} */
  metadata: Maybe<AttachmentMetadata>;
  /** MIME type */
  mimeType: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Maybe<Scalars['Int']['output']>;
  /** Indicates if attachment is processed */
  processed: Scalars['Boolean']['output'];
  /** URLs */
  urls: Maybe<AttachmentUrl>;
};

/** Attachment attributes */
export type AttachmentCuInputObject = {
  /** Destroy attachment */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** File */
  file?: InputMaybe<AttachmentFileInputObject>;
  /** Any string to identify file in CDN (content delivery network) (e.g. some default icon or image or whatever) */
  fileTag?: InputMaybe<Scalars['String']['input']>;
  /** Filename */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Attachment ID (to update existing attachment pass ID. To create new attachment do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata */
  metadata?: InputMaybe<AttachmentMetadataInputObject>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** File attributes */
export type AttachmentFileDerivativesInputObject = {
  /** Large */
  large: AttachmentFileInfoInputObject;
  /** Medium */
  medium: AttachmentFileInfoInputObject;
  /** Small */
  small: AttachmentFileInfoInputObject;
};

/** File attributes */
export type AttachmentFileInfoInputObject = {
  /** File ID */
  id: Scalars['String']['input'];
  /** Metadata */
  metadata: AttachmentFileMetadataInputObject;
  /** Storage */
  storage: AttachmentStorageEnum;
};

/** File attributes */
export type AttachmentFileInputObject = {
  /** Derivatives */
  derivatives?: InputMaybe<AttachmentFileDerivativesInputObject>;
  /** File ID */
  id: Scalars['String']['input'];
  /** Metadata */
  metadata: AttachmentFileMetadataInputObject;
  /** Storage */
  storage: AttachmentStorageEnum;
};

/** File attributes */
export type AttachmentFileMetadataInputObject = {
  /** Filename */
  filename: Scalars['String']['input'];
  /** Height */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Mime type */
  mimeType: Scalars['String']['input'];
  /** Size of file */
  size: Scalars['Int']['input'];
  /** Width */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Metadata */
export type AttachmentMetadata = {
  __typename?: 'AttachmentMetadata';
  /** Intended use */
  intendedUse: Maybe<Scalars['String']['output']>;
};

/** Metadata attributes */
export type AttachmentMetadataInputObject = {
  /** Intended use */
  intendedUse?: InputMaybe<Scalars['String']['input']>;
};

/** Available storages */
export enum AttachmentStorageEnum {
  Cache = 'cache',
  Store = 'store'
}

/** Attachment URLs */
export type AttachmentUrl = {
  __typename?: 'AttachmentUrl';
  /** Image preview URL */
  imagePreview: Maybe<Scalars['String']['output']>;
  /** Large URL */
  large: Maybe<Scalars['String']['output']>;
  /** Medium URL */
  medium: Maybe<Scalars['String']['output']>;
  /** Original URL */
  original: Maybe<Scalars['String']['output']>;
  /** Original direct download URL (without preview in browser even for known formats) */
  originalDirectDownload: Maybe<Scalars['String']['output']>;
  /** Small URL */
  small: Maybe<Scalars['String']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsEmailConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsRegistrationConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsResendEmailConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resource ID */
  id: Scalars['String']['input'];
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationConfirmationsResendRegistrationConfirmationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Resource ID */
  id: Scalars['String']['input'];
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Show entrypoint */
export type AuthenticationEntrypointUnion = ApiToken | Session;

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordSetupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsForgotInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email: Scalars['String']['input'];
  /** Url to change password */
  redirectUrl: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Token */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationPasswordsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** Current password. Required only if user already has a password set (check hasPassword field). */
  passwordChallenge?: InputMaybe<Scalars['String']['input']>;
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationResendAccountLockedEmailForAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to include in the email for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** ID of the locked admin to send the email to */
  targetAdminId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationResendAccountLockedEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the locked account */
  email: Scalars['String']['input'];
  /** URL for account restore link in email */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Account type (USER or SYSTEM_ADMIN) */
  scope: AuthenticationScopeEnum;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationRestoreAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New password */
  password: Scalars['String']['input'];
  /** New password confirmation */
  passwordConfirmation: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Account restore token from email */
  token: Scalars['String']['input'];
};

/** Available resource scopes */
export enum AuthenticationScopeEnum {
  SystemAdmin = 'SYSTEM_ADMIN',
  User = 'USER'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password: Scalars['String']['input'];
  /** Scope */
  scope: AuthenticationScopeEnum;
  /** Email or username */
  uid: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to exclude current session (default true) */
  excludeCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionEndSpecificInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Session ID */
  sessionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionReportSuspiciousByTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Token from email */
  token: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationSessionReportSuspiciousInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL to redirect to for account restoration */
  restoreRedirectUrl: Scalars['String']['input'];
  /** Session ID to report */
  sessionId: Scalars['ID']['input'];
};

/** Two-factor authentication code types */
export enum AuthenticationTwoFactorCodeTypeEnum {
  /** Backup code */
  Backup = 'BACKUP',
  /** Email One-Time Password */
  Email = 'EMAIL',
  /** Time-based One-Time Password */
  Totp = 'TOTP'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorDisableEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorDisableTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorEnableEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from email */
  code: Scalars['String']['input'];
  /** Generate backup codes after enabling email OTP */
  generateBackupCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorEnableTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from authenticator app */
  code: Scalars['String']['input'];
  /** Generate backup codes after enabling TOTP */
  generateBackupCodes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorGenerateBackupCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Two-factor authentication methods */
export enum AuthenticationTwoFactorOtpMethodEnum {
  /** Email One-Time Password */
  Email = 'EMAIL',
  /** Time-based One-Time Password (authenticator app) */
  Totp = 'TOTP'
}

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorResendEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current admin's 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Target SystemAdmin ID */
  targetAdminId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorSetupEmailOtpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA verification code (required when adding second method) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Type of verification code (required when adding second method) */
  codeType?: InputMaybe<AuthenticationTwoFactorCodeTypeEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorSetupTotpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA verification code (required when adding second method) */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Type of verification code (required when adding second method) */
  codeType?: InputMaybe<AuthenticationTwoFactorCodeTypeEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type AuthenticationTwoFactorVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 6-digit code from authenticator app or email */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Show current user */
export type AuthenticationWhoamiUnion = SystemAdmin | User;

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

/** Company entity */
export type Company = TimestampInterface & {
  __typename?: 'Company';
  /** Active users count in the company */
  activeUsersCount: Scalars['Int']['output'];
  /** Country */
  country: CountryEnum;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if company is deactivated */
  deactivated: Scalars['Boolean']['output'];
  /** Description */
  description: Scalars['String']['output'];
  /** Company ID */
  id: Scalars['ID']['output'];
  /** Industry */
  industry: Maybe<Industry>;
  /** Name */
  name: Scalars['String']['output'];
  /** Company full admin owner entity */
  owner: Maybe<User>;
  /** Plan entity */
  plan: CompanyPlan;
  /** Timezone name */
  timezone: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Website */
  website: Maybe<Scalars['String']['output']>;
};

/** CompanyCollection type */
export type CompanyCollection = {
  __typename?: 'CompanyCollection';
  /** A collection of paginated CompanyCollection */
  collection: Array<Company>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyCreateInput = {
  /** Create attributes */
  attributes: CompanyCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** Company attributes */
export type CompanyCreateInputObject = {
  /** Admin attributes */
  admin: UserCreateOwnerInputObject;
  /** Country */
  country: CountryEnum;
  /** Description */
  description: Scalars['String']['input'];
  /** Industry ID */
  industryId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Plan attributes */
  plan: CompanyPlanCuInputObject;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** Company Domain entity */
export type CompanyDomain = TimestampInterface & {
  __typename?: 'CompanyDomain';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Full DNS TXT record for domain verification */
  dnsTxtRecord: Scalars['String']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Company Domain ID */
  id: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** DNS verification token */
  verificationToken: Scalars['String']['output'];
  /** Indicates if domain is verified */
  verified: Scalars['Boolean']['output'];
  /** Verification timestamp */
  verifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** CompanyDomainCollection type */
export type CompanyDomainCollection = {
  __typename?: 'CompanyDomainCollection';
  /** A collection of paginated CompanyDomainCollection */
  collection: Array<CompanyDomain>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainCreateInput = {
  /** Create attributes */
  attributes: CompanyDomainCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Company Domain attributes */
export type CompanyDomainCreateInputObject = {
  /** Domain name (e.g., example.com) */
  domain: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Domain ID */
  id: Scalars['ID']['input'];
};

/** Company Domain filters */
export type CompanyDomainFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Domain name */
  domain?: InputMaybe<FilterInputObject>;
  /** Company Domain ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Verification timestamp */
  verifiedAt?: InputMaybe<FilterDateInputObject>;
};

/** Company Domain sorts */
export type CompanyDomainSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Domain name */
  domain?: InputMaybe<SortDirectionEnum>;
  /** Verification timestamp */
  verifiedAt?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyDomainVerifyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company Domain ID */
  id: Scalars['ID']['input'];
};

/** Company filters */
export type CompanyFilterInputObject = {
  /** Country name */
  country?: InputMaybe<FilterInputObject>;
  /** Industry ID */
  industryId?: InputMaybe<FilterIdInputObject>;
  /** Industry name */
  industryName?: InputMaybe<FilterInputObject>;
  /** Company name */
  name?: InputMaybe<FilterInputObject>;
  /** Owner full name */
  ownerFullName?: InputMaybe<FilterInputObject>;
  /** Plan kind */
  planKind?: InputMaybe<FilterIntInputObject>;
};

/** Company plan entity */
export type CompanyPlan = TimestampInterface & {
  __typename?: 'CompanyPlan';
  /** Accesses */
  accesses: Array<Access>;
  /** Shows a list of available access components to create or edit for company users */
  allowedUsersAccessComponents: Array<AccessComponentEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Currency
   * ATTENTION: Access allowed for system admins.
   */
  currency: Maybe<CompanyPlanCurrencyEnum>;
  /** Company plan ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: CompanyPlanKindEnum;
  /**
   * Payment period
   * ATTENTION: Access allowed for system admins.
   */
  paymentPeriod: Maybe<CompanyPlanPaymentPeriodEnum>;
  /**
   * Price
   * ATTENTION: Access allowed for system admins.
   */
  price: Maybe<Scalars['Float']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Maximum active users */
  usersLimit: Maybe<Scalars['Int']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyPlanChangeRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Params */
  params: CompanyPlanChangeRequestInputObject;
};

/** Company Plan change params */
export type CompanyPlanChangeRequestInputObject = {
  /**  Link to open the company profile page for system admins. Supported variables: `companyId`. Example: `https://system.datizy.com/dashboard/accounts/:companyId/view`  */
  companyProfileLink: Scalars['String']['input'];
  /** Email to contact */
  contactEmail: Scalars['String']['input'];
  /** Message */
  message: Scalars['String']['input'];
};

/** Company Plan attributes */
export type CompanyPlanCuInputObject = {
  /** Accesses */
  accesses: Array<AccessCuInputObject>;
  /** Currency */
  currency: CompanyPlanCurrencyEnum;
  /** Kind */
  kind: CompanyPlanKindEnum;
  /** Payment period */
  paymentPeriod: CompanyPlanPaymentPeriodEnum;
  /** Price */
  price: Scalars['Float']['input'];
  /** Limit of users */
  usersLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Available currencies */
export enum CompanyPlanCurrencyEnum {
  Eur = 'EUR'
}

/** Available plans */
export enum CompanyPlanKindEnum {
  Custom = 'CUSTOM',
  Gold = 'GOLD',
  Silver = 'SILVER',
  Starter = 'STARTER'
}

/** Available payment periods */
export enum CompanyPlanPaymentPeriodEnum {
  Month = 'MONTH'
}

/** Company sorts */
export type CompanySortInputObject = {
  /** Active users count */
  activeUsersCount?: InputMaybe<SortDirectionEnum>;
  /** Country name */
  country?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Industry name */
  industryName?: InputMaybe<SortDirectionEnum>;
  /** Company name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Owner full name */
  ownerFullName?: InputMaybe<SortDirectionEnum>;
  /** Plan kind */
  planKind?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CompanyUpdateInput = {
  /** Update attributes */
  attributes: CompanyUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** Company attributes */
export type CompanyUpdateInputObject = {
  /** Admin ID */
  adminId?: InputMaybe<Scalars['ID']['input']>;
  /** Country */
  country?: InputMaybe<CountryEnum>;
  /** Deactivate company */
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  industryId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Plan attributes */
  plan?: InputMaybe<CompanyPlanCuInputObject>;
  /** Website */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Counter entity */
export type Counter = TimestampInterface & {
  __typename?: 'Counter';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Asset;
  /** Asset ID */
  assetId: Scalars['ID']['output'];
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Counter ID */
  id: Scalars['ID']['output'];
  /** Last check at */
  lastCheckAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Latest index value */
  latestIndex: Maybe<Scalars['Float']['output']>;
  /** Measure type */
  measureType: CounterMeasureTypeEnum;
  /** Measure unit */
  measureUnit: CounterMeasureUnitEnum;
  /** Name */
  name: Scalars['String']['output'];
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type CounterBulkDestroyInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type CounterBulkQrCodeCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** CounterCollection type */
export type CounterCollection = {
  __typename?: 'CounterCollection';
  /** A collection of paginated CounterCollection */
  collection: Array<Counter>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CounterCreateInput = {
  /** Create attributes */
  attributes: CounterCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Counter attributes */
export type CounterCreateInputObject = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Code */
  code: Scalars['String']['input'];
  /** Measure type */
  measureType: CounterMeasureTypeEnum;
  /** Measure unit */
  measureUnit: CounterMeasureUnitEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious: Scalars['Boolean']['input'];
};

/** Counter filters */
export type CounterFilterInputObject = {
  /** Code */
  code?: InputMaybe<FilterInputObject>;
};

/** Counter attributes */
export type CounterFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Counter Measure entity */
export type CounterMeasure = TimestampInterface & {
  __typename?: 'CounterMeasure';
  /**
   * Counter entity
   * NOTE: if you only need an Object ID, please use the counterId field to reduce the load on the database.
   */
  counter: Counter;
  /** Counter ID */
  counterId: Scalars['ID']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** (Total Consumption) - Previous cumulative value + the gap (to get the total usage over time) */
  cumulativeUsage: Scalars['Float']['output'];
  /** (Consumption) - The difference between the current index and the previous check index. If a new meter is installed, calculate the difference accordingly */
  gap: Scalars['Float']['output'];
  /** Counter ID */
  id: Scalars['ID']['output'];
  /** Manually entered the reading value */
  index: Scalars['Float']['output'];
  /** Indicates if the measure was reset to zero */
  resetToZero: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** CounterMeasureCollection type */
export type CounterMeasureCollection = {
  __typename?: 'CounterMeasureCollection';
  /** A collection of paginated CounterMeasureCollection */
  collection: Array<CounterMeasure>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type CounterMeasureCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Create attributes */
  attributes: CounterMeasureCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Counter Measure attributes */
export type CounterMeasureCreateInputObject = {
  /** Counter ID */
  counterId: Scalars['ID']['input'];
  /** Manually entered the reading value */
  index: Scalars['Float']['input'];
};

/** Counter Measure filters */
export type CounterMeasureFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
};

/** Counter Measure graph data */
export type CounterMeasureGraphData = {
  __typename?: 'CounterMeasureGraphData';
  /** Created at */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** (Total Consumption) - Previous cumulative value + the gap (to get the total usage over time) */
  cumulativeUsage: Scalars['Float']['output'];
  /** (Consumption) - The difference between the current index and the previous check index. If a new meter is installed, calculate the difference accordingly */
  gap: Scalars['Float']['output'];
};

/** Counter Measure sorts */
export type CounterMeasureSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** All available measure types */
export enum CounterMeasureTypeEnum {
  Distance = 'DISTANCE',
  Energy = 'ENERGY',
  Mass = 'MASS',
  Quantity = 'QUANTITY',
  Time = 'TIME'
}

/** All available measure units */
export enum CounterMeasureUnitEnum {
  Centimeter = 'CENTIMETER',
  Foot = 'FOOT',
  Gram = 'GRAM',
  Hour = 'HOUR',
  Kilogram = 'KILOGRAM',
  Kilometer = 'KILOMETER',
  KilowattHour = 'KILOWATT_HOUR',
  Meter = 'METER',
  Mile = 'MILE',
  Minute = 'MINUTE',
  Piece = 'PIECE',
  Second = 'SECOND',
  Ton = 'TON',
  Yard = 'YARD'
}

/** Description from base input object. Please set your description for child object. */
export type CounterResetToZeroInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter ID */
  id: Scalars['ID']['input'];
};

/** Counter sorts */
export type CounterSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Last check at */
  lastCheckAt?: InputMaybe<SortDirectionEnum>;
  /** Latest index value */
  latestIndex?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type CounterUpdateInput = {
  /** Counter ID */
  assetId: Scalars['ID']['input'];
  /** Update attributes */
  attributes: CounterUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Counter ID */
  id: Scalars['ID']['input'];
};

/** Counter attributes */
export type CounterUpdateInputObject = {
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Prohibit lower index. The next index must be higher than the previous one. The cumulative usage is calculated by adding the gap to the last cumulative total that is stored after the counter is reset. Allow lower index. The next index can be lower than the previous one. The cumulative usage is calculated by adding the index to the last cumulative total that is stored after the counter is reset. */
  prohibitLowerIndexThanPrevious?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Available countries */
export enum CountryEnum {
  /** Andorra */
  Ad = 'AD',
  /** Albania */
  Al = 'AL',
  /** Austria */
  At = 'AT',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Belgium */
  Be = 'BE',
  /** Bulgaria */
  Bg = 'BG',
  /** Canada */
  Ca = 'CA',
  /** Switzerland */
  Ch = 'CH',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Denmark */
  Dk = 'DK',
  /** Estonia */
  Ee = 'EE',
  /** Spain */
  Es = 'ES',
  /** Finland */
  Fi = 'FI',
  /** France */
  Fr = 'FR',
  /** United Kingdom */
  Gb = 'GB',
  /** Greenland */
  Gl = 'GL',
  /** Greece */
  Gr = 'GR',
  /** Croatia */
  Hr = 'HR',
  /** Hungary */
  Hu = 'HU',
  /** Ireland */
  Ie = 'IE',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** North Macedonia */
  Mk = 'MK',
  /** Malta */
  Mt = 'MT',
  /** Mexico */
  Mx = 'MX',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Portugal */
  Pt = 'PT',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Sweden */
  Se = 'SE',
  /** Slovenia */
  Si = 'SI',
  /** Slovakia */
  Sk = 'SK',
  /** San Marino */
  Sm = 'SM',
  /** Ukraine */
  Ua = 'UA',
  /** United States of America */
  Us = 'US',
  /** Vatican City */
  Va = 'VA'
}

/** Data Import entity */
export type DataImport = TimestampInterface & {
  __typename?: 'DataImport';
  /** Attachment to import */
  attachmentAttached: Maybe<Attachment>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Failure error details */
  failureDetails: Maybe<Scalars['CamelizedJson']['output']>;
  /** File exception (use when failureDetails is empty and there is a file exception) */
  fileException: Maybe<Array<Scalars['String']['output']>>;
  /** Data Import ID */
  id: Scalars['ID']['output'];
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors: Scalars['Boolean']['output'];
  /** Imported rows */
  importedRows: Maybe<Scalars['Int']['output']>;
  /** Job ID */
  jid: Maybe<Scalars['String']['output']>;
  /** Job entity */
  job: Maybe<Job>;
  /** Kind of import */
  kind: DataImportKindEnum;
  /** Current status */
  status: DataImportStatusEnum;
  /** Total rows to import */
  totalRows: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Created by User
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: User;
  /** Created by User ID */
  userId: Scalars['ID']['output'];
};

/** DataImportCollection type */
export type DataImportCollection = {
  __typename?: 'DataImportCollection';
  /** A collection of paginated DataImportCollection */
  collection: Array<DataImport>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type DataImportCreateInput = {
  /** Create attributes */
  attributes: DataImportCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Data Import attributes */
export type DataImportCreateInputObject = {
  /** Attachment to import */
  attachmentAttached: AttachmentCuInputObject;
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Kind of import */
  kind: DataImportKindEnum;
};

/** Description from base input object. Please set your description for child object. */
export type DataImportDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Import ID */
  id: Scalars['ID']['input'];
};

/** Data Import filters */
export type DataImportFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterInputObject>;
  /** Data Import ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Kind of import */
  kind?: InputMaybe<FilterInputObject>;
};

/** Available data import kinds */
export enum DataImportKindEnum {
  Asset = 'ASSET',
  Site = 'SITE',
  SiteArea = 'SITE_AREA'
}

/** Data Import sorts */
export type DataImportSortInputObject = {
  /** Attachment filename */
  attachmentFilename?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Kind of import */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Created by user full name */
  userFullName?: InputMaybe<SortDirectionEnum>;
};

/** Available data import statuses */
export enum DataImportStatusEnum {
  /** Completed successfully */
  Complete = 'COMPLETE',
  /** Failed (after all retries) */
  Failed = 'FAILED',
  /** Interrupted */
  Interrupted = 'INTERRUPTED',
  /** Queued (waiting to be processed) */
  Queued = 'QUEUED',
  /** Retrying again (after failure) */
  Retrying = 'RETRYING',
  /** Stopped */
  Stopped = 'STOPPED',
  /** Work in progress */
  Working = 'WORKING'
}

/** Description from base input object. Please set your description for child object. */
export type DataImportUpdateInput = {
  /** Update attributes */
  attributes: DataImportUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Import ID */
  id: Scalars['ID']['input'];
};

/** Data Import attributes */
export type DataImportUpdateInputObject = {
  /** Attachment to import */
  attachmentAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Indicator to ignore rows with errors and import only valid rows */
  ignoreRowsWithErrors?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Date range attributes */
export type DateRangeInputObject = {
  /** End date */
  endDate: Scalars['ISO8601Date']['input'];
  /** Start date */
  startDate: Scalars['ISO8601Date']['input'];
};

/** Documentation entity */
export type Documentation = TimestampInterface & {
  __typename?: 'Documentation';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Asset;
  /** Asset ID */
  assetId: Scalars['ID']['output'];
  /** File */
  attachmentAttached: Maybe<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: User;
  /** User ID */
  createdById: Scalars['ID']['output'];
  /** Documentation ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Tags collection */
  tags: Array<Tag>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkCreateInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** Create attributes */
  attributes: Array<DocumentationCreateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationBulkDestroyInput = {
  /** Asset ID */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** DocumentationCollection type */
export type DocumentationCollection = {
  __typename?: 'DocumentationCollection';
  /** A collection of paginated DocumentationCollection */
  collection: Array<Documentation>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Documentation attributes */
export type DocumentationCreateInputObject = {
  /** File */
  attachmentAttached: AttachmentCuInputObject;
  /** Tags */
  documentationTags?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Documentation filters */
export type DocumentationFilterInputObject = {
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Tag name */
  tagsName?: InputMaybe<FilterInputObject>;
};

/** Documentation sorts */
export type DocumentationSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Created by user full name */
  createdByFullName?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type DocumentationUpdateInput = {
  /** Documentation ID */
  assetId: Scalars['ID']['input'];
  /** Update attributes */
  attributes: DocumentationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documentation ID */
  id: Scalars['ID']['input'];
};

/** Documentation attributes */
export type DocumentationUpdateInputObject = {
  /** Tags */
  documentationTags?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

/** Fake DNS record entity (non-production only) */
export type FakeDnsRecord = TimestampInterface & {
  __typename?: 'FakeDnsRecord';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Domain name */
  domain: Scalars['String']['output'];
  /** Fake DNS record ID */
  id: Scalars['ID']['output'];
  /** DNS record type */
  recordType: FakeDnsRecordTypeEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Record value */
  value: Maybe<Scalars['String']['output']>;
};

/** FakeDnsRecordCollection type */
export type FakeDnsRecordCollection = {
  __typename?: 'FakeDnsRecordCollection';
  /** A collection of paginated FakeDnsRecordCollection */
  collection: Array<FakeDnsRecord>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordCreateInput = {
  /** Create attributes */
  attributes: FakeDnsRecordCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Fake DNS record attributes (non-production only) */
export type FakeDnsRecordCreateInputObject = {
  /** Domain name */
  domain: Scalars['String']['input'];
  /** DNS record type (txt, a, cname, mx) */
  recordType?: InputMaybe<FakeDnsRecordTypeEnum>;
  /** Record value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fake DNS record ID */
  id: Scalars['ID']['input'];
};

/** Available fake DNS record types (non-production only) */
export enum FakeDnsRecordTypeEnum {
  /** A record */
  A = 'A',
  /** CNAME record */
  Cname = 'CNAME',
  /** MX record */
  Mx = 'MX',
  /** TXT record */
  Txt = 'TXT'
}

/** Description from base input object. Please set your description for child object. */
export type FakeDnsRecordUpdateInput = {
  /** Update attributes */
  attributes: FakeDnsRecordUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fake DNS record ID */
  id: Scalars['ID']['input'];
};

/** Fake DNS record attributes (non-production only) */
export type FakeDnsRecordUpdateInputObject = {
  /** Domain name */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** DNS record type (txt, a, cname, mx) */
  recordType?: InputMaybe<FakeDnsRecordTypeEnum>;
  /** Record value */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Frontend Filter Preset entity */
export type FeFilterPreset = TimestampInterface & {
  __typename?: 'FeFilterPreset';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Untyped data in any format that frontend will understand. */
  data: Scalars['JSON']['output'];
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities: FeFilterPresetEntities;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: Scalars['String']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FeFilterPresetCollection type */
export type FeFilterPresetCollection = {
  __typename?: 'FeFilterPresetCollection';
  /** A collection of paginated FeFilterPresetCollection */
  collection: Array<FeFilterPreset>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetCreateInput = {
  /** Create attributes */
  attributes: FeFilterPresetCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Frontend Filter Preset attributes */
export type FeFilterPresetCreateInputObject = {
  /** Untyped data in any format that frontend will understand. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities?: InputMaybe<FeFilterPresetEntitiesInputObject>;
  /** Kind */
  kind: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset Entities entity */
export type FeFilterPresetEntities = {
  __typename?: 'FeFilterPresetEntities';
  /** Form Categories collection */
  formCategories: Maybe<Array<FeFilterPresetEntity>>;
  /** Form Templates collection */
  formTemplates: Maybe<Array<FeFilterPresetEntity>>;
  /** Sectors collection */
  sectors: Maybe<Array<FeFilterPresetEntity>>;
  /** Sites collection */
  sites: Maybe<Array<FeFilterPresetEntity>>;
};

/** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
export type FeFilterPresetEntitiesInputObject = {
  /** Form Categories attributes array */
  formCategories?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Form Templates attributes array */
  formTemplates?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Sectors attributes array */
  sectors?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
  /** Sites attributes array */
  sites?: InputMaybe<Array<FeFilterPresetEntityInputObject>>;
};

/** Frontend Filter Preset Entity entity */
export type FeFilterPresetEntity = {
  __typename?: 'FeFilterPresetEntity';
  /** Entity ID */
  id: Scalars['ID']['output'];
};

/** Entity attributes */
export type FeFilterPresetEntityInputObject = {
  /** Entity ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset filters */
export type FeFilterPresetFilterInputObject = {
  /** Frontend Filter Preset ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Kind */
  kind?: InputMaybe<FilterInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
};

/** Frontend Filter Preset sorts */
export type FeFilterPresetSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FeFilterPresetUpdateInput = {
  /** Update attributes */
  attributes: FeFilterPresetUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend Filter Preset ID */
  id: Scalars['ID']['input'];
};

/** Frontend Filter Preset attributes */
export type FeFilterPresetUpdateInputObject = {
  /** Untyped data in any format that frontend will understand. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Entities attributes array. Used for storing entity IDs. Will be automatically deleted from preset when entity is deleted. */
  entities?: InputMaybe<FeFilterPresetEntitiesInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterDateInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterDatePredicateInputObject;
};

/** Filters */
export type FilterDatePredicateInputObject = {
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Determines if result must be matched with all filters ('and') or any of them ('or') */
export enum FilterGroupingEnum {
  /** All */
  And = 'and',
  /** Any */
  Or = 'or'
}

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterIdInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterIdPredicateInputObject;
};

/** Filters */
export type FilterIdPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterPredicateInputObject;
};

/**
 * Filters
 * Examples:
 *   ```
 *   {
 *       "siteId": {
 *       "grouping": "or",
 *       "predicate": {
 *           "in": [
 *             "bab53e5d-be4b-4f5d-8429-ff5d3521d08e",
 *             "14fd0a18-6a3c-4523-aa68-a661641360f6"
 *           ]
 *       },
 *       "filterGroup": "filter1"
 *     }
 *   },
 *   {
 *       "siteAreaId": {
 *           "grouping": "or",
 *           "predicate": {
 *               "in": [
 *                   "57c6364d-0f55-43b0-8e7c-776011f8e2a9",
 *                   "e226b0e1-6ffd-4918-9aad-bbf217258ea7"
 *               ]
 *           },
 *           "filterGroup": "filter1"
 *       }
 *   },
 *   {
 *       "name": {
 *           "grouping": "or",
 *           "predicate": { "cont": "cleaning" },
 *           "filterGroup": "filter2"
 *       }
 *   },
 *   {
 *       "priority": {
 *           "grouping": "or",
 *           "predicate": { "in": ["HIGH", "MEDIUM", "LOW"] },
 *           "filterGroup": "filter2"
 *       }
 *   }
 *   ```
 *
 */
export type FilterIntInputObject = {
  /** Allows to group many filters by AND. For example, if you want to filter by (name or email) AND by (site or area), you can group them together. Specify the same group for the (name and email) and then specify an another group for (site and area). The filters in the same group will be combined by AND/OR (depends on grouping attribute) and the groups will be combined by AND. The filter_group is a string and it can be any string. It is used to group filters together. You can see the example in the description, where the filter_group is 'filter1' and 'filter2'. In the example, the result will be in the following format: (siteId OR siteAreaId) AND (name OR priority) */
  filterGroup?: InputMaybe<Scalars['String']['input']>;
  /** Determines if result must be matched with all filters ('AND') or any of them ('OR') */
  grouping?: InputMaybe<FilterGroupingEnum>;
  /** Predicate */
  predicate: FilterIntPredicateInputObject;
};

/** Filters */
export type FilterIntPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to all */
  eqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than all */
  gtAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than any */
  gtAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to all */
  gteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to any */
  gteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than all */
  ltAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than any */
  ltAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to all */
  lteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to any */
  lteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to all */
  notEqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters */
export type FilterPredicateInputObject = {
  /** Is null or empty (SQL: col is null OR col = '') */
  blank?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains (ILIKE %value%) */
  cont?: InputMaybe<Scalars['String']['input']>;
  /** Contains all (ILIKE %all values%) */
  contAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any (ILIKE %any value%) */
  contAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not match (NOT ILIKE value) */
  doesNotMatch?: InputMaybe<Scalars['String']['input']>;
  /** Does not match all (NOT ILIKE all values) */
  doesNotMatchAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not match any (NOT ILIKE any value) */
  doesNotMatchAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ends with (ILIKE %value) */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Ends with all (ILIKE %all values) */
  endAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ends with any (ILIKE %any value) */
  endAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Equal to */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Equal to all */
  eqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** false */
  false?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than all */
  gtAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than any */
  gtAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to all */
  gteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Greater than or equal to any */
  gteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains value with case insensitive */
  iCont?: InputMaybe<Scalars['String']['input']>;
  /** Contains all values with case insensitive */
  iContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any value with case insensitive */
  iContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** In */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than all */
  ltAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than any */
  ltAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to all */
  lteqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Less than or equal to any */
  lteqAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches (ILIKE value) */
  matches?: InputMaybe<Scalars['String']['input']>;
  /** Matches all (ILIKE all values) */
  matchesAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches any (ILIKE any value) */
  matchesAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain (NOT ILIKE %value%) */
  notCont?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain all (NOT ILIKE %all values%) */
  notContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain any (NOT ILIKE %any value%) */
  notContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not end with (NOT ILIKE %value) */
  notEnd?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with all (NOT ILIKE %all values) */
  notEndAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not end with any (NOT ILIKE %any value) */
  notEndAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not equal to */
  notEq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to all */
  notEqAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain value with case insensitive */
  notICont?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain all values with case insensitive */
  notIContAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain any value with case insensitive */
  notIContAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not in */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is not null */
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does not start with (NOT ILIKE value%) */
  notStart?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with all (NOT ILIKE all values%) */
  notStartAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not start with any (NOT ILIKE any value%) */
  notStartAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is null */
  null?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not null and not empty (SQL: col is not null AND col != '') */
  present?: InputMaybe<Scalars['Boolean']['input']>;
  /** Starts with (ILIKE value%) */
  start?: InputMaybe<Scalars['String']['input']>;
  /** Starts with all (ILIKE all values%) */
  startAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Starts with any (ILIKE any value%) */
  startAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** true */
  true?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Form Answer entity */
export type FormAnswer = TimestampInterface & {
  __typename?: 'FormAnswer';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Template Question Field */
  field: FormTemplateQuestionField;
  /** Form Template Question Field ID */
  fieldId: Scalars['ID']['output'];
  /** Form Answer ID */
  id: Scalars['ID']['output'];
  /** Form Template Question Field kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /**
   * Performer entity
   * NOTE: if you only need an Object ID, please use the performerId field to reduce the load on the database.
   */
  performer: Maybe<User>;
  /** Performer ID */
  performerId: Maybe<Scalars['ID']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Template Question description */
  questionDescription: Maybe<Scalars['String']['output']>;
  /** Form Template Question ID */
  questionId: Scalars['ID']['output'];
  /** Form Template Question name */
  questionName: Maybe<Scalars['String']['output']>;
  /** Response object to a Form Answer */
  resp: Array<FormAnswerResp>;
  /** Task Completion ID */
  taskCompletionId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if response is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** Form Answer attributes */
export type FormAnswerCreateInputObject = {
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Form Template Question Field ID */
  fieldId: Scalars['ID']['input'];
  /** Form Template Question ID */
  questionId: Scalars['ID']['input'];
  /** Response object */
  resp?: InputMaybe<Array<FormAnswerRespInputObject>>;
};

/** Response type */
export type FormAnswerResp = {
  __typename?: 'FormAnswerResp';
  /** Group */
  group: Maybe<FormAnswerRespGroupEnum>;
  /** Form Template Question Field Option ID (Row of the checkbox button grid) */
  optionId: Maybe<Scalars['ID']['output']>;
  /** Position */
  position: Maybe<Scalars['Int']['output']>;
  /** Indicates if option is selected */
  selected: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates if option is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Value */
  value: Maybe<Scalars['String']['output']>;
  /** Form Template Question Field Option ID (Column for the checkbox button grid and only for the checkbox button grid) */
  valueId: Maybe<Scalars['ID']['output']>;
};

/** All available form answer response groups */
export enum FormAnswerRespGroupEnum {
  EndDate = 'END_DATE',
  EndTime = 'END_TIME',
  Max = 'MAX',
  Min = 'MIN',
  No = 'NO',
  StartDate = 'START_DATE',
  StartTime = 'START_TIME',
  Yes = 'YES'
}

/** Response object */
export type FormAnswerRespInputObject = {
  /** Group */
  group?: InputMaybe<FormAnswerRespGroupEnum>;
  /** Form Template Question Field Option ID (Row of the checkbox button grid) */
  optionId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates if option is selected */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Form Template Question Field Option ID (Column for the checkbox button grid and only for the checkbox button grid) */
  valueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Form Category entity */
export type FormCategory = TimestampInterface & {
  __typename?: 'FormCategory';
  canDestroy: AuthorizationResult;
  /** Color */
  color: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Templates collection */
  formTemplates: FormTemplateCollection;
  /** Number of form templates */
  formTemplatesCount: Scalars['Int']['output'];
  /** Form Category ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Form Category entity */
export type FormCategoryFormTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** FormCategoryCollection type */
export type FormCategoryCollection = {
  __typename?: 'FormCategoryCollection';
  /** A collection of paginated FormCategoryCollection */
  collection: Array<FormCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryCreateInput = {
  /** Create attributes */
  attributes: FormCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Category attributes */
export type FormCategoryCreateInputObject = {
  /** Color */
  color: Scalars['String']['input'];
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Category ID */
  id: Scalars['ID']['input'];
};

/** Form Category filters */
export type FormCategoryFilterInputObject = {
  /** Form Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Category sorts */
export type FormCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Number of form templates in this category */
  formTemplatesCount?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormCategoryUpdateInput = {
  /** Update attributes */
  attributes: FormCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Category ID */
  id: Scalars['ID']['input'];
};

/** Form Category attributes */
export type FormCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Form Checklist Template entity */
export type FormChecklistTemplate = TimestampInterface & {
  __typename?: 'FormChecklistTemplate';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Form Checklist Template Options collection */
  options: Array<FormChecklistTemplateOption>;
  /** Number of options */
  optionsCount: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** FormChecklistTemplateCollection type */
export type FormChecklistTemplateCollection = {
  __typename?: 'FormChecklistTemplateCollection';
  /** A collection of paginated FormChecklistTemplateCollection */
  collection: Array<FormChecklistTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateCreateInput = {
  /** Create attributes */
  attributes: FormChecklistTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Checklist Template attributes */
export type FormChecklistTemplateCreateInputObject = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Form Checklist Template Options attributes array */
  options: Array<FormChecklistTemplateOptionUpdateInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['input'];
};

/** Form Checklist Template filters */
export type FormChecklistTemplateFilterInputObject = {
  /** Form Checklist Template name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Checklist Template Option entity */
export type FormChecklistTemplateOption = TimestampInterface & {
  __typename?: 'FormChecklistTemplateOption';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Checklist Template Option ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Value */
  value: Scalars['String']['output'];
};

/** Form Checklist Template Option attributes */
export type FormChecklistTemplateOptionUpdateInputObject = {
  /** Form Checklist Template Option ID (to update existing option pass ID. To create new option do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Value */
  value: Scalars['String']['input'];
};

/** Form Checklist Template sorts */
export type FormChecklistTemplateSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of options */
  optionsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormChecklistTemplateUpdateInput = {
  /** Update attributes */
  attributes: FormChecklistTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template ID */
  id: Scalars['ID']['input'];
};

/** Form Checklist Template attributes */
export type FormChecklistTemplateUpdateInputObject = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Form Checklist Template Options attributes array */
  options: Array<FormChecklistTemplateOptionUpdateInputObject>;
};

/** Form Template entity */
export type FormTemplate = TimestampInterface & {
  __typename?: 'FormTemplate';
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchive: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canRestore: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /**
   * Form Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<FormCategory>;
  /** Form Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Latest Form Template Version entity */
  currentVersion: Maybe<FormTemplateVersion>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Form Template ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of versions */
  versionsCount: Scalars['Int']['output'];
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateBulkRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** FormTemplateCollection type */
export type FormTemplateCollection = {
  __typename?: 'FormTemplateCollection';
  /** A collection of paginated FormTemplateCollection */
  collection: Array<FormTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateCreateInput = {
  /** Create attributes */
  attributes: FormTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Form Template attributes */
export type FormTemplateCreateInputObject = {
  /** Form Category ID */
  categoryId: Scalars['ID']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Version */
  version: FormTemplateVersionCuInputObject;
};

/** Form Template filters */
export type FormTemplateFilterInputObject = {
  /** Form Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Form Template name */
  name?: InputMaybe<FilterInputObject>;
};

/** Form Question entity */
export type FormTemplateQuestion = TimestampInterface & {
  __typename?: 'FormTemplateQuestion';
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Related Form Question Fields */
  fields: Array<FormTemplateQuestionField>;
  /** Form Question ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Form Question Field entity */
export type FormTemplateQuestionField = TimestampInterface & {
  __typename?: 'FormTemplateQuestionField';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Question Field ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /** Related Form Question Field Options */
  options: Array<FormTemplateQuestionFieldOption>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Question ID */
  questionId: Scalars['ID']['output'];
  /** Indicates if field is required */
  required: Scalars['Boolean']['output'];
  /** Field settings */
  settings: FormTemplateQuestionFieldSettings;
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Validity hint config
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHintConfig: Array<FormTemplateQuestionFieldValidityHintConfig>;
};

/** Form Question Field Option entity */
export type FormTemplateQuestionFieldOption = TimestampInterface & {
  __typename?: 'FormTemplateQuestionFieldOption';
  /**
   * Condition
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  condition: Maybe<FormTemplateQuestionFieldOptionConditionEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Question Field ID */
  fieldId: Scalars['ID']['output'];
  /** Group */
  group: Maybe<FormTemplateQuestionFieldOptionGroupEnum>;
  /** Form Question Field Option ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Form Question ID */
  questionId: Scalars['ID']['output'];
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if option will have expected result after user input in answers
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Array of values which will be used to validate user input or to display in the form (depends on the kind of the field) */
  values: Array<Scalars['String']['output']>;
};

/** All available form template question field option conditions */
export enum FormTemplateQuestionFieldOptionConditionEnum {
  Between = 'BETWEEN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  NotEqual = 'NOT_EQUAL'
}

/** All available form template question field option groups */
export enum FormTemplateQuestionFieldOptionGroupEnum {
  Columns = 'COLUMNS',
  Max = 'MAX',
  Min = 'MIN',
  No = 'NO',
  Rows = 'ROWS',
  Yes = 'YES'
}

/** Form Question Field Option attributes */
export type FormTemplateQuestionFieldOptionUpdateInputObject = {
  /** Condition */
  condition?: InputMaybe<FormTemplateQuestionFieldOptionConditionEnum>;
  /** Group */
  group?: InputMaybe<FormTemplateQuestionFieldOptionGroupEnum>;
  /** Form Question Field Option ID (to update existing question pass ID. To create new question do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Indicates if option will have expected result after user input in answers */
  validityHint?: InputMaybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
  /** Values */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** All available form template question field option validity hints */
export enum FormTemplateQuestionFieldOptionsValidityHintEnum {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** Field settings */
export type FormTemplateQuestionFieldSettings = {
  __typename?: 'FormTemplateQuestionFieldSettings';
  /** Indicates if field should display last response for the same question */
  allowDisplayLastAnswer: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if field should limit responses to one (currently only for checklist field) */
  limitToOneResp: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per column */
  limitToOneRespPerColumn: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per row */
  limitToOneRespPerRow: Maybe<Scalars['Boolean']['output']>;
};

/** Field settings */
export type FormTemplateQuestionFieldSettingsInputObject = {
  /** Allow display last answer */
  allowDisplayLastAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if field should limit responses to one (currently only for checklist field) */
  limitToOneResp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per column */
  limitToOneRespPerColumn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if checkbox_button_grid field should limit responses to one per row */
  limitToOneRespPerRow?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Form Question Field attributes */
export type FormTemplateQuestionFieldUpdateInputObject = {
  /** Form Question Field ID (to update existing field pass ID. To create new field do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind */
  kind: FormTemplateQuestionFieldsKindEnum;
  /** Form Question Field Options attributes array */
  options?: InputMaybe<Array<FormTemplateQuestionFieldOptionUpdateInputObject>>;
  /** Position */
  position: Scalars['Int']['input'];
  /** Indicates if field is required */
  required: Scalars['Boolean']['input'];
  /** Field settings */
  settings?: InputMaybe<FormTemplateQuestionFieldSettingsInputObject>;
  /** Validity hint config */
  validityHintConfig?: InputMaybe<Array<FormTemplateQuestionFieldValidityHintConfigInputObject>>;
};

/** Validity hint config */
export type FormTemplateQuestionFieldValidityHintConfig = {
  __typename?: 'FormTemplateQuestionFieldValidityHintConfig';
  /** Option positions */
  optionPositions: Array<Scalars['Int']['output']>;
  /** Validity hint */
  validityHint: FormTemplateQuestionFieldOptionsValidityHintEnum;
};

/** Validity hint config */
export type FormTemplateQuestionFieldValidityHintConfigInputObject = {
  /** Option positions */
  optionPositions: Array<Scalars['Int']['input']>;
  /** Validity hint */
  validityHint?: InputMaybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** Available form template question field kinds */
export enum FormTemplateQuestionFieldsKindEnum {
  /** Attachment */
  Attachment = 'ATTACHMENT',
  /** Multi select */
  Checkbox = 'CHECKBOX',
  /** Checkbox grid in table */
  CheckboxButtonGrid = 'CHECKBOX_BUTTON_GRID',
  /** Checklist */
  Checklist = 'CHECKLIST',
  /** Date */
  Date = 'DATE',
  /** Date and time */
  Datetime = 'DATETIME',
  /** Date range */
  DateRange = 'DATE_RANGE',
  /** Decision box */
  DecisionBox = 'DECISION_BOX',
  /** Important notice */
  ImportantNotice = 'IMPORTANT_NOTICE',
  /** Single line text */
  Input = 'INPUT',
  /** Numeric range */
  MinMax = 'MIN_MAX',
  /** Numeric */
  NumberInput = 'NUMBER_INPUT',
  /** Single select */
  RadioButton = 'RADIO_BUTTON',
  /** Rating */
  Rating = 'RATING',
  /** Section */
  Section = 'SECTION',
  /** Dropdown */
  SingleSelect = 'SINGLE_SELECT',
  /** Multi line text */
  TextArea = 'TEXT_AREA',
  /** Time */
  Time = 'TIME',
  /** Time range */
  TimeRange = 'TIME_RANGE',
  /** Yes/no */
  YesNo = 'YES_NO'
}

/** Form Question attributes */
export type FormTemplateQuestionUpdateInputObject = {
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Form Question Fields attributes array */
  fields: Array<FormTemplateQuestionFieldUpdateInputObject>;
  /** Form Question ID (to update existing question pass ID. To create new question do not pass ID) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position */
  position: Scalars['Int']['input'];
};

/** Available form template scope names */
export enum FormTemplateScopeNameEnum {
  /** Active form templates */
  Active = 'ACTIVE',
  /** Archived form templates */
  Archived = 'ARCHIVED'
}

/** Form Template sorts */
export type FormTemplateSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Form Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of versions */
  versionsCount?: InputMaybe<SortDirectionEnum>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateUpdateInput = {
  /** Update attributes */
  attributes: FormTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  id: Scalars['ID']['input'];
};

/** Form Template attributes */
export type FormTemplateUpdateInputObject = {
  /** Form Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Form Template Version entity */
export type FormTemplateVersion = TimestampInterface & {
  __typename?: 'FormTemplateVersion';
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchive: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canRestore: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Form Template ID */
  id: Scalars['ID']['output'];
  /** Related Form Questions */
  questions: Array<FormTemplateQuestion>;
  /** Status (Virtual field) */
  status: FormTemplateVersionStatusEnum;
  /** Form Template ID */
  templateId: Scalars['ID']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Version */
  version: Maybe<Scalars['String']['output']>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount: Scalars['Int']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** FormTemplateVersionCollection type */
export type FormTemplateVersionCollection = {
  __typename?: 'FormTemplateVersionCollection';
  /** A collection of paginated FormTemplateVersionCollection */
  collection: Array<FormTemplateVersion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionCreateInput = {
  /** Create attributes */
  attributes: FormTemplateVersionCuInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
};

/** Form Template Version attributes */
export type FormTemplateVersionCuInputObject = {
  /** Form Template Questions attributes array */
  questions: Array<FormTemplateQuestionUpdateInputObject>;
  /** Task IDs to link */
  taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Form Template Version filters */
export type FormTemplateVersionFilterInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<FilterDateInputObject>;
  /** Version */
  version?: InputMaybe<FilterIntInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionRestoreInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Form Template Version sorts */
export type FormTemplateVersionSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Version */
  version?: InputMaybe<SortDirectionEnum>;
  /** Number of visible linked tasks for current user */
  visibleLinkedTasksCount?: InputMaybe<SortDirectionEnum>;
};

/** Available form template version statuses */
export enum FormTemplateVersionStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Unused = 'UNUSED'
}

/** Description from base input object. Please set your description for child object. */
export type FormTemplateVersionUpdateInput = {
  /** Update attributes */
  attributes: FormTemplateVersionCuInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Form Template ID */
  formTemplateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  id: Scalars['ID']['input'];
};

/** Country */
export type GeoCountry = {
  __typename?: 'GeoCountry';
  /** Country code */
  code: Scalars['String']['output'];
  /** Country name */
  name: Scalars['String']['output'];
};

/** GeoJSON Feature entity */
export type GeojsonFeature = {
  __typename?: 'GeojsonFeature';
  /** Feature geometry */
  geometry: GeojsonGeometry;
  /** Feature properties */
  properties: Maybe<GeojsonProperties>;
  /** Feature type */
  type: GeojsonFeatureTypeEnum;
};

/** GeoJSON Feature Collection entity */
export type GeojsonFeatureCollection = {
  __typename?: 'GeojsonFeatureCollection';
  /** Features collection */
  features: Array<GeojsonFeature>;
  /** Feature Collection type */
  type: GeojsonFeatureCollectionTypeEnum;
};

/** GeoJSON Feature Collection input */
export type GeojsonFeatureCollectionInputObject = {
  /** Features collection */
  features: Array<GeojsonFeatureInputObject>;
  /** Feature Collection type */
  type: GeojsonFeatureCollectionTypeEnum;
};

/** Available GeoJSON feature collection types */
export enum GeojsonFeatureCollectionTypeEnum {
  /** Feature Collection */
  FeatureCollection = 'FeatureCollection'
}

/** GeoJSON Feature input */
export type GeojsonFeatureInputObject = {
  /** Feature geometry */
  geometry: GeojsonGeometryInputObject;
  /** Feature properties */
  properties?: InputMaybe<GeojsonPropertiesInputObject>;
  /** Feature type */
  type: GeojsonFeatureTypeEnum;
};

/** Available GeoJSON feature types */
export enum GeojsonFeatureTypeEnum {
  /** Feature */
  Feature = 'Feature'
}

/** GeoJSON Geometry entity */
export type GeojsonGeometry = {
  __typename?: 'GeojsonGeometry';
  /** Geometry coordinates (Point, Polygon); Point -> [longitude, latitude]; Polygon -> [[[longitude, latitude], ...], ...]; */
  coordinates: Scalars['JSON']['output'];
  /** Geometry type */
  type: GeojsonGeometryTypeEnum;
};

/** GeoJSON Geometry input */
export type GeojsonGeometryInputObject = {
  /** Geometry coordinates (Point, Polygon); Point -> [longitude, latitude]; Polygon -> [[[longitude, latitude], ...], ...]; */
  coordinates: Scalars['JSON']['input'];
  /** Geometry type */
  type: GeojsonGeometryTypeEnum;
};

/** Available GeoJSON geometry types */
export enum GeojsonGeometryTypeEnum {
  /** Point */
  Point = 'Point',
  /** Polygon */
  Polygon = 'Polygon'
}

/** GeoJSON Properties entity */
export type GeojsonProperties = {
  __typename?: 'GeojsonProperties';
  /** Address (exact address that syncs with the coordinates) */
  address: Maybe<Scalars['String']['output']>;
  /** Address details (any other details, for example, a building name, a floor number, etc.) */
  addressDetails: Maybe<Scalars['String']['output']>;
  /** Color */
  color: Maybe<Scalars['String']['output']>;
  /** Icon */
  icon: Maybe<Scalars['String']['output']>;
  /** ID (must be used by FE to recognize the same object on the map if it is returned multiple times during multiple requests) */
  id: Maybe<Scalars['String']['output']>;
  /** Point count (number of points in the cluster) */
  pointCount: Maybe<Scalars['Int']['output']>;
  /** Shape */
  shape: Maybe<Scalars['String']['output']>;
  /** Sourceables Collection. A set of unique object classes and identifiers associated with the cluster. This indicates that the cluster contains defined locations for each of these objects. */
  sourceables: Maybe<Array<GeojsonPropertiesPolymorphicIdentity>>;
  /** Type (cluster, polygon, point, line, etc.). Must be used by FE to identify the type of the feature and to render it correctly. */
  type: Maybe<GeojsonPropertiesTypeEnum>;
};

/** GeoJSON Properties input */
export type GeojsonPropertiesInputObject = {
  /** Address (exact address that syncs with the coordinates) */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Address details (any other details, for example, a building name, a floor number, etc.) */
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Shape */
  shape?: InputMaybe<Scalars['String']['input']>;
};

/** Polymorphic identity entity */
export type GeojsonPropertiesPolymorphicIdentity = {
  __typename?: 'GeojsonPropertiesPolymorphicIdentity';
  /** ID */
  id: Scalars['ID']['output'];
  /** Type (Class name) */
  type: GeojsonPropertiesPolymorphicIdentityTypeEnum;
};

/** Available GeoJSON properties polymorphic identity types */
export enum GeojsonPropertiesPolymorphicIdentityTypeEnum {
  /** Sector */
  Sector = 'SECTOR',
  /** Site */
  Site = 'SITE'
}

/** Available GeoJSON properties types */
export enum GeojsonPropertiesTypeEnum {
  /** Cluster */
  Cluster = 'CLUSTER',
  /** Line */
  Line = 'LINE',
  /** Point */
  Point = 'POINT',
  /** Polygon */
  Polygon = 'POLYGON'
}

/** History entity */
export type History = {
  __typename?: 'History';
  /** Diff data */
  data: Maybe<HistoryDataUnion>;
  /** History ID */
  id: Scalars['ID']['output'];
  /** Kind of operation */
  kind: HistoryKindEnum;
  /** Metadata */
  metadata: Maybe<HistoryMetadataUnion>;
  /** Occurred at (actual time when a record was created/updated/etc.) */
  occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if operation was done by the Datizy system */
  system: Maybe<Scalars['Boolean']['output']>;
  /**
   * User entity who made the operation
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** User ID who made the operation */
  userId: Maybe<Scalars['ID']['output']>;
};

/** HistoryCollection type */
export type HistoryCollection = {
  __typename?: 'HistoryCollection';
  /** A collection of paginated HistoryCollection */
  collection: Array<History>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** History data */
export type HistoryDataUnion = InterventionActionHistoryData;

/** Available intervention action history metadata reasons */
export enum HistoryInterventionActionHistoryMetadataReasonEnum {
  /** When intervention was closed */
  InterventionClosed = 'INTERVENTION_CLOSED'
}

/** Available history kinds */
export enum HistoryKindEnum {
  /** Created action */
  Created = 'CREATED',
  /** Updated action */
  Updated = 'UPDATED'
}

/** History metadata */
export type HistoryMetadataUnion = InterventionActionHistoryMetadata;

/** History sorts */
export type HistorySortInputObject = {
  /** Occurred at (actual time when a record was created/updated/etc.) */
  occurredAt?: InputMaybe<SortDirectionEnum>;
};

/** Available source types */
export enum HistorySourceableTypeEnum {
  /** Intervention Action entity */
  InterventionAction = 'INTERVENTION_ACTION'
}

/** Home Page entity */
export type HomePage = TimestampInterface & {
  __typename?: 'HomePage';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Home Page ID */
  id: Scalars['ID']['output'];
  /** Indicates if Home Page is default */
  isDefault: Scalars['Boolean']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Position */
  position: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID */
  userId: Maybe<Scalars['ID']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type HomePageBulkUpdateInput = {
  /** Update attributes */
  attributes: Array<HomePageUpdateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** HomePageCollection type */
export type HomePageCollection = {
  __typename?: 'HomePageCollection';
  /** A collection of paginated HomePageCollection */
  collection: Array<HomePage>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Home Page attributes */
export type HomePageUpdateInputObject = {
  /** Destroy home page (if true, home page will be destroyed) */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Industry entity */
export type Industry = TimestampInterface & {
  __typename?: 'Industry';
  /** Color */
  color: Scalars['String']['output'];
  /** Companies */
  companies: CompanyCollection;
  /** Number of companies in this industry */
  companiesCount: Scalars['Int']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Industry ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Industry entity */
export type IndustryCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** IndustryCollection type */
export type IndustryCollection = {
  __typename?: 'IndustryCollection';
  /** A collection of paginated IndustryCollection */
  collection: Array<Industry>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type IndustryCreateInput = {
  /** Create attributes */
  attributes: IndustryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Industry attributes */
export type IndustryCreateInputObject = {
  /** Color */
  color: Scalars['String']['input'];
  /** Companies attributes array */
  companies?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type IndustryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  id: Scalars['ID']['input'];
};

/** Industry filters */
export type IndustryFilterInputObject = {
  /** Industry name */
  name?: InputMaybe<FilterInputObject>;
};

/** Industry sorts */
export type IndustrySortInputObject = {
  /** Number of companies in this industry */
  companiesCount?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type IndustryUpdateInput = {
  /** Update attributes */
  attributes: IndustryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Industry ID */
  id: Scalars['ID']['input'];
};

/** Industry attributes */
export type IndustryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Companies attributes array */
  companies?: InputMaybe<Array<LinkingInputObject>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention entity */
export type Intervention = TimestampInterface & {
  __typename?: 'Intervention';
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Maybe<Asset>;
  /** Asset ID */
  assetId: Maybe<Scalars['ID']['output']>;
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  canClose: AuthorizationResult;
  canCreate: AuthorizationResult;
  canCreateAction: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /**
   * Intervention Category entity
   * NOTE: if you only need an Object ID, please use the categoryId field to reduce the load on the database.
   */
  category: Maybe<InterventionCategory>;
  /** Intervention Category ID */
  categoryId: Maybe<Scalars['ID']['output']>;
  /** Closed date */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Duration time (in minutes) */
  durationTime: Maybe<Scalars['Int']['output']>;
  /** Estimated date */
  estimatedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Scalars['Int']['output']>;
  /** Intervention ID */
  id: Scalars['ID']['output'];
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Priority */
  priority: InterventionPriorityEnum;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Status */
  status: InterventionStatusEnum;
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the supervisorId field to reduce the load on the database.
   */
  supervisor: Maybe<User>;
  /** User ID */
  supervisorId: Maybe<Scalars['ID']['output']>;
  /**
   * Task entity
   * NOTE: if you only need an Object ID, please use the taskId field to reduce the load on the database.
   */
  task: Maybe<Task>;
  /** Key to group the same tasks which are recurring or have been recurred (if recurring rule was deleted in some point) */
  taskGroupKey: Maybe<Scalars['ID']['output']>;
  /** Task ID */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Total duration time (in minutes) (intervention.duration_time + SUM(intervention_actions.duration_time)) */
  totalDurationTime: Maybe<Scalars['Int']['output']>;
  /** Total estimated time (in minutes) (intervention.estimated_time + SUM(intervention_actions.estimated_time)) */
  totalEstimatedTime: Maybe<Scalars['Int']['output']>;
  /** Total logistic time (in minutes) (intervention.logistic_time + SUM(intervention_actions.logistic_time)) */
  totalLogisticTime: Maybe<Scalars['Int']['output']>;
  /** Total duration time + Total logistic time */
  totalTime: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Intervention Action entity */
export type InterventionAction = TimestampInterface & {
  __typename?: 'InterventionAction';
  /** Related Attachments */
  attachmentsAttached: Array<Attachment>;
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Closed date */
  closedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the createdById field to reduce the load on the database.
   */
  createdBy: Maybe<User>;
  /** User ID */
  createdById: Maybe<Scalars['ID']['output']>;
  /** Duration time (in minutes) */
  durationTime: Maybe<Scalars['Int']['output']>;
  /** Estimated date */
  estimatedDate: Maybe<Scalars['ISO8601Date']['output']>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Scalars['Int']['output']>;
  /** Intervention Action ID */
  id: Scalars['ID']['output'];
  /** Intervention ID */
  interventionId: Maybe<Scalars['ID']['output']>;
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: InterventionActionStatusEnum;
  /** Test */
  text: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** InterventionActionCollection type */
export type InterventionActionCollection = {
  __typename?: 'InterventionActionCollection';
  /** A collection of paginated InterventionActionCollection */
  collection: Array<InterventionAction>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionActionCreateInput = {
  /**  Link to open the intervention action from notification. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Create attributes */
  attributes: InterventionActionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create attributes */
  interventionId: Scalars['ID']['input'];
  /**  Link to open the intervention action from notification where user was mentioned. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  mentionRedirectUrl: Scalars['String']['input'];
};

/** Intervention action attributes */
export type InterventionActionCreateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status: InterventionActionStatusEnum;
  /** Text */
  text: Scalars['String']['input'];
  /** Mentions attributes array for text field */
  textMentions?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionActionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Action ID */
  id: Scalars['ID']['input'];
  /** Intervention ID */
  interventionId: Scalars['ID']['input'];
};

/** Intervention Action filters */
export type InterventionActionFilterInputObject = {
  /** Assignee users */
  assigneeUsersId?: InputMaybe<FilterIdInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user */
  createdById?: InputMaybe<FilterIdInputObject>;
  /** Mentioned users in text field */
  textMentionsUsersId?: InputMaybe<FilterIdInputObject>;
};

/** Intervention Action entity */
export type InterventionActionHistoryData = {
  __typename?: 'InterventionActionHistoryData';
  /** Duration time (in minutes) */
  durationTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Estimated date */
  estimatedDate: Maybe<Array<Maybe<Scalars['ISO8601Date']['output']>>>;
  /** Estimated time (in minutes) */
  estimatedTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Logistic time (in minutes) */
  logisticTime: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Status */
  status: Maybe<Array<InterventionActionStatusEnum>>;
};

/** Intervention Action History Metadata entity */
export type InterventionActionHistoryMetadata = {
  __typename?: 'InterventionActionHistoryMetadata';
  /** Reason */
  reason: Maybe<HistoryInterventionActionHistoryMetadataReasonEnum>;
};

/** Intervention Action sorts */
export type InterventionActionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
};

/** Available intervention action statuses */
export enum InterventionActionStatusEnum {
  ClassifiedSatsContinued = 'CLASSIFIED_SATS_CONTINUED',
  Closed = 'CLOSED',
  InCheck = 'IN_CHECK',
  InProgress = 'IN_PROGRESS',
  MaterialOrdered = 'MATERIAL_ORDERED',
  MaterialReceived = 'MATERIAL_RECEIVED',
  Planned = 'PLANNED'
}

/** Description from base input object. Please set your description for child object. */
export type InterventionActionUpdateInput = {
  /**  Link to open the intervention action from notification. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Update attributes */
  attributes: InterventionActionUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Action ID */
  id: Scalars['ID']['input'];
  /** Intervention ID */
  interventionId: Scalars['ID']['input'];
  /**  Link to open the intervention action from notification where user was mentioned. Supported variables: `interventionId` and `interventionActionId`. Example: `https://admin.datizy.com/interventions/:interventionId/:interventionActionId`  */
  mentionRedirectUrl: Scalars['String']['input'];
};

/** Intervention action attributes */
export type InterventionActionUpdateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Status */
  status?: InputMaybe<InterventionActionStatusEnum>;
  /** Text */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Mentions attributes array for text field */
  textMentions?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionBulkCloseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Intervention Category entity */
export type InterventionCategory = TimestampInterface & {
  __typename?: 'InterventionCategory';
  canDestroy: AuthorizationResult;
  /** Color */
  color: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Intervention Category ID */
  id: Scalars['ID']['output'];
  /** Intervention collection */
  interventions: InterventionCollection;
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Number of visible Interventions */
  visibleInterventionsCount: Scalars['Int']['output'];
};


/** Intervention Category entity */
export type InterventionCategoryInterventionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** InterventionCategoryCollection type */
export type InterventionCategoryCollection = {
  __typename?: 'InterventionCategoryCollection';
  /** A collection of paginated InterventionCategoryCollection */
  collection: Array<InterventionCategory>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryCreateInput = {
  /** Create attributes */
  attributes: InterventionCategoryCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention Category attributes */
export type InterventionCategoryCreateInputObject = {
  /** Color */
  color: Scalars['String']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Category ID */
  id: Scalars['ID']['input'];
};

/** Intervention Category filters */
export type InterventionCategoryFilterInputObject = {
  /** Intervention ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category name */
  name?: InputMaybe<FilterInputObject>;
};

/** Intervention Category sorts */
export type InterventionCategorySortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Number of visible Interventions in this category */
  visibleInterventionsCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCategoryUpdateInput = {
  /** Update attributes */
  attributes: InterventionCategoryUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention Category ID */
  id: Scalars['ID']['input'];
};

/** Intervention Category attributes */
export type InterventionCategoryUpdateInputObject = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** InterventionCollection type */
export type InterventionCollection = {
  __typename?: 'InterventionCollection';
  /** A collection of paginated InterventionCollection */
  collection: Array<Intervention>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionCreateInput = {
  /**  Link to open the intervention from notification. Supported variables: `interventionId`. Example: `https://admin.datizy.com/interventions/:interventionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Create attributes */
  attributes: InterventionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Intervention attributes */
export type InterventionCreateInputObject = {
  /** Asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Intervention Category ID */
  categoryId: Scalars['ID']['input'];
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description: Scalars['String']['input'];
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Priority */
  priority: InterventionPriorityEnum;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Site ID */
  siteId: Scalars['ID']['input'];
  /** Status */
  status: InterventionStatusEnum;
  /** User ID */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  /** Task ID */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type InterventionDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention ID */
  id: Scalars['ID']['input'];
};

/** Intervention filters */
export type InterventionFilterInputObject = {
  /** Asset code */
  assetCode?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  assetId?: InputMaybe<FilterIdInputObject>;
  /** Asset name */
  assetName?: InputMaybe<FilterInputObject>;
  /** Asset QR prefix */
  assetQrPrefix?: InputMaybe<FilterInputObject>;
  /** Assignee users */
  assigneeUsersId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category ID */
  categoryId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Category name */
  categoryName?: InputMaybe<FilterInputObject>;
  /** Code */
  code?: InputMaybe<FilterInputObject>;
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /** Created by user */
  createdById?: InputMaybe<FilterIdInputObject>;
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Priority */
  priority?: InputMaybe<FilterIntInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Status */
  status?: InputMaybe<FilterIntInputObject>;
  /** Task group key */
  taskGroupKey?: InputMaybe<FilterIdInputObject>;
};

/** Available intervention priorities */
export enum InterventionPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Available intervention scope names */
export enum InterventionScopeNameEnum {
  /** All */
  All = 'ALL',
  /** Closed interventions */
  Closed = 'CLOSED',
  /** Opened interventions */
  Opened = 'OPENED',
  /** Opened interventions where user is participant (creator, supervisor, assignee, action creator, action assignee or mentioned in comments) */
  OpenedMyParticipation = 'OPENED_MY_PARTICIPATION'
}

/** Intervention sorts */
export type InterventionSortInputObject = {
  /** Asset name */
  assetName?: InputMaybe<SortDirectionEnum>;
  /** Intervention Category name */
  categoryName?: InputMaybe<SortDirectionEnum>;
  /** Closed at */
  closedAt?: InputMaybe<SortDirectionEnum>;
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Priority */
  priority?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Available intervention statuses */
export enum InterventionStatusEnum {
  ClassifiedSatsContinued = 'CLASSIFIED_SATS_CONTINUED',
  Closed = 'CLOSED',
  InCheck = 'IN_CHECK',
  InProgress = 'IN_PROGRESS',
  MaterialOrdered = 'MATERIAL_ORDERED',
  MaterialReceived = 'MATERIAL_RECEIVED',
  Planned = 'PLANNED'
}

/** Description from base input object. Please set your description for child object. */
export type InterventionUpdateInput = {
  /**  Link to open the intervention from notification. Supported variables: `interventionId`. Example: `https://admin.datizy.com/interventions/:interventionId`  */
  assigneeRedirectUrl: Scalars['String']['input'];
  /** Update attributes */
  attributes: InterventionUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Intervention ID */
  id: Scalars['ID']['input'];
};

/** Intervention attributes */
export type InterventionUpdateInputObject = {
  /** Assignees attributes array */
  assignees?: InputMaybe<Array<LinkingInputObject>>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Intervention Category ID */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Duration time (in minutes) */
  durationTime?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated date */
  estimatedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Estimated time (in minutes) */
  estimatedTime?: InputMaybe<Scalars['Int']['input']>;
  /** Logistic time (in minutes) */
  logisticTime?: InputMaybe<Scalars['Int']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Priority */
  priority?: InputMaybe<InterventionPriorityEnum>;
  /** Status */
  status?: InputMaybe<InterventionStatusEnum>;
  /** User ID */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Job entity */
export type Job = {
  __typename?: 'Job';
  /** Number of the object currently being processed */
  at: Maybe<Scalars['Int']['output']>;
  canCancel: AuthorizationResult;
  canCreateDeliveryRequest: AuthorizationResult;
  canRetry: AuthorizationResult;
  /** Indicates if delivery request was requested */
  deliveryRequest: Maybe<Scalars['Boolean']['output']>;
  /** Estimated time of completion (in seconds) */
  eta: Maybe<Scalars['Float']['output']>;
  /** Job ID */
  jid: Maybe<Scalars['String']['output']>;
  /** Worker kind */
  kind: Maybe<JobKindEnum>;
  /** Current progress message */
  message: Maybe<Scalars['String']['output']>;
  /** Payload */
  payload: Maybe<Scalars['JSON']['output']>;
  /** Percentage of completion */
  pctComplete: Maybe<Scalars['Int']['output']>;
  /** Status */
  status: Maybe<JobStatusEnum>;
  /** Indicates if stop was requested */
  stop: Maybe<Scalars['Boolean']['output']>;
  /** Total number of objects to be processed */
  total: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updateTime: Maybe<Scalars['Int']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type JobCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Job ID */
  jid: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type JobCreateDeliveryRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Job ID */
  jid: Scalars['String']['input'];
};

/** Available job kinds */
export enum JobKindEnum {
  /** Data import */
  DataImport = 'DATA_IMPORT',
  /** QR code generation */
  QrCodeGeneration = 'QR_CODE_GENERATION',
  /** Timeline report generation */
  TimelineReportGeneration = 'TIMELINE_REPORT_GENERATION'
}

/** Description from base input object. Please set your description for child object. */
export type JobRetryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Job ID */
  jid: Scalars['String']['input'];
};

/** Available job statuses */
export enum JobStatusEnum {
  /** Completed successfully */
  Complete = 'COMPLETE',
  /** Failed (after all retries) */
  Failed = 'FAILED',
  /** Interrupted */
  Interrupted = 'INTERRUPTED',
  /** Queued (waiting to be processed) */
  Queued = 'QUEUED',
  /** Retrying again (after failure) */
  Retrying = 'RETRYING',
  /** Stopped */
  Stopped = 'STOPPED',
  /** Work in progress */
  Working = 'WORKING'
}

/** Available languages */
export enum LanguageEnum {
  /** English */
  En = 'en',
  /** Spanish */
  Es = 'es',
  /** French */
  Fr = 'fr',
  /** Polish */
  Pl = 'pl',
  /** Romanian */
  Ro = 'ro',
  /** Ukrainian */
  Uk = 'uk'
}

/** Linking attributes */
export type LinkingInputObject = {
  /** Entity ID */
  id: Scalars['ID']['input'];
  /** Unlink entity */
  unlink?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Location entity */
export type Location = TimestampInterface & {
  __typename?: 'Location';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** GeoJSON */
  geojson: Maybe<GeojsonFeatureCollection>;
  /** Location ID */
  id: Scalars['ID']['output'];
  /** Kind */
  kind: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Location attributes */
export type LocationCuInputObject = {
  /** GeoJSON */
  geojson?: InputMaybe<GeojsonFeatureCollectionInputObject>;
};

/** Location filters */
export type LocationFilterInputObject = {
  /** Location kind (site location => point; sector location => boundary) */
  kind?: InputMaybe<FilterInputObject>;
};

/** Location geographical center entity */
export type LocationGeographicalCenter = {
  __typename?: 'LocationGeographicalCenter';
  /** Latitude */
  lat: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  lon: Maybe<Scalars['Float']['output']>;
};

/** Location Map Params input (current visible area on map) */
export type LocationMapParamsInputObject = {
  /** Maximum latitude */
  maxLat: Scalars['Float']['input'];
  /** Maximum longitude */
  maxLon: Scalars['Float']['input'];
  /** Minimum latitude */
  minLat: Scalars['Float']['input'];
  /** Minimum longitude */
  minLon: Scalars['Float']['input'];
  /** Zoom level */
  zoom: Scalars['Int']['input'];
};

/** List of mutations */
export type Mutation = {
  __typename?: 'Mutation';
  /** Create an ApiToken */
  apiTokenCreate: Maybe<ApiToken>;
  /** Destroy an ApiToken */
  apiTokenDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an ApiToken */
  apiTokenUpdate: Maybe<ApiToken>;
  /** Bulk destroy Assets */
  assetBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Assets in bulk */
  assetBulkQrCodeCreate: Maybe<Job>;
  /** Create an Asset Category */
  assetCategoryCreate: Maybe<AssetCategory>;
  /** Destroy an Asset Category */
  assetCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Asset Category */
  assetCategoryUpdate: Maybe<AssetCategory>;
  /** Create an Asset */
  assetCreate: Maybe<Asset>;
  /** Update an Asset */
  assetUpdate: Maybe<Asset>;
  /** Confirm email changing by token */
  authenticationConfirmationsEmailConfirmation: Whoami;
  /** Confirm registration by token */
  authenticationConfirmationsRegistrationConfirmation: Whoami;
  /** Resend email confirmation email */
  authenticationConfirmationsResendEmailConfirmation: ResponseMessage;
  /** Resend registration confirmation */
  authenticationConfirmationsResendRegistrationConfirmation: ResponseMessage;
  /** Complete password setup for newly created accounts */
  authenticationPasswordSetup: Scalars['Boolean']['output'];
  /** Send password reset instructions */
  authenticationPasswordsForgot: ResponseMessage;
  /** Reset password by token */
  authenticationPasswordsReset: Whoami;
  /** Change or set password. Requires session older than 24 hours and step-up 2FA verification (30-min window). Users with an existing password must provide password_challenge. SSO users without a password can set one without providing password_challenge. */
  authenticationPasswordsUpdate: Whoami;
  /** Resend account locked email */
  authenticationResendAccountLockedEmail: ResponseMessage;
  /** Resend account locked email to another system admin. Requires session older than 24 hours. */
  authenticationResendAccountLockedEmailForAdmin: Scalars['Boolean']['output'];
  /** Restore a locked account by token from email */
  authenticationRestoreAccount: Whoami;
  /** Create a session (aka Login) */
  authenticationSessionCreate: Whoami;
  /** End current session (aka Logout) */
  authenticationSessionEnd: Maybe<Scalars['Boolean']['output']>;
  /** End all sessions for the current user. Requires session older than 24 hours. */
  authenticationSessionEndAll: Scalars['Boolean']['output'];
  /** End a specific session by ID. Requires session older than 24 hours. */
  authenticationSessionEndSpecific: Scalars['Boolean']['output'];
  /** Report current session as suspicious and end all other sessions. Requires session older than 24 hours and step-up 2FA verification (30-min window). */
  authenticationSessionReportSuspicious: Scalars['Boolean']['output'];
  /** Report session as suspicious by token from email */
  authenticationSessionReportSuspiciousByToken: Scalars['Boolean']['output'];
  /** Disable email-based two-factor authentication method. Requires session older than 24 hours. */
  authenticationTwoFactorDisableEmailOtp: Scalars['Boolean']['output'];
  /** Disable TOTP (authenticator app) two-factor authentication method. Requires session older than 24 hours. */
  authenticationTwoFactorDisableTotp: Scalars['Boolean']['output'];
  /** Enable email-based two-factor authentication by verifying code from email. Requires session older than 24 hours. */
  authenticationTwoFactorEnableEmailOtp: TwoFactorSetupResult;
  /** Enable TOTP by verifying code from authenticator app. Requires session older than 24 hours. */
  authenticationTwoFactorEnableTotp: TwoFactorSetupResult;
  /** Generate new backup codes for two-factor authentication. Requires session older than 24 hours and fresh 2FA verification on every call. */
  authenticationTwoFactorGenerateBackupCodes: TwoFactorBackupCodes;
  /** Resend email OTP code */
  authenticationTwoFactorResendEmailOtp: Scalars['Boolean']['output'];
  /** Reset two-factor authentication for another admin. Requires session older than 24 hours and fresh 2FA verification on every call. */
  authenticationTwoFactorReset: Scalars['Boolean']['output'];
  /** Setup email OTP for two-factor authentication by sending verification code. Requires session older than 24 hours. Fresh 2FA verification required when adding second method. */
  authenticationTwoFactorSetupEmailOtp: Scalars['Boolean']['output'];
  /** Setup TOTP (authenticator app) for two-factor authentication. Requires session older than 24 hours. Fresh 2FA verification required when adding second method. */
  authenticationTwoFactorSetupTotp: TwoFactorTotpSetup;
  /** Verify two-factor authentication code during login */
  authenticationTwoFactorVerify: Whoami;
  /** Create a Company */
  companyCreate: Maybe<Company>;
  /** Destroy a Company. Requires session older than 24 hours and fresh 2FA verification on every call. */
  companyDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create a Company Domain */
  companyDomainCreate: Maybe<CompanyDomain>;
  /** Destroy a Company Domain */
  companyDomainDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Verify a Company Domain via DNS TXT record */
  companyDomainVerify: Maybe<CompanyDomain>;
  /** Plan change request */
  companyPlanChangeRequest: Maybe<Scalars['Boolean']['output']>;
  /** Update a Company */
  companyUpdate: Maybe<Company>;
  /** Bulk Destroy Counters */
  counterBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Counter in bulk */
  counterBulkQrCodeCreate: Maybe<Job>;
  /** Create a Counter */
  counterCreate: Maybe<Counter>;
  /** Create a Counter Measure */
  counterMeasureCreate: Maybe<CounterMeasure>;
  /** Reset to zero a Counter */
  counterResetToZero: Maybe<Counter>;
  /** Update a Counter */
  counterUpdate: Maybe<Counter>;
  /** Create a Data Import */
  dataImportCreate: Maybe<DataImport>;
  /** Destroy a Data Import */
  dataImportDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Data Import */
  dataImportUpdate: Maybe<DataImport>;
  /** Create a Documentation in bulk */
  documentationBulkCreate: Maybe<Scalars['Boolean']['output']>;
  /** Bulk Destroy Documentations */
  documentationBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Documentation */
  documentationUpdate: Maybe<Documentation>;
  /** Create a fake DNS record (non-production only) */
  fakeDnsRecordCreate: Maybe<FakeDnsRecord>;
  /** Destroy a fake DNS record (non-production only) */
  fakeDnsRecordDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a fake DNS record (non-production only) */
  fakeDnsRecordUpdate: Maybe<FakeDnsRecord>;
  /** Create a Frontend Filter Preset */
  feFilterPresetCreate: Maybe<FeFilterPreset>;
  /** Destroy a Frontend Filter Preset */
  feFilterPresetDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Frontend Filter Preset */
  feFilterPresetUpdate: Maybe<FeFilterPreset>;
  /** Create a Form Category */
  formCategoryCreate: Maybe<FormCategory>;
  /** Destroy a Form Category */
  formCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Category */
  formCategoryUpdate: Maybe<FormCategory>;
  /** Create a Form Checklist Template */
  formChecklistTemplateCreate: Maybe<FormChecklistTemplate>;
  /** Destroy a Form Checklist Template */
  formChecklistTemplateDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Form Checklist Template */
  formChecklistTemplateUpdate: Maybe<FormChecklistTemplate>;
  /** Bulk archive Form Templates */
  formTemplateBulkArchive: Maybe<Scalars['Boolean']['output']>;
  /** Bulk destroy Form Templates */
  formTemplateBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Bulk restore Form Templates */
  formTemplateBulkRestore: Maybe<Scalars['Boolean']['output']>;
  /** Create a Form Template */
  formTemplateCreate: Maybe<FormTemplate>;
  /** Update a Form Template */
  formTemplateUpdate: Maybe<FormTemplate>;
  /** Archive a Form Template Version */
  formTemplateVersionArchive: Maybe<FormTemplateVersion>;
  /** Create a Form Template Version */
  formTemplateVersionCreate: Maybe<FormTemplateVersion>;
  /** Destroy a Form Template Version */
  formTemplateVersionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Restore a Form Template Version */
  formTemplateVersionRestore: Maybe<FormTemplateVersion>;
  /** Update a Form Template Version */
  formTemplateVersionUpdate: Maybe<FormTemplateVersion>;
  /** Bulk update Home Pages */
  homePageBulkUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Create an Industry */
  industryCreate: Maybe<Industry>;
  /** Destroy an Industry */
  industryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Industry */
  industryUpdate: Maybe<Industry>;
  /** Create an Intervention Action */
  interventionActionCreate: Maybe<InterventionAction>;
  /** Destroy an Intervention Action */
  interventionActionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention Action */
  interventionActionUpdate: Maybe<InterventionAction>;
  /** Bulk close Interventions */
  interventionBulkClose: Maybe<Scalars['Boolean']['output']>;
  /** Create an Intervention Category */
  interventionCategoryCreate: Maybe<InterventionCategory>;
  /** Destroy an Intervention Category */
  interventionCategoryDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention Category */
  interventionCategoryUpdate: Maybe<InterventionCategory>;
  /** Create an Intervention */
  interventionCreate: Maybe<Intervention>;
  /** Destroy an Intervention */
  interventionDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an Intervention */
  interventionUpdate: Maybe<Intervention>;
  /** Cancel a Job */
  jobCancel: Maybe<Scalars['Boolean']['output']>;
  /** Create a Delivery Request for a Job */
  jobCreateDeliveryRequest: Maybe<Scalars['Boolean']['output']>;
  /** Retry a Job */
  jobRetry: Maybe<Scalars['Boolean']['output']>;
  /** Bulk Destroy Nomenclatures */
  nomenclatureBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for component assets of Nomenclatures in bulk */
  nomenclatureBulkQrCodeCreate: Maybe<Job>;
  /** Create a Nomenclature */
  nomenclatureCreate: Maybe<Nomenclature>;
  /** Update a Nomenclature */
  nomenclatureUpdate: Maybe<Nomenclature>;
  /** Create a Sector */
  sectorCreate: Maybe<Sector>;
  /** Destroy a Sector */
  sectorDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Sector */
  sectorUpdate: Maybe<Sector>;
  /** Destroy Site Areas in bulk */
  siteAreaBulkDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create QR codes for Site Areas in bulk */
  siteAreaBulkQrCodeCreate: Maybe<Job>;
  /** Update a Site Area */
  siteAreaUpdate: Maybe<SiteArea>;
  /** Create a Site */
  siteCreate: Maybe<Site>;
  /** Destroy a Site */
  siteDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Site */
  siteUpdate: Maybe<Site>;
  /** Activate an SSO integration */
  ssoIntegrationActivate: Maybe<SsoIntegration>;
  /** Create an SSO integration */
  ssoIntegrationCreate: Maybe<SsoIntegration>;
  /** Deactivate an SSO integration */
  ssoIntegrationDeactivate: Maybe<SsoIntegration>;
  /** Destroy an SSO integration */
  ssoIntegrationDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an SSO integration */
  ssoIntegrationUpdate: Maybe<SsoIntegration>;
  /** Create a System Admin */
  systemAdminCreate: Maybe<SystemAdmin>;
  /** Destroy a System Admin. Requires session older than 24 hours. */
  systemAdminDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update self System Admin. When changing email, requires session older than 24 hours and step-up 2FA verification (30-min window). */
  systemAdminSelfUpdate: Maybe<SystemAdmin>;
  /** Update a System Admin by other System Admin */
  systemAdminUpdate: Maybe<SystemAdmin>;
  /** Create a User by System Admin */
  systemAdminUserCreate: Maybe<User>;
  /** Create a Tag */
  tagCreate: Maybe<Tag>;
  /** Destroy a Tag */
  tagDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Create same Tasks in bulk */
  taskBulkCreateSame: Maybe<Array<Scalars['ID']['output']>>;
  /** Bulk update a Task's Deadline Missed Reason */
  taskBulkDeadlineMissedReasonUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Bulk schedule Tasks */
  taskBulkScheduling: Maybe<Scalars['Boolean']['output']>;
  /** Bulk update a Task's Template Version */
  taskBulkTemplateVersionUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Update Tasks status */
  taskBulkUpdateStatus: Maybe<Scalars['Boolean']['output']>;
  /** Create a Task Completion */
  taskCompletionCreate: Maybe<TaskCompletion>;
  /** Update a Task's Completion status */
  taskCompletionStatusUpdate: Maybe<TaskCompletion>;
  /** Destroy a Task */
  taskDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Generate a Tasks Timeline Report */
  taskTimelineReportCreate: Maybe<Job>;
  /** Update a Task */
  taskUpdate: Maybe<Task>;
  /** Team creation */
  teamCreate: Maybe<Team>;
  /** Team destroy */
  teamDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Team update */
  teamUpdate: Maybe<Team>;
  /** Create a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseCreate: Maybe<TechnicalPause>;
  /** Destroy a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update a Technical Pause. Requires fresh 2FA verification on every call. */
  technicalPauseUpdate: Maybe<TechnicalPause>;
  /** Activate Users in bulk */
  userBulkActivate: Maybe<Scalars['Boolean']['output']>;
  /** Deactivate Users in bulk */
  userBulkDeactivate: Maybe<Scalars['Boolean']['output']>;
  /** Accept the Code of Conduct */
  userCodeOfConductAccept: Maybe<User>;
  /** Create a User */
  userCreate: Maybe<User>;
  /** Destroy a User */
  userDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update self User */
  userSelfUpdate: Maybe<User>;
  /** Update a User by other Full Admin/Admin */
  userUpdate: Maybe<User>;
  /** Bulk update Widgets for a Home Page */
  widgetBulkUpdate: Maybe<Scalars['Boolean']['output']>;
  /** Create a new Widget Template (only announcement and external_link kinds) */
  widgetTemplateCreate: Maybe<WidgetTemplate>;
  /** Delete a Widget Template (deletes all associated widgets for external_link kind) */
  widgetTemplateDestroy: Maybe<Scalars['Boolean']['output']>;
  /** Update an existing Widget Template */
  widgetTemplateUpdate: Maybe<WidgetTemplate>;
};


/** List of mutations */
export type MutationApiTokenCreateArgs = {
  input: ApiTokenCreateInput;
};


/** List of mutations */
export type MutationApiTokenDestroyArgs = {
  input: ApiTokenDestroyInput;
};


/** List of mutations */
export type MutationApiTokenUpdateArgs = {
  input: ApiTokenUpdateInput;
};


/** List of mutations */
export type MutationAssetBulkDestroyArgs = {
  input: AssetBulkDestroyInput;
};


/** List of mutations */
export type MutationAssetBulkQrCodeCreateArgs = {
  input: AssetBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationAssetCategoryCreateArgs = {
  input: AssetCategoryCreateInput;
};


/** List of mutations */
export type MutationAssetCategoryDestroyArgs = {
  input: AssetCategoryDestroyInput;
};


/** List of mutations */
export type MutationAssetCategoryUpdateArgs = {
  input: AssetCategoryUpdateInput;
};


/** List of mutations */
export type MutationAssetCreateArgs = {
  input: AssetCreateInput;
};


/** List of mutations */
export type MutationAssetUpdateArgs = {
  input: AssetUpdateInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsEmailConfirmationArgs = {
  input: AuthenticationConfirmationsEmailConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsRegistrationConfirmationArgs = {
  input: AuthenticationConfirmationsRegistrationConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsResendEmailConfirmationArgs = {
  input: AuthenticationConfirmationsResendEmailConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationConfirmationsResendRegistrationConfirmationArgs = {
  input: AuthenticationConfirmationsResendRegistrationConfirmationInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordSetupArgs = {
  input: AuthenticationPasswordSetupInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsForgotArgs = {
  input: AuthenticationPasswordsForgotInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsResetArgs = {
  input: AuthenticationPasswordsResetInput;
};


/** List of mutations */
export type MutationAuthenticationPasswordsUpdateArgs = {
  input: AuthenticationPasswordsUpdateInput;
};


/** List of mutations */
export type MutationAuthenticationResendAccountLockedEmailArgs = {
  input: AuthenticationResendAccountLockedEmailInput;
};


/** List of mutations */
export type MutationAuthenticationResendAccountLockedEmailForAdminArgs = {
  input: AuthenticationResendAccountLockedEmailForAdminInput;
};


/** List of mutations */
export type MutationAuthenticationRestoreAccountArgs = {
  input: AuthenticationRestoreAccountInput;
};


/** List of mutations */
export type MutationAuthenticationSessionCreateArgs = {
  input: AuthenticationSessionCreateInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndArgs = {
  input: AuthenticationSessionEndInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndAllArgs = {
  input: AuthenticationSessionEndAllInput;
};


/** List of mutations */
export type MutationAuthenticationSessionEndSpecificArgs = {
  input: AuthenticationSessionEndSpecificInput;
};


/** List of mutations */
export type MutationAuthenticationSessionReportSuspiciousArgs = {
  input: AuthenticationSessionReportSuspiciousInput;
};


/** List of mutations */
export type MutationAuthenticationSessionReportSuspiciousByTokenArgs = {
  input: AuthenticationSessionReportSuspiciousByTokenInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorDisableEmailOtpArgs = {
  input: AuthenticationTwoFactorDisableEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorDisableTotpArgs = {
  input: AuthenticationTwoFactorDisableTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorEnableEmailOtpArgs = {
  input: AuthenticationTwoFactorEnableEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorEnableTotpArgs = {
  input: AuthenticationTwoFactorEnableTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorGenerateBackupCodesArgs = {
  input: AuthenticationTwoFactorGenerateBackupCodesInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorResendEmailOtpArgs = {
  input: AuthenticationTwoFactorResendEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorResetArgs = {
  input: AuthenticationTwoFactorResetInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorSetupEmailOtpArgs = {
  input: AuthenticationTwoFactorSetupEmailOtpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorSetupTotpArgs = {
  input: AuthenticationTwoFactorSetupTotpInput;
};


/** List of mutations */
export type MutationAuthenticationTwoFactorVerifyArgs = {
  input: AuthenticationTwoFactorVerifyInput;
};


/** List of mutations */
export type MutationCompanyCreateArgs = {
  input: CompanyCreateInput;
};


/** List of mutations */
export type MutationCompanyDestroyArgs = {
  input: CompanyDestroyInput;
};


/** List of mutations */
export type MutationCompanyDomainCreateArgs = {
  input: CompanyDomainCreateInput;
};


/** List of mutations */
export type MutationCompanyDomainDestroyArgs = {
  input: CompanyDomainDestroyInput;
};


/** List of mutations */
export type MutationCompanyDomainVerifyArgs = {
  input: CompanyDomainVerifyInput;
};


/** List of mutations */
export type MutationCompanyPlanChangeRequestArgs = {
  input: CompanyPlanChangeRequestInput;
};


/** List of mutations */
export type MutationCompanyUpdateArgs = {
  input: CompanyUpdateInput;
};


/** List of mutations */
export type MutationCounterBulkDestroyArgs = {
  input: CounterBulkDestroyInput;
};


/** List of mutations */
export type MutationCounterBulkQrCodeCreateArgs = {
  input: CounterBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationCounterCreateArgs = {
  input: CounterCreateInput;
};


/** List of mutations */
export type MutationCounterMeasureCreateArgs = {
  input: CounterMeasureCreateInput;
};


/** List of mutations */
export type MutationCounterResetToZeroArgs = {
  input: CounterResetToZeroInput;
};


/** List of mutations */
export type MutationCounterUpdateArgs = {
  input: CounterUpdateInput;
};


/** List of mutations */
export type MutationDataImportCreateArgs = {
  input: DataImportCreateInput;
};


/** List of mutations */
export type MutationDataImportDestroyArgs = {
  input: DataImportDestroyInput;
};


/** List of mutations */
export type MutationDataImportUpdateArgs = {
  input: DataImportUpdateInput;
};


/** List of mutations */
export type MutationDocumentationBulkCreateArgs = {
  input: DocumentationBulkCreateInput;
};


/** List of mutations */
export type MutationDocumentationBulkDestroyArgs = {
  input: DocumentationBulkDestroyInput;
};


/** List of mutations */
export type MutationDocumentationUpdateArgs = {
  input: DocumentationUpdateInput;
};


/** List of mutations */
export type MutationFakeDnsRecordCreateArgs = {
  input: FakeDnsRecordCreateInput;
};


/** List of mutations */
export type MutationFakeDnsRecordDestroyArgs = {
  input: FakeDnsRecordDestroyInput;
};


/** List of mutations */
export type MutationFakeDnsRecordUpdateArgs = {
  input: FakeDnsRecordUpdateInput;
};


/** List of mutations */
export type MutationFeFilterPresetCreateArgs = {
  input: FeFilterPresetCreateInput;
};


/** List of mutations */
export type MutationFeFilterPresetDestroyArgs = {
  input: FeFilterPresetDestroyInput;
};


/** List of mutations */
export type MutationFeFilterPresetUpdateArgs = {
  input: FeFilterPresetUpdateInput;
};


/** List of mutations */
export type MutationFormCategoryCreateArgs = {
  input: FormCategoryCreateInput;
};


/** List of mutations */
export type MutationFormCategoryDestroyArgs = {
  input: FormCategoryDestroyInput;
};


/** List of mutations */
export type MutationFormCategoryUpdateArgs = {
  input: FormCategoryUpdateInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateCreateArgs = {
  input: FormChecklistTemplateCreateInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateDestroyArgs = {
  input: FormChecklistTemplateDestroyInput;
};


/** List of mutations */
export type MutationFormChecklistTemplateUpdateArgs = {
  input: FormChecklistTemplateUpdateInput;
};


/** List of mutations */
export type MutationFormTemplateBulkArchiveArgs = {
  input: FormTemplateBulkArchiveInput;
};


/** List of mutations */
export type MutationFormTemplateBulkDestroyArgs = {
  input: FormTemplateBulkDestroyInput;
};


/** List of mutations */
export type MutationFormTemplateBulkRestoreArgs = {
  input: FormTemplateBulkRestoreInput;
};


/** List of mutations */
export type MutationFormTemplateCreateArgs = {
  input: FormTemplateCreateInput;
};


/** List of mutations */
export type MutationFormTemplateUpdateArgs = {
  input: FormTemplateUpdateInput;
};


/** List of mutations */
export type MutationFormTemplateVersionArchiveArgs = {
  input: FormTemplateVersionArchiveInput;
};


/** List of mutations */
export type MutationFormTemplateVersionCreateArgs = {
  input: FormTemplateVersionCreateInput;
};


/** List of mutations */
export type MutationFormTemplateVersionDestroyArgs = {
  input: FormTemplateVersionDestroyInput;
};


/** List of mutations */
export type MutationFormTemplateVersionRestoreArgs = {
  input: FormTemplateVersionRestoreInput;
};


/** List of mutations */
export type MutationFormTemplateVersionUpdateArgs = {
  input: FormTemplateVersionUpdateInput;
};


/** List of mutations */
export type MutationHomePageBulkUpdateArgs = {
  input: HomePageBulkUpdateInput;
};


/** List of mutations */
export type MutationIndustryCreateArgs = {
  input: IndustryCreateInput;
};


/** List of mutations */
export type MutationIndustryDestroyArgs = {
  input: IndustryDestroyInput;
};


/** List of mutations */
export type MutationIndustryUpdateArgs = {
  input: IndustryUpdateInput;
};


/** List of mutations */
export type MutationInterventionActionCreateArgs = {
  input: InterventionActionCreateInput;
};


/** List of mutations */
export type MutationInterventionActionDestroyArgs = {
  input: InterventionActionDestroyInput;
};


/** List of mutations */
export type MutationInterventionActionUpdateArgs = {
  input: InterventionActionUpdateInput;
};


/** List of mutations */
export type MutationInterventionBulkCloseArgs = {
  input: InterventionBulkCloseInput;
};


/** List of mutations */
export type MutationInterventionCategoryCreateArgs = {
  input: InterventionCategoryCreateInput;
};


/** List of mutations */
export type MutationInterventionCategoryDestroyArgs = {
  input: InterventionCategoryDestroyInput;
};


/** List of mutations */
export type MutationInterventionCategoryUpdateArgs = {
  input: InterventionCategoryUpdateInput;
};


/** List of mutations */
export type MutationInterventionCreateArgs = {
  input: InterventionCreateInput;
};


/** List of mutations */
export type MutationInterventionDestroyArgs = {
  input: InterventionDestroyInput;
};


/** List of mutations */
export type MutationInterventionUpdateArgs = {
  input: InterventionUpdateInput;
};


/** List of mutations */
export type MutationJobCancelArgs = {
  input: JobCancelInput;
};


/** List of mutations */
export type MutationJobCreateDeliveryRequestArgs = {
  input: JobCreateDeliveryRequestInput;
};


/** List of mutations */
export type MutationJobRetryArgs = {
  input: JobRetryInput;
};


/** List of mutations */
export type MutationNomenclatureBulkDestroyArgs = {
  input: NomenclatureBulkDestroyInput;
};


/** List of mutations */
export type MutationNomenclatureBulkQrCodeCreateArgs = {
  input: NomenclatureBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationNomenclatureCreateArgs = {
  input: NomenclatureCreateInput;
};


/** List of mutations */
export type MutationNomenclatureUpdateArgs = {
  input: NomenclatureUpdateInput;
};


/** List of mutations */
export type MutationSectorCreateArgs = {
  input: SectorCreateInput;
};


/** List of mutations */
export type MutationSectorDestroyArgs = {
  input: SectorDestroyInput;
};


/** List of mutations */
export type MutationSectorUpdateArgs = {
  input: SectorUpdateInput;
};


/** List of mutations */
export type MutationSiteAreaBulkDestroyArgs = {
  input: SiteAreaBulkDestroyInput;
};


/** List of mutations */
export type MutationSiteAreaBulkQrCodeCreateArgs = {
  input: SiteAreaBulkQrCodeCreateInput;
};


/** List of mutations */
export type MutationSiteAreaUpdateArgs = {
  input: SiteAreaUpdateInput;
};


/** List of mutations */
export type MutationSiteCreateArgs = {
  input: SiteCreateInput;
};


/** List of mutations */
export type MutationSiteDestroyArgs = {
  input: SiteDestroyInput;
};


/** List of mutations */
export type MutationSiteUpdateArgs = {
  input: SiteUpdateInput;
};


/** List of mutations */
export type MutationSsoIntegrationActivateArgs = {
  input: SsoIntegrationActivateInput;
};


/** List of mutations */
export type MutationSsoIntegrationCreateArgs = {
  input: SsoIntegrationCreateInput;
};


/** List of mutations */
export type MutationSsoIntegrationDeactivateArgs = {
  input: SsoIntegrationDeactivateInput;
};


/** List of mutations */
export type MutationSsoIntegrationDestroyArgs = {
  input: SsoIntegrationDestroyInput;
};


/** List of mutations */
export type MutationSsoIntegrationUpdateArgs = {
  input: SsoIntegrationUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminCreateArgs = {
  input: SystemAdminCreateInput;
};


/** List of mutations */
export type MutationSystemAdminDestroyArgs = {
  input: SystemAdminDestroyInput;
};


/** List of mutations */
export type MutationSystemAdminSelfUpdateArgs = {
  input: SystemAdminSelfUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminUpdateArgs = {
  input: SystemAdminUpdateInput;
};


/** List of mutations */
export type MutationSystemAdminUserCreateArgs = {
  input: SystemAdminUserCreateInput;
};


/** List of mutations */
export type MutationTagCreateArgs = {
  input: TagCreateInput;
};


/** List of mutations */
export type MutationTagDestroyArgs = {
  input: TagDestroyInput;
};


/** List of mutations */
export type MutationTaskBulkCreateSameArgs = {
  input: TaskBulkCreateSameInput;
};


/** List of mutations */
export type MutationTaskBulkDeadlineMissedReasonUpdateArgs = {
  input: TaskBulkDeadlineMissedReasonUpdateInput;
};


/** List of mutations */
export type MutationTaskBulkSchedulingArgs = {
  input: TaskBulkSchedulingInput;
};


/** List of mutations */
export type MutationTaskBulkTemplateVersionUpdateArgs = {
  input: TaskBulkTemplateVersionUpdateInput;
};


/** List of mutations */
export type MutationTaskBulkUpdateStatusArgs = {
  input: TaskBulkUpdateStatusInput;
};


/** List of mutations */
export type MutationTaskCompletionCreateArgs = {
  input: TaskCompletionCreateInput;
};


/** List of mutations */
export type MutationTaskCompletionStatusUpdateArgs = {
  input: TaskCompletionStatusUpdateInput;
};


/** List of mutations */
export type MutationTaskDestroyArgs = {
  input: TaskDestroyInput;
};


/** List of mutations */
export type MutationTaskTimelineReportCreateArgs = {
  input: TasksTimelineReportCreateInput;
};


/** List of mutations */
export type MutationTaskUpdateArgs = {
  input: TaskUpdateInput;
};


/** List of mutations */
export type MutationTeamCreateArgs = {
  input: TeamCreateInput;
};


/** List of mutations */
export type MutationTeamDestroyArgs = {
  input: TeamDestroyInput;
};


/** List of mutations */
export type MutationTeamUpdateArgs = {
  input: TeamUpdateInput;
};


/** List of mutations */
export type MutationTechnicalPauseCreateArgs = {
  input: TechnicalPauseCreateInput;
};


/** List of mutations */
export type MutationTechnicalPauseDestroyArgs = {
  input: TechnicalPauseDestroyInput;
};


/** List of mutations */
export type MutationTechnicalPauseUpdateArgs = {
  input: TechnicalPauseUpdateInput;
};


/** List of mutations */
export type MutationUserBulkActivateArgs = {
  input: UserBulkActivateInput;
};


/** List of mutations */
export type MutationUserBulkDeactivateArgs = {
  input: UserBulkDeactivateInput;
};


/** List of mutations */
export type MutationUserCodeOfConductAcceptArgs = {
  input: UserCodeOfConductAcceptInput;
};


/** List of mutations */
export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


/** List of mutations */
export type MutationUserDestroyArgs = {
  input: UserDestroyInput;
};


/** List of mutations */
export type MutationUserSelfUpdateArgs = {
  input: UserSelfUpdateInput;
};


/** List of mutations */
export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


/** List of mutations */
export type MutationWidgetBulkUpdateArgs = {
  input: WidgetBulkUpdateInput;
};


/** List of mutations */
export type MutationWidgetTemplateCreateArgs = {
  input: WidgetTemplateCreateInput;
};


/** List of mutations */
export type MutationWidgetTemplateDestroyArgs = {
  input: WidgetTemplateDestroyInput;
};


/** List of mutations */
export type MutationWidgetTemplateUpdateArgs = {
  input: WidgetTemplateUpdateInput;
};

/** Nomenclature entity */
export type Nomenclature = TimestampInterface & {
  __typename?: 'Nomenclature';
  /**
   * Component Asset entity
   * NOTE: if you only need an Object ID, please use the componentAssetId field to reduce the load on the database.
   */
  componentAsset: Maybe<Asset>;
  /** Component Asset ID */
  componentAssetId: Maybe<Scalars['ID']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Nomenclature ID */
  id: Scalars['ID']['output'];
  /**
   * Main Asset entity
   * NOTE: if you only need an Object ID, please use the mainAssetId field to reduce the load on the database.
   */
  mainAsset: Maybe<Asset>;
  /** Main Asset ID */
  mainAssetId: Maybe<Scalars['ID']['output']>;
  /** Quantity */
  quantity: Scalars['Int']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Nomenclature IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Main Asset ID */
  mainAssetId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** NomenclatureCollection type */
export type NomenclatureCollection = {
  __typename?: 'NomenclatureCollection';
  /** A collection of paginated NomenclatureCollection */
  collection: Array<Nomenclature>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureCreateInput = {
  /** Create attributes */
  attributes: NomenclatureCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Nomenclature attributes */
export type NomenclatureCreateInputObject = {
  /** Component asset ID */
  componentAssetId: Scalars['ID']['input'];
  /** Main asset ID (Asset nomenclature for) */
  mainAssetId: Scalars['ID']['input'];
  /** Quantity */
  quantity: Scalars['Int']['input'];
};

/** Nomenclature filters */
export type NomenclatureFilterInputObject = {
  /** Component Asset code */
  componentAssetCode?: InputMaybe<FilterInputObject>;
  /** Component Asset name */
  componentAssetName?: InputMaybe<FilterInputObject>;
};

/** Nomenclature sorts */
export type NomenclatureSortInputObject = {
  /** Component Asset code */
  componentAssetCode?: InputMaybe<SortDirectionEnum>;
  /** Component Asset name */
  componentAssetName?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Quantity */
  quantity?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type NomenclatureUpdateInput = {
  /** Update attributes */
  attributes: NomenclatureUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Nomenclature ID */
  id: Scalars['ID']['input'];
  /** Main Asset ID */
  mainAssetId: Scalars['ID']['input'];
};

/** Nomenclature attributes */
export type NomenclatureUpdateInputObject = {
  /** Quantity */
  quantity: Scalars['Int']['input'];
};

/** Available period group by options */
export enum PeriodGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

/** Available QR code file formats */
export enum QrCodeFileFormatEnum {
  /** EPS */
  Eps = 'EPS',
  /** PDF */
  Pdf = 'PDF',
  /** PNG */
  Png = 'PNG',
  /** SVG */
  Svg = 'SVG'
}

/** Available QR code file layouts */
export enum QrCodeFileLayoutEnum {
  /** Single file */
  SingleFile = 'SINGLE_FILE',
  /** Single page */
  SinglePage = 'SINGLE_PAGE'
}

/** Available QR code page sizes */
export enum QrCodePageSizeEnum {
  /** 29x39 mm */
  W29H39 = 'W29H39',
  /** 60x80 mm */
  W60H80 = 'W60H80',
  /** 67x76 mm */
  W67H76 = 'W67H76',
  /** A5 (148x210 mm) */
  W148H210 = 'W148H210'
}

/** QR codes attributes */
export type QrCodesCreateInputObject = {
  /** File format */
  fileFormat: QrCodeFileFormatEnum;
  /** File layout */
  fileLayout: QrCodeFileLayoutEnum;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Message to recipient */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Page size */
  pageSize: QrCodePageSizeEnum;
  /** Recipient user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** List of queries */
export type Query = {
  __typename?: 'Query';
  /** Show an ApiToken */
  apiToken: Maybe<ApiToken>;
  /** List of ApiTokens */
  apiTokens: ApiTokenCollection;
  /** Asset */
  asset: Maybe<Asset>;
  /** List of Asset Categories */
  assetCategories: AssetCategoryCollection;
  /** Show an Asset Category */
  assetCategory: Maybe<AssetCategory>;
  /** List of Assets */
  assets: AssetCollection;
  /** Check if an email domain has SSO integrations configured. Used on login page to show SSO options. */
  authenticationSsoCheck: SsoCheck;
  /** List of Companies */
  companies: CompanyCollection;
  /** Show a Company */
  company: Maybe<Company>;
  /** Show a Company Domain */
  companyDomain: Maybe<CompanyDomain>;
  /** List of Company Domains */
  companyDomains: CompanyDomainCollection;
  /** Show a Counter */
  counter: Maybe<Counter>;
  /** Show a Counter Measure */
  counterMeasure: Maybe<CounterMeasure>;
  /** List of Counter Measures */
  counterMeasures: CounterMeasureCollection;
  /** Counter Measures Graph Data */
  counterMeasuresGraphData: Array<CounterMeasureGraphData>;
  /** List of Counters */
  counters: CounterCollection;
  /** List of countries */
  countries: Array<GeoCountry>;
  /** Show a Data Import */
  dataImport: Maybe<DataImport>;
  /** Data Import Config */
  dataImportConfig: Maybe<Scalars['CamelizedJson']['output']>;
  /** List of Data Imports */
  dataImports: DataImportCollection;
  /** Show a documentation */
  documentation: Maybe<Documentation>;
  /** List of documentations */
  documentations: DocumentationCollection;
  /** Show a fake DNS record (non-production only) */
  fakeDnsRecord: Maybe<FakeDnsRecord>;
  /** List of fake DNS records (non-production only) */
  fakeDnsRecords: FakeDnsRecordCollection;
  /** Show a Frontend Filter Preset */
  feFilterPreset: Maybe<FeFilterPreset>;
  /** List of Frontend Filter Presets */
  feFilterPresets: FeFilterPresetCollection;
  /** List of Form Categories */
  formCategories: FormCategoryCollection;
  /** Show a Form Category */
  formCategory: Maybe<FormCategory>;
  /** Show a Form Checklist Template */
  formChecklistTemplate: Maybe<FormChecklistTemplate>;
  /** List of Form Checklist Templates */
  formChecklistTemplates: FormChecklistTemplateCollection;
  /** Show a Form Template */
  formTemplate: Maybe<FormTemplate>;
  /** Show a Form Template Version */
  formTemplateVersion: Maybe<FormTemplateVersion>;
  /** List of Form Template Versions */
  formTemplateVersions: FormTemplateVersionCollection;
  /** List of Form Templates */
  formTemplates: FormTemplateCollection;
  /** List of Histories */
  histories: HistoryCollection;
  /** Show a Home Page */
  homePage: Maybe<HomePage>;
  /** List of Home Pages */
  homePages: HomePageCollection;
  /** List of Industries */
  industries: IndustryCollection;
  /** Show an Industry */
  industry: Maybe<Industry>;
  /** Show an Intervention */
  intervention: Maybe<Intervention>;
  /** Show an Intervention Action */
  interventionAction: Maybe<InterventionAction>;
  /** List of Intervention Actions */
  interventionActions: InterventionActionCollection;
  /** List of Intervention Categories */
  interventionCategories: InterventionCategoryCollection;
  /** Show an Intervention Category */
  interventionCategory: Maybe<InterventionCategory>;
  /** List of Interventions */
  interventions: InterventionCollection;
  /** Show jobs information */
  jobs: Array<Job>;
  /** Show a Nomenclature */
  nomenclature: Maybe<Nomenclature>;
  /** List of Nomenclatures */
  nomenclatures: NomenclatureCollection;
  /** Show a Sector */
  sector: Maybe<Sector>;
  /** Sector Location Center */
  sectorLocationCenter: Maybe<LocationGeographicalCenter>;
  /** List of Sector Locations */
  sectorLocations: Maybe<GeojsonFeatureCollection>;
  /** List of Sectors */
  sectors: SectorCollection;
  /** Sectors performance metrics by task deadlines missed */
  sectorsPerformanceMetricsByTaskDeadlinesMissed: Maybe<Array<SectorPerformanceMetricByTaskDeadlinesMissed>>;
  /** Sectors performance metrics by task deadlines missed by date */
  sectorsPerformanceMetricsByTaskDeadlinesMissedByDate: Maybe<Array<SectorPerformanceMetricByTaskDeadlinesMissedByDate>>;
  /** Sectors performance metrics by task results */
  sectorsPerformanceMetricsByTaskResults: Maybe<Array<SectorPerformanceMetricByTaskResults>>;
  /** Sectors performance metrics by task results by date */
  sectorsPerformanceMetricsByTaskResultsByDate: Maybe<Array<SectorPerformanceMetricByTaskResultsByDate>>;
  /** List of user sessions */
  sessions: SessionCollection;
  /** Show a Site */
  site: Maybe<Site>;
  /** Show a Site Area */
  siteArea: Maybe<SiteArea>;
  /** List of Site Areas */
  siteAreas: SiteAreaCollection;
  /** Site Location Center */
  siteLocationCenter: Maybe<LocationGeographicalCenter>;
  /** List of Site Locations */
  siteLocations: Maybe<GeojsonFeatureCollection>;
  /** List of Sites */
  sites: SiteCollection;
  /** Sites performance metrics by task deadlines missed */
  sitesPerformanceMetricsByTaskDeadlinesMissed: Maybe<Array<SitePerformanceMetricByTaskDeadlinesMissed>>;
  /** Sites performance metrics by task deadlines missed by date */
  sitesPerformanceMetricsByTaskDeadlinesMissedByDate: Maybe<Array<SitePerformanceMetricByTaskDeadlinesMissedByDate>>;
  /** Sites performance metrics by task results */
  sitesPerformanceMetricsByTaskResults: Maybe<Array<SitePerformanceMetricByTaskResults>>;
  /** Sites performance metrics by task results by date */
  sitesPerformanceMetricsByTaskResultsByDate: Maybe<Array<SitePerformanceMetricByTaskResultsByDate>>;
  /** Show an SSO integration */
  ssoIntegration: Maybe<SsoIntegration>;
  /** Generate a new SSO code with SP URLs for IdP configuration */
  ssoIntegrationGenerateCode: SsoGeneratedCode;
  /** Get default attribute mapping and settings for a provider preset */
  ssoIntegrationPresetDefaults: Scalars['JSON']['output'];
  /** List of supported user fields for SSO attribute mapping */
  ssoIntegrationSupportedMappingFields: Array<SsoMappingField>;
  /** List of SSO integrations */
  ssoIntegrations: SsoIntegrationCollection;
  /** Show a System Admin */
  systemAdmin: Maybe<SystemAdmin>;
  /** List of System Admins */
  systemAdmins: SystemAdminCollection;
  /** Show a tag */
  tag: Maybe<Tag>;
  /** List of tags */
  tags: TagCollection;
  /** Task */
  task: Maybe<Task>;
  /** Get unique task kinds for given task IDs available for scheduling */
  taskAvailableForSchedulingKindsByIds: Array<TaskKindEnum>;
  /** Show a Task Completion */
  taskCompletion: Maybe<TaskCompletion>;
  /** List of Task Completions */
  taskCompletions: TaskCompletionCollection;
  /** List of Tasks */
  tasks: TaskCollection;
  /** Tasks data which can be completed from today until a provided date and assigned to the current user */
  tasksMyTodoCompletableByDateData: Array<TasksTodoCompletableByDateData>;
  /** Tasks Timeline */
  tasksTimeline: Array<TaskTimeline>;
  /** Show a Team */
  team: Maybe<Team>;
  /** List of Teams */
  teams: TeamCollection;
  /** Show a Technical Pause */
  technicalPause: Maybe<TechnicalPause>;
  /** List of Technical Pauses */
  technicalPauses: TechnicalPauseCollection;
  /** Show a User */
  user: Maybe<User>;
  /** List of Users */
  users: UserCollection;
  /** Show current user */
  whoami: Whoami;
  /** Show a Widget */
  widget: Maybe<Widget>;
  /** Show a Widget Template */
  widgetTemplate: Maybe<WidgetTemplate>;
  /** List of Widget Templates */
  widgetTemplates: WidgetTemplateCollection;
  /** List of Widgets */
  widgets: Array<Widget>;
};


/** List of queries */
export type QueryApiTokenArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryApiTokensArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryAssetArgs = {
  findBy: AssetFindByInputObject;
  siteFindBy?: InputMaybe<SiteFindByInputObject>;
};


/** List of queries */
export type QueryAssetCategoriesArgs = {
  filters?: InputMaybe<Array<AssetCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetCategorySortInputObject>;
};


/** List of queries */
export type QueryAssetCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryAssetsArgs = {
  filters?: InputMaybe<Array<AssetFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<AssetSortInputObject>;
};


/** List of queries */
export type QueryAuthenticationSsoCheckArgs = {
  email: Scalars['String']['input'];
};


/** List of queries */
export type QueryCompaniesArgs = {
  filters?: InputMaybe<Array<CompanyFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanySortInputObject>;
};


/** List of queries */
export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCompanyDomainArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCompanyDomainsArgs = {
  filters?: InputMaybe<Array<CompanyDomainFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CompanyDomainSortInputObject>;
};


/** List of queries */
export type QueryCounterArgs = {
  assetFindBy: AssetFindByInputObject;
  findBy: CounterFindByInputObject;
};


/** List of queries */
export type QueryCounterMeasureArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryCounterMeasuresArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<CounterMeasureFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterMeasureSortInputObject>;
};


/** List of queries */
export type QueryCounterMeasuresGraphDataArgs = {
  assetId: Scalars['ID']['input'];
  counterId: Scalars['ID']['input'];
  dateRange: DateRangeInputObject;
};


/** List of queries */
export type QueryCountersArgs = {
  assetId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<CounterFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<CounterSortInputObject>;
};


/** List of queries */
export type QueryDataImportArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDataImportsArgs = {
  filters?: InputMaybe<Array<DataImportFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DataImportSortInputObject>;
};


/** List of queries */
export type QueryDocumentationArgs = {
  assetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryDocumentationsArgs = {
  assetId: Scalars['ID']['input'];
  filters?: InputMaybe<Array<DocumentationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<DocumentationSortInputObject>;
};


/** List of queries */
export type QueryFakeDnsRecordArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFakeDnsRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryFeFilterPresetArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFeFilterPresetsArgs = {
  filters?: InputMaybe<Array<FeFilterPresetFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FeFilterPresetSortInputObject>;
};


/** List of queries */
export type QueryFormCategoriesArgs = {
  filters?: InputMaybe<Array<FormCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormCategorySortInputObject>;
};


/** List of queries */
export type QueryFormCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormChecklistTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormChecklistTemplatesArgs = {
  filters?: InputMaybe<Array<FormChecklistTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormChecklistTemplateSortInputObject>;
};


/** List of queries */
export type QueryFormTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormTemplateVersionArgs = {
  formTemplateId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryFormTemplateVersionsArgs = {
  filters?: InputMaybe<Array<FormTemplateVersionFilterInputObject>>;
  formTemplateId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<FormTemplateVersionSortInputObject>;
};


/** List of queries */
export type QueryFormTemplatesArgs = {
  filters?: InputMaybe<Array<FormTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: FormTemplateScopeNameEnum;
  sorts?: InputMaybe<FormTemplateSortInputObject>;
};


/** List of queries */
export type QueryHistoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<HistorySortInputObject>;
  sourceableId: Scalars['ID']['input'];
  sourceableType: HistorySourceableTypeEnum;
};


/** List of queries */
export type QueryHomePageArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryHomePagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** List of queries */
export type QueryIndustriesArgs = {
  filters?: InputMaybe<Array<IndustryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<IndustrySortInputObject>;
};


/** List of queries */
export type QueryIndustryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionActionArgs = {
  id: Scalars['ID']['input'];
  interventionId: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionActionsArgs = {
  filters?: InputMaybe<Array<InterventionActionFilterInputObject>>;
  interventionId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionActionSortInputObject>;
};


/** List of queries */
export type QueryInterventionCategoriesArgs = {
  filters?: InputMaybe<Array<InterventionCategoryFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<InterventionCategorySortInputObject>;
};


/** List of queries */
export type QueryInterventionCategoryArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryInterventionsArgs = {
  filters?: InputMaybe<Array<InterventionFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeName: InterventionScopeNameEnum;
  sorts?: InputMaybe<InterventionSortInputObject>;
};


/** List of queries */
export type QueryJobsArgs = {
  jids: Array<Scalars['String']['input']>;
};


/** List of queries */
export type QueryNomenclatureArgs = {
  id: Scalars['ID']['input'];
  mainAssetId: Scalars['ID']['input'];
};


/** List of queries */
export type QueryNomenclaturesArgs = {
  filters?: InputMaybe<Array<NomenclatureFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mainAssetId: Scalars['ID']['input'];
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<NomenclatureSortInputObject>;
};


/** List of queries */
export type QuerySectorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** List of queries */
export type QuerySectorLocationCenterArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject>>;
};


/** List of queries */
export type QuerySectorLocationsArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  mapParams: LocationMapParamsInputObject;
  sectorFilters?: InputMaybe<Array<SectorFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsArgs = {
  filters?: InputMaybe<Array<SectorFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SectorSortInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskDeadlinesMissedArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskDeadlinesMissedByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySectorsPerformanceMetricsByTaskResultsByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySessionsArgs = {
  currentFirst?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope: SessionScopeEnum;
  sorts?: InputMaybe<SessionSortInputObject>;
};


/** List of queries */
export type QuerySiteArgs = {
  findBy: SiteFindByInputObject;
};


/** List of queries */
export type QuerySiteAreaArgs = {
  findBy: SiteAreaFindByInputObject;
  siteFindBy?: InputMaybe<SiteFindByInputObject>;
};


/** List of queries */
export type QuerySiteAreasArgs = {
  filters?: InputMaybe<Array<SiteAreaFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SiteAreaSortInputObject>;
};


/** List of queries */
export type QuerySiteLocationCenterArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject>>;
};


/** List of queries */
export type QuerySiteLocationsArgs = {
  filters?: InputMaybe<Array<LocationFilterInputObject>>;
  mapParams: LocationMapParamsInputObject;
  siteFilters?: InputMaybe<Array<SiteFilterInputObject>>;
};


/** List of queries */
export type QuerySitesArgs = {
  filters?: InputMaybe<Array<SiteFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SiteSortInputObject>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskDeadlinesMissedArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskDeadlinesMissedByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySitesPerformanceMetricsByTaskResultsByDateArgs = {
  ids: Array<Scalars['ID']['input']>;
  periodGroupBy: PeriodGroupByEnum;
  taskFilters?: InputMaybe<Array<TaskFilterInputObject>>;
};


/** List of queries */
export type QuerySsoIntegrationArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QuerySsoIntegrationPresetDefaultsArgs = {
  preset: SsoIntegrationProviderPresetEnum;
};


/** List of queries */
export type QuerySsoIntegrationsArgs = {
  filters?: InputMaybe<Array<SsoIntegrationFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SsoIntegrationSortInputObject>;
};


/** List of queries */
export type QuerySystemAdminArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QuerySystemAdminsArgs = {
  filters?: InputMaybe<Array<SystemAdminFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<SystemAdminSortInputObject>;
};


/** List of queries */
export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTagsArgs = {
  filters?: InputMaybe<Array<TagFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TagSortInputObject>;
};


/** List of queries */
export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTaskAvailableForSchedulingKindsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** List of queries */
export type QueryTaskCompletionArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTaskCompletionsArgs = {
  filters?: InputMaybe<Array<TaskCompletionFilterInputObject>>;
  groupKey: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TaskCompletionSortInputObject>;
};


/** List of queries */
export type QueryTasksArgs = {
  filters?: InputMaybe<Array<TaskFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope: TaskScopeInputObject;
  sorts?: InputMaybe<TaskSortInputObject>;
};


/** List of queries */
export type QueryTasksMyTodoCompletableByDateDataArgs = {
  date: Scalars['ISO8601DateTime']['input'];
};


/** List of queries */
export type QueryTasksTimelineArgs = {
  queryData: TaskTimelineQueryDataInputObject;
  taskIds: Array<Scalars['ID']['input']>;
};


/** List of queries */
export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTeamsArgs = {
  filters?: InputMaybe<Array<TeamFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TeamSortInputObject>;
};


/** List of queries */
export type QueryTechnicalPauseArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryTechnicalPausesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<TechnicalPauseSortInputObject>;
};


/** List of queries */
export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryUsersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<Array<UserFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UserScopeInputObject>;
  sorts?: InputMaybe<UserSortInputObject>;
};


/** List of queries */
export type QueryWidgetArgs = {
  homePageId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryWidgetTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** List of queries */
export type QueryWidgetTemplatesArgs = {
  filters?: InputMaybe<Array<WidgetTemplateFilterInputObject>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  onlyIds?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sorts?: InputMaybe<WidgetTemplateSortInputObject>;
};


/** List of queries */
export type QueryWidgetsArgs = {
  homePageId: Scalars['ID']['input'];
};

/** Recurring rule entity */
export type RecurringRule = TimestampInterface & {
  __typename?: 'RecurringRule';
  /** Countdown type */
  countdownType: Maybe<RecurringRuleCountdownTypeEnum>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** End time */
  endTime: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of occurrences after which recurring rule will be stopped */
  endsAfterOccurrences: Maybe<Scalars['Int']['output']>;
  /** Days that should be moved to the nearest available day */
  excludedWdays: Maybe<Array<Scalars['Int']['output']>>;
  /** Recurring rule ID */
  id: Scalars['ID']['output'];
  /** Recurring rule schema */
  schema: RecurringRuleSchema;
  /** Start time */
  startTime: Scalars['ISO8601DateTime']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Available countdown types */
export enum RecurringRuleCountdownTypeEnum {
  Completion = 'COMPLETION',
  Deadline = 'DEADLINE'
}

/** Recurring rule attributes */
export type RecurringRuleInputObject = {
  /** Countdown type */
  countdownType: RecurringRuleCountdownTypeEnum;
  /** End time */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Number of occurrences after which recurring rule will be stopped */
  endsAfterOccurrences?: InputMaybe<Scalars['Int']['input']>;
  /** Days that should be moved to the nearest available day */
  excludedWdays: Array<Scalars['Int']['input']>;
  /** Schema attributes */
  schema: RecurringRuleSchemaInputObject;
  /** Start time */
  startTime: Scalars['ISO8601DateTime']['input'];
};

/** Available recurring rule types */
export enum RecurringRuleRuleTypeEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** Recurring rule schema type */
export type RecurringRuleSchema = {
  __typename?: 'RecurringRuleSchema';
  /** Recurring rule schema metadata */
  metadata: Maybe<RecurringRuleSchemaMetadata>;
  /** Recurring schema rule */
  rrules: Array<RecurringRuleSchemaRule>;
};

/**
 * Recurring rule schema attributes
 * Examples:
 *
 *   - Daily:
 *     ```
 *     [
 *       {
 *         "ruleType": "DAILY",
 *         "interval": 1
 *       }
 *     ]
 *     ```
 *
 *   - Weekly on Sundays, Mondays, Wednesdays, and Fridays:
 *     ```
 *     [
 *       {
 *         "ruleType": "WEEKLY",
 *         "interval": 1,
 *         "validations": {
 *           "day": [0,1,3,5]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Monthly on the 1st, 15th, and 31st days of the month:
 *     ```
 *     [
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfMonth": [1,15,31]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Monthly on the 1st Monday and on the last day of the month
 *     ```
 *     [
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfWeek": {
 *             "1": [1]
 *           }
 *         }
 *       },
 *       {
 *         "ruleType": "MONTHLY",
 *         "interval": 1,
 *         "validations": {
 *           "dayOfMonth": [-1]
 *         }
 *       }
 *     ]
 *     ```
 *
 *   - Yearly:
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 1
 *       }
 *     ]
 *     ```
 *
 *   - Every 2 years on the 1st and last days of the month in January, February, and December:
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfMonth": [1,-1],
 *           "monthOfYear": [1,2,12]
 *         }
 *       }
 *     ]
 *     ```
 *   - Every 2 years on the 1st Monday and last Friday (1) and on the last day of the month (2) in January and February
 *     ```
 *     [
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfWeek": {
 *             "1": [1],
 *             "5": [-1]
 *           },
 *           "monthOfYear": [1,2]
 *         }
 *       },
 *       {
 *         "ruleType": "YEARLY",
 *         "interval": 2,
 *         "validations": {
 *           "dayOfMonth": [-1],
 *           "monthOfYear": [1,2]
 *         }
 *       }
 *     ]
 *     ```
 *
 */
export type RecurringRuleSchemaInputObject = {
  /** Metadata */
  metadata?: InputMaybe<RecurringRuleSchemaMetadataInputObject>;
  /** Recurring schema rule */
  rrules: Array<RecurringRuleSchemaRuleInputObject>;
};

/** Recurring rule schema metadata */
export type RecurringRuleSchemaMetadata = {
  __typename?: 'RecurringRuleSchemaMetadata';
  /** Recurring rule schema option */
  schemaOption: RecurringRuleSchemaOptionEnum;
};

/** Recurring rule schema metadata attributes */
export type RecurringRuleSchemaMetadataInputObject = {
  /** Schema option */
  schemaOption?: InputMaybe<RecurringRuleSchemaOptionEnum>;
};

/** Available recurring rule schema options */
export enum RecurringRuleSchemaOptionEnum {
  Each = 'EACH',
  OnThe = 'ON_THE'
}

/**
 * Recurring schema rule
 * Examples:
 *
 * - Daily:
 *   ```
 *   [
 *     {
 *       "ruleType": "DAILY",
 *       "interval": 1
 *     }
 *   ]
 *   ```
 *
 * - Weekly on Sundays, Mondays, Wednesdays, and Fridays:
 *   ```
 *   [
 *     {
 *       "ruleType": "WEEKLY",
 *       "interval": 1,
 *       "validations": {
 *         "day": [0,1,3,5]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Monthly on the 1st, 15th, and 31st days of the month:
 *   ```
 *   [
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfMonth": [1,15,31]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Monthly on the 1st Monday and on the last day of the month
 *   ```
 *   [
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfWeek": {
 *           "1": [1]
 *         }
 *       }
 *     },
 *     {
 *       "ruleType": "MONTHLY",
 *       "interval": 1,
 *       "validations": {
 *         "dayOfMonth": [-1]
 *       }
 *     }
 *   ]
 *   ```
 *
 * - Yearly:
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 1
 *     }
 *   ]
 *   ```
 *
 * - Every 2 years on the 1st and last days of the month in January, February, and December:
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfMonth": [1,-1],
 *         "monthOfYear": [1,2,12]
 *       }
 *     }
 *   ]
 *   ```
 * - Every 2 years on the 1st Monday and last Friday (1) and on the last day of the month (2) in January and February
 *   ```
 *   [
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfWeek": {
 *           "1": [1],
 *           "5": [-1]
 *         },
 *         "monthOfYear": [1,2]
 *       }
 *     },
 *     {
 *       "ruleType": "YEARLY",
 *       "interval": 2,
 *       "validations": {
 *         "dayOfMonth": [-1],
 *         "monthOfYear": [1,2]
 *       }
 *     }
 *   ]
 *   ```
 *
 */
export type RecurringRuleSchemaRule = {
  __typename?: 'RecurringRuleSchemaRule';
  /** Interval */
  interval: Scalars['Int']['output'];
  /** Rule type */
  ruleType: RecurringRuleRuleTypeEnum;
  /** Recurring schema rule validations */
  validations: Maybe<RecurringRuleValidations>;
};

/** Recurring rule schema rule attributes */
export type RecurringRuleSchemaRuleInputObject = {
  /** Interval */
  interval: Scalars['Int']['input'];
  /** Rule type */
  ruleType: RecurringRuleRuleTypeEnum;
  /** Validations attributes */
  validations?: InputMaybe<RecurringRuleValidationsInputObject>;
};

/** Recurring schema rule validations */
export type RecurringRuleValidations = {
  __typename?: 'RecurringRuleValidations';
  /** Day (1..31) */
  day: Maybe<Array<Scalars['Int']['output']>>;
  /** Days of month (-1, 1..31) where -1 is the last day of the month, 1 is the first day of the month, etc. */
  dayOfMonth: Maybe<Array<Scalars['Int']['output']>>;
  /**
   * Days of week.
   * Example: `{"1": [-1,1,3,5]}` where key `1` is the day of the week (Monday) and value `[-1,1,3,5]` are the number of the day in the month (last, 1st, 3rd, 5th)
   *
   */
  dayOfWeek: Maybe<Scalars['JSON']['output']>;
  /** Month of year (1..12) */
  monthOfYear: Maybe<Array<Scalars['Int']['output']>>;
};

/** Recurring rule validations */
export type RecurringRuleValidationsInputObject = {
  /** Day (1..31) */
  day?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Day of month (-1, 1..31) where -1 is the last day of the month, 1 is the first day of the month, etc. */
  dayOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Days of week.
   * Example: `{"1": [-1,1,3,5]}` where key `1` is the day of the week (Monday) and value `[-1,1,3,5]` are the number of the day in the month (last, 1st, 3rd, 5th)
   *
   */
  dayOfWeek?: InputMaybe<Scalars['JSON']['input']>;
  /** Month of year (1..12) */
  monthOfYear?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Response message */
export type ResponseMessage = {
  __typename?: 'ResponseMessage';
  /** Message */
  message: Scalars['String']['output'];
};

/** Sector entity */
export type Sector = TimestampInterface & {
  __typename?: 'Sector';
  canDestroy: AuthorizationResult;
  /** Code */
  code: Maybe<Scalars['String']['output']>;
  /** Color */
  color: Maybe<Scalars['String']['output']>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Location boundary */
  locationBoundary: Maybe<Location>;
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if sector is read only (default system sector) */
  readOnly: Scalars['Boolean']['output'];
  /** Sites collection */
  sites: SiteCollection;
  /** Sites count */
  sitesCount: Scalars['Int']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Responsible User entity
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Responsible User ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Users count (memberships + full admins) */
  usersCount: Scalars['Int']['output'];
};


/** Sector entity */
export type SectorSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** SectorCollection type */
export type SectorCollection = {
  __typename?: 'SectorCollection';
  /** A collection of paginated SectorCollection */
  collection: Array<Sector>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SectorCreateInput = {
  /** Create attributes */
  attributes: SectorCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Sector attributes */
export type SectorCreateInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color: Scalars['String']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location boundary */
  locationBoundary?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name: Scalars['String']['input'];
  /** Sites linking attributes array */
  sites?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Users linking attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type SectorDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  id: Scalars['ID']['input'];
};

/** Sector filters */
export type SectorFilterInputObject = {
  /** Sector code */
  code?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Sector name */
  name?: InputMaybe<FilterInputObject>;
  /** Sites ID */
  sitesId?: InputMaybe<FilterIdInputObject>;
};

/** Sector performance metric by task deadlines missed entity */
export type SectorPerformanceMetricByTaskDeadlinesMissed = {
  __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissed';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task deadlines missed by date entity */
export type SectorPerformanceMetricByTaskDeadlinesMissedByDate = {
  __typename?: 'SectorPerformanceMetricByTaskDeadlinesMissedByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Scalars['Int']['output'];
};

/** Sector performance metric by task results entity */
export type SectorPerformanceMetricByTaskResults = {
  __typename?: 'SectorPerformanceMetricByTaskResults';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task results by date entity */
export type SectorPerformanceMetricByTaskResultsByDate = {
  __typename?: 'SectorPerformanceMetricByTaskResultsByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Scalars['Int']['output'];
};

/** Sector sorts */
export type SectorSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sites count */
  sitesCount?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** Users count (memberships + full admins) */
  usersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SectorUpdateInput = {
  /** Update attributes */
  attributes: SectorUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  id: Scalars['ID']['input'];
};

/** Sector attributes */
export type SectorUpdateInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Location boundary */
  locationBoundary?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Sites linking attributes array */
  sites?: InputMaybe<Array<LinkingInputObject>>;
  /** Responsible User ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Users linking attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Session */
export type Session = {
  __typename?: 'Session';
  /** Minimum session age in hours required for sensitive operations */
  ageMinimumHours: Scalars['Int']['output'];
  /** Browser name */
  browserName: Scalars['String']['output'];
  /** Browser version */
  browserVersion: Scalars['String']['output'];
  /** City from IP geolocation */
  city: Scalars['String']['output'];
  /** Country from IP geolocation */
  country: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 country code */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Creation time */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Combined device info (e.g., "Desktop, Chrome 120.0") */
  device: Scalars['String']['output'];
  /** Device type (Desktop, Smartphone, Tablet, etc.) */
  deviceType: Scalars['String']['output'];
  /** Expiration time */
  expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Session ID */
  id: Scalars['ID']['output'];
  /** IP address */
  ip: Maybe<Scalars['String']['output']>;
  /** Last activity time */
  lastActivityAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Combined location info (e.g., "Kyiv, Kyiv Oblast, Ukraine") */
  location: Scalars['String']['output'];
  /** Operating system name */
  osName: Scalars['String']['output'];
  /** Region/state from IP geolocation */
  region: Scalars['String']['output'];
  /** Whether this session belongs to the current device */
  thisDevice: Scalars['Boolean']['output'];
  /** Whether session is too young for sensitive operations */
  tooYoung: Scalars['Boolean']['output'];
  /** Indicates if session is pending two-factor authentication verification */
  twoFactorPending: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication has been verified for this session */
  twoFactorVerified: Scalars['Boolean']['output'];
  /** User agent */
  userAgent: Maybe<Scalars['String']['output']>;
};

/** SessionCollection type */
export type SessionCollection = {
  __typename?: 'SessionCollection';
  /** A collection of paginated SessionCollection */
  collection: Array<Session>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Available session scopes */
export enum SessionScopeEnum {
  /** Active sessions (not expired) */
  Active = 'ACTIVE',
  /** Ended sessions (expired) */
  Ended = 'ENDED'
}

/** Session sorts */
export type SessionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Expires at */
  expiresAt?: InputMaybe<SortDirectionEnum>;
  /** Last activity at */
  lastActivityAt?: InputMaybe<SortDirectionEnum>;
};

/** Site entity */
export type Site = TimestampInterface & {
  __typename?: 'Site';
  /** Site cellphone */
  cellphone: Maybe<Scalars['String']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Site contact email */
  email: Scalars['String']['output'];
  /** Site ID */
  id: Scalars['ID']['output'];
  /** Site location photo */
  locationPhotoAttached: Maybe<Attachment>;
  /** Location point */
  locationPoint: Maybe<Location>;
  /** Name */
  name: Scalars['String']['output'];
  /** Site contact phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /**
   * Sector
   * NOTE: if you only need an Object ID, please use the sectorId field to reduce the load on the database.
   */
  sector: Maybe<Sector>;
  /** Sector ID */
  sectorId: Maybe<Scalars['ID']['output']>;
  /** Number of Site Areas */
  siteAreasCount: Scalars['Int']['output'];
  /** Site Code of Conduct sections */
  siteConductCodeSections: Array<SiteConductCodeSection>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Responsible user
   * NOTE: if you only need an Object ID, please use the userId field to reduce the load on the database.
   */
  user: Maybe<User>;
  /** Responsible user ID */
  userId: Maybe<Scalars['ID']['output']>;
  /** Number of Users (memberships + full admins) */
  usersCount: Scalars['Int']['output'];
};

/** Site Area entity */
export type SiteArea = TimestampInterface & {
  __typename?: 'SiteArea';
  /** Site Area address */
  address: Maybe<Scalars['String']['output']>;
  /** Code */
  code: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Full code (As on the QR code) */
  fullCode: Scalars['String']['output'];
  /** Site Area ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi: Scalars['Boolean']['output'];
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaBulkDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaBulkQrCodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Create params */
  params: QrCodesCreateInputObject;
};

/** SiteAreaCollection type */
export type SiteAreaCollection = {
  __typename?: 'SiteAreaCollection';
  /** A collection of paginated SiteAreaCollection */
  collection: Array<SiteArea>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Site area attributes */
export type SiteAreaCreateInputObject = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Site Area filters */
export type SiteAreaFilterInputObject = {
  /** Site Area code */
  code?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  name?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  sectorId?: InputMaybe<FilterIdInputObject>;
  /** Sector name */
  sectorName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
};

/** Site area attributes */
export type SiteAreaFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Site Area sorts */
export type SiteAreaSortInputObject = {
  /** Code */
  code?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sector name */
  sectorName?: InputMaybe<SortDirectionEnum>;
  /** Site code */
  siteCode?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteAreaUpdateInput = {
  /** Update attributes */
  attributes: SiteAreaUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site Area ID */
  id: Scalars['ID']['input'];
};

/** Site area attributes */
export type SiteAreaUpdateInputObject = {
  /** Address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if site area location has poor wifi or does not have wifi */
  poorWifi?: InputMaybe<Scalars['Boolean']['input']>;
};

/** SiteCollection type */
export type SiteCollection = {
  __typename?: 'SiteCollection';
  /** A collection of paginated SiteCollection */
  collection: Array<Site>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Site Code of Conduct section entity */
export type SiteConductCodeSection = TimestampInterface & {
  __typename?: 'SiteConductCodeSection';
  /** Body text */
  body: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Site Code of Conduct section ID */
  id: Scalars['ID']['output'];
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Site conduct code section attributes */
export type SiteConductCodeSectionCreateInputObject = {
  /** Body */
  body: Scalars['String']['input'];
  /** Position */
  position: Scalars['Int']['input'];
  /** Title */
  title: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SiteCreateInput = {
  /** Create attributes */
  attributes: SiteCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Site attributes */
export type SiteCreateInputObject = {
  /** Create Site Areas attributes array */
  areas?: InputMaybe<Array<SiteAreaCreateInputObject>>;
  /** Site cellphone */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Create Conduct Code sections attributes array */
  conductCodeSections?: InputMaybe<Array<SiteConductCodeSectionCreateInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Site contact email */
  email: Scalars['String']['input'];
  /** Location photo */
  locationPhotoAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Location point */
  locationPoint: LocationCuInputObject;
  /** Name */
  name: Scalars['String']['input'];
  /** Site contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible user ID */
  userId: Scalars['ID']['input'];
  /** User memberships attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site ID */
  id: Scalars['ID']['input'];
};

/** Site filters */
export type SiteFilterInputObject = {
  /** Site area code */
  areasCode?: InputMaybe<FilterInputObject>;
  /** Site area name */
  areasName?: InputMaybe<FilterInputObject>;
  /** Site code */
  code?: InputMaybe<FilterInputObject>;
  /** Site ID */
  id?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  name?: InputMaybe<FilterInputObject>;
  /** Sector ID */
  sectorId?: InputMaybe<FilterInputObject>;
  /** Sector name */
  sectorName?: InputMaybe<FilterInputObject>;
  /** Responsible user full name */
  userFullName?: InputMaybe<FilterInputObject>;
};

/** Site attributes */
export type SiteFindByInputObject = {
  /** Code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Site performance metric by task deadlines missed entity */
export type SitePerformanceMetricByTaskDeadlinesMissed = {
  __typename?: 'SitePerformanceMetricByTaskDeadlinesMissed';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Maybe<Scalars['Int']['output']>;
};

/** Sector performance metric by task deadlines missed by date entity */
export type SitePerformanceMetricByTaskDeadlinesMissedByDate = {
  __typename?: 'SitePerformanceMetricByTaskDeadlinesMissedByDate';
  /** Sector ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed: Scalars['Int']['output'];
};

/** Site performance metric by task results entity */
export type SitePerformanceMetricByTaskResults = {
  __typename?: 'SitePerformanceMetricByTaskResults';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults: Maybe<Scalars['Float']['output']>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Maybe<Scalars['Int']['output']>;
};

/** Site performance metric by task results by date entity */
export type SitePerformanceMetricByTaskResultsByDate = {
  __typename?: 'SitePerformanceMetricByTaskResultsByDate';
  /** Site ID */
  id: Scalars['ID']['output'];
  /** Period */
  period: Scalars['ISO8601Date']['output'];
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults: Scalars['Int']['output'];
};

/** Site sorts */
export type SiteSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sector name */
  sectorName?: InputMaybe<SortDirectionEnum>;
  /** Number of site areas */
  siteAreasCount?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage (deadlines missed) according to the task filters */
  successPercentageByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Success percentage according to the task filters */
  successPercentageByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (deadlines missed) according to the task filters */
  totalAnomaliesByTaskDeadlinesMissed?: InputMaybe<SortDirectionEnum>;
  /** [Performance metrics] Total anomalies (warning and failure completions) according to the task filters */
  totalAnomaliesByTaskResults?: InputMaybe<SortDirectionEnum>;
  /** Number of users (memberships + full admins) */
  usersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SiteUpdateInput = {
  /** Update attributes */
  attributes: SiteUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Site ID */
  id: Scalars['ID']['input'];
};

/** Site attributes */
export type SiteUpdateInputObject = {
  /** Create Site Areas attributes array */
  areas?: InputMaybe<Array<SiteAreaCreateInputObject>>;
  /** Site cellphone */
  cellphone?: InputMaybe<Scalars['String']['input']>;
  /** Create Conduct Code sections attributes array */
  conductCodeSections?: InputMaybe<Array<SiteConductCodeSectionCreateInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Site contact email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Location photo */
  locationPhotoAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Location point */
  locationPoint?: InputMaybe<LocationCuInputObject>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Site contact phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Sector ID */
  sectorId?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** User memberships attributes array (not full admins) */
  userMemberships?: InputMaybe<Array<LinkingInputObject>>;
};

/** Sort directions */
export enum SortDirectionEnum {
  /** Ascending */
  Asc = 'asc',
  /** Descending */
  Desc = 'desc'
}

/** SSO availability check result */
export type SsoCheck = {
  __typename?: 'SsoCheck';
  /** Indicates if password login is allowed (always true) */
  passwordAllowed: Scalars['Boolean']['output'];
  /** Indicates if SSO is available for this email domain */
  ssoEnabled: Scalars['Boolean']['output'];
  /** List of available SSO integrations for this domain */
  ssoIntegrations: Array<SsoIntegrationPreview>;
};

/** Generated SSO code */
export type SsoGeneratedCode = {
  __typename?: 'SsoGeneratedCode';
  /** Assertion Consumer Service URL */
  acsUrl: Scalars['String']['output'];
  /** Unique code for the SSO integration */
  code: Scalars['String']['output'];
  /** Service Provider entity ID */
  entityId: Scalars['String']['output'];
  /** Service Provider metadata URL */
  metadataUrl: Scalars['String']['output'];
};

/** SSO integration entity */
export type SsoIntegration = TimestampInterface & {
  __typename?: 'SsoIntegration';
  /** Whether IdP-initiated SSO login is allowed */
  allowIdpInitiated: Scalars['Boolean']['output'];
  /** Attribute mapping configuration */
  attributeMapping: Maybe<Scalars['JSON']['output']>;
  /** Unique code for the SSO integration */
  code: Scalars['String']['output'];
  /** Associated company domains */
  companyDomains: Array<CompanyDomain>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Display status (computed based on status and domain verification) */
  displayStatus: SsoIntegrationDisplayStatusEnum;
  /** SSO integration icon */
  icon: Maybe<Attachment>;
  /** SSO integration ID */
  id: Scalars['ID']['output'];
  /** IdP metadata XML */
  idpMetadata: Maybe<Scalars['String']['output']>;
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled: Scalars['Boolean']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Indicates if the SSO integration is pinned */
  pinned: Scalars['Boolean']['output'];
  /** Provider preset */
  providerPreset: SsoIntegrationProviderPresetEnum;
  /** Provider type */
  providerType: SsoIntegrationProviderTypeEnum;
  /** Status (admin-controlled) */
  status: SsoIntegrationStatusEnum;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes: Scalars['Boolean']['output'];
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Warning key for configuration issues */
  warningKey: Maybe<SsoIntegrationWarningKeyEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** SsoIntegrationCollection type */
export type SsoIntegrationCollection = {
  __typename?: 'SsoIntegrationCollection';
  /** A collection of paginated SsoIntegrationCollection */
  collection: Array<SsoIntegration>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationCreateInput = {
  /** Create attributes */
  attributes: SsoIntegrationCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** SSO integration attributes */
export type SsoIntegrationCreateInputObject = {
  /** Allow Identity Provider initiated SSO login */
  allowIdpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute mapping configuration */
  attributeMapping: Scalars['JSON']['input'];
  /** Unique code for the SSO integration */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Company domain IDs to associate */
  companyDomainIds: Array<LinkingInputObject>;
  /** SSO integration icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** IdP metadata (raw XML or base64-encoded XML) */
  idpMetadata: Scalars['String']['input'];
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the SSO integration is pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Provider preset */
  providerPreset: SsoIntegrationProviderPresetEnum;
  /** Provider type */
  providerType: SsoIntegrationProviderTypeEnum;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** Available SSO integration display statuses */
export enum SsoIntegrationDisplayStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Misconfigured = 'MISCONFIGURED'
}

/** SSO integration filters */
export type SsoIntegrationFilterInputObject = {
  /** Company domain ID */
  companyDomainsId?: InputMaybe<FilterIdInputObject>;
  /** SSO integration name */
  name?: InputMaybe<FilterInputObject>;
  /** Provider type */
  providerType?: InputMaybe<FilterInputObject>;
};

/** SSO integration preview for login page */
export type SsoIntegrationPreview = {
  __typename?: 'SsoIntegrationPreview';
  /** SSO integration code for constructing init URL */
  code: Scalars['String']['output'];
  /** Custom icon (for custom preset) */
  icon: Maybe<Attachment>;
  /** Display name */
  name: Scalars['String']['output'];
  /** Provider preset (for displaying provider icon) */
  providerPreset: SsoIntegrationProviderPresetEnum;
};

/** Available SSO provider presets */
export enum SsoIntegrationProviderPresetEnum {
  Auth0 = 'AUTH0',
  Custom = 'CUSTOM',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT',
  Okta = 'OKTA',
  Onelogin = 'ONELOGIN'
}

/** Available SSO provider types */
export enum SsoIntegrationProviderTypeEnum {
  Saml = 'SAML'
}

/** SSO integration sorts */
export type SsoIntegrationSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Updated at */
  updatedAt?: InputMaybe<SortDirectionEnum>;
};

/** Available SSO integration statuses */
export enum SsoIntegrationStatusEnum {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

/** Description from base input object. Please set your description for child object. */
export type SsoIntegrationUpdateInput = {
  /** Update attributes */
  attributes: SsoIntegrationUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SSO integration ID */
  id: Scalars['ID']['input'];
};

/** SSO integration attributes */
export type SsoIntegrationUpdateInputObject = {
  /** Allow Identity Provider initiated SSO login */
  allowIdpInitiated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute mapping configuration */
  attributeMapping?: InputMaybe<Scalars['JSON']['input']>;
  /** Company domain IDs to associate */
  companyDomainIds?: InputMaybe<Array<LinkingInputObject>>;
  /** SSO integration icon */
  iconAttached?: InputMaybe<AttachmentCuInputObject>;
  /** IdP metadata (raw XML or base64-encoded XML) */
  idpMetadata?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if Just-In-Time provisioning is enabled */
  jitProvisioningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the SSO integration is pinned */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sync user attributes from IdP on each login */
  syncUserAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time tolerance for SAML assertions in seconds */
  timeToleranceSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** SSO integration warning keys */
export enum SsoIntegrationWarningKeyEnum {
  NoVerifiedDomains = 'NO_VERIFIED_DOMAINS',
  SomeDomainsNotVerified = 'SOME_DOMAINS_NOT_VERIFIED'
}

/** SSO attribute mapping field */
export type SsoMappingField = {
  __typename?: 'SsoMappingField';
  /** Help text explaining the field purpose and constraints */
  description: Maybe<Scalars['String']['output']>;
  /** Field key */
  key: Scalars['String']['output'];
  /** Field label */
  label: Scalars['String']['output'];
  /** Indicates if the field is required */
  required: Scalars['Boolean']['output'];
  /** Display order index for the field */
  sortIndex: Scalars['Int']['output'];
};

/** SystemAdmin entity */
export type SystemAdmin = TimestampInterface & TwoFactorAuthenticatableInterface & UserInterface & {
  __typename?: 'SystemAdmin';
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** SystemAdmin ID */
  id: Scalars['ID']['output'];
  /** Job title */
  jobTitle: Maybe<Scalars['String']['output']>;
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Lock time */
  lockedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Lock reason */
  lockedReason: Maybe<SystemAdminLockedReasonEnum>;
  /** Indicates if password change is required */
  passwordChangeRequired: Scalars['Boolean']['output'];
  /** Password change required reason */
  passwordChangeRequiredReason: Maybe<SystemAdminPasswordChangeRequiredReasonEnum>;
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of available backup codes */
  twoFactorBackupCodesCount: Scalars['Int']['output'];
  /** Indicates if email OTP method is enabled */
  twoFactorEmailOtpEnabled: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication is enabled */
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** List of enabled two-factor authentication methods */
  twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>;
  /** Timestamp of last successful two-factor verification */
  twoFactorLastVerifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if two-factor authentication is required for this account */
  twoFactorRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication reset is required */
  twoFactorResetRequired: Scalars['Boolean']['output'];
  /** Two-factor authentication reset required reason */
  twoFactorResetRequiredReason: Maybe<SystemAdminTwoFactorResetRequiredReasonEnum>;
  /** Indicates if two-factor authentication setup is required */
  twoFactorSetupRequired: Scalars['Boolean']['output'];
  /** Indicates if TOTP (authenticator app) method is enabled */
  twoFactorTotpEnabled: Scalars['Boolean']['output'];
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};

/** SystemAdminCollection type */
export type SystemAdminCollection = {
  __typename?: 'SystemAdminCollection';
  /** A collection of paginated SystemAdminCollection */
  collection: Array<SystemAdmin>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminCreateInput = {
  /** Create attributes */
  attributes: SystemAdminCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** System Admin attributes */
export type SystemAdminCreateInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** System Admin ID */
  id: Scalars['ID']['input'];
};

/** System Admin filters */
export type SystemAdminFilterInputObject = {
  /** Full name */
  fullName?: InputMaybe<FilterInputObject>;
  /** Job title */
  jobTitle?: InputMaybe<FilterInputObject>;
};

/** Available locked reasons */
export enum SystemAdminLockedReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Available password change required reasons */
export enum SystemAdminPasswordChangeRequiredReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Description from base input object. Please set your description for child object. */
export type SystemAdminSelfUpdateInput = {
  /** Update attributes */
  attributes: SystemAdminSelfUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
};

/** System Admin attributes */
export type SystemAdminSelfUpdateInputObject = {
  /** Avatar */
  avatarAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Cancel email changing */
  cancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** System Admin sorts */
export type SystemAdminSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Full name */
  fullName?: InputMaybe<SortDirectionEnum>;
  /** Job title */
  jobTitle?: InputMaybe<SortDirectionEnum>;
};

/** Available two-factor reset required reasons */
export enum SystemAdminTwoFactorResetRequiredReasonEnum {
  SecurityNotYou = 'SECURITY__NOT_YOU'
}

/** Description from base input object. Please set your description for child object. */
export type SystemAdminUpdateInput = {
  /** Update attributes */
  attributes: SystemAdminUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  confirmEmailRedirectUrl: Scalars['String']['input'];
  /** Url to finish registration */
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  /** System Admin ID */
  id: Scalars['ID']['input'];
};

/** System Admin attributes */
export type SystemAdminUpdateInputObject = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type SystemAdminUserCreateInput = {
  /** Create attributes */
  attributes: SystemAdminUserCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company ID */
  companyId: Scalars['ID']['input'];
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type SystemAdminUserCreateInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Role */
  role: UserRoleEnum;
};

/** Tag entity */
export type Tag = TimestampInterface & {
  __typename?: 'Tag';
  canDestroy: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Tag ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** TagCollection type */
export type TagCollection = {
  __typename?: 'TagCollection';
  /** A collection of paginated TagCollection */
  collection: Array<Tag>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TagCreateInput = {
  /** Create attributes */
  attributes: TagCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Tag attributes */
export type TagCreateInputObject = {
  /** Name */
  name: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TagDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id: Scalars['ID']['input'];
};

/** Tag filters */
export type TagFilterInputObject = {
  /** Name */
  name?: InputMaybe<FilterInputObject>;
};

/** Tag sorts */
export type TagSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Task entity */
export type Task = TimestampInterface & {
  __typename?: 'Task';
  /**
   * User entity
   * NOTE: if you only need an Object ID, please use the approverId field to reduce the load on the database.
   */
  approver: Maybe<User>;
  /** Approver ID */
  approverId: Maybe<Scalars['ID']['output']>;
  /** Archived date */
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Asset entity
   * NOTE: if you only need an Object ID, please use the assetId field to reduce the load on the database.
   */
  asset: Maybe<Asset>;
  /** Asset ID */
  assetId: Maybe<Scalars['ID']['output']>;
  canArchive: AuthorizationResult;
  canCompletionCreate: AuthorizationResult;
  canDestroy: AuthorizationResult;
  canFormTemplateVersionUpdate: AuthorizationResult;
  canInterventionCreate: AuthorizationResult;
  canQrCodeRelatedInfoUpdate: AuthorizationResult;
  canReschedule: AuthorizationResult;
  canUpdate: AuthorizationResult;
  /** Completed date */
  completedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Task completion entity */
  completion: Maybe<TaskCompletion>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deadline date (On date or Next check - for non completed tasks) */
  deadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shows the reason why the deadline was missed. */
  deadlineMissedReason: Maybe<TaskDeadlineMissedReasonEnum>;
  /** Indicates if the deadline was missed before. */
  deadlineWasMissed: Scalars['Boolean']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Early completion */
  earlyCompletion: Maybe<Scalars['Int']['output']>;
  /** Early completion unit */
  earlyCompletionUnit: Maybe<TaskEarlyCompletionUnitEnum>;
  /** Form Template entity */
  formTemplate: FormTemplate;
  /** Form Template Version entity */
  formTemplateVersion: FormTemplateVersion;
  /** Key to group the same tasks which are recurring or have been recurred (if recurring rule was deleted in some point) */
  groupKey: Scalars['ID']['output'];
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Intervention entity */
  intervention: Maybe<Intervention>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Form Answers from previous completion that allowed to be shown in the form */
  lastAllowedAnswers: Array<FormAnswer>;
  /** Last check date (Completion date for previous task completion) */
  lastCheckAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last deadline date */
  lastDeadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shows how many days the missed deadline. If the task is not missed, the value is null. */
  lateFor: Maybe<Scalars['Int']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  /** Next deadline date (Next check date - for recurring tasks which have the next created task) */
  nextDeadlineAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Important data digest for todo tasks (changes when the data is changed) [NULL means that not implemented for the query] */
  offlineImportantDataDigest: Maybe<Scalars['String']['output']>;
  /** Original creation date (for recurring tasks) */
  originalCreatedAt: Scalars['ISO8601DateTime']['output'];
  /** Priority */
  priority: TaskPriorityEnum;
  /**
   * Recurring rule entity
   * NOTE: if you only need an Object ID, please use the recurringRuleId field to reduce the load on the database.
   */
  recurringRule: Maybe<RecurringRule>;
  /** Recurring rule ID */
  recurringRuleId: Maybe<Scalars['ID']['output']>;
  /**
   * Site entity
   * NOTE: if you only need an Object ID, please use the siteId field to reduce the load on the database.
   */
  site: Maybe<Site>;
  /**
   * Site Area entity
   * NOTE: if you only need an Object ID, please use the siteAreaId field to reduce the load on the database.
   */
  siteArea: Maybe<SiteArea>;
  /** Site Area ID */
  siteAreaId: Maybe<Scalars['ID']['output']>;
  /** Site ID */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Status */
  status: TaskStatusEnum;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Task attributes */
export type TaskAssignationsInputObject = {
  /** Asset ID */
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Site Area ID */
  siteAreaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkCreateSameInput = {
  /** Create attributes */
  attributes: TaskBulkCreateSameInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Task attributes */
export type TaskBulkCreateSameInputObject = {
  /** Approver ID */
  approverId: Scalars['ID']['input'];
  /** Assignations attributes array */
  assignations: TaskAssignationsInputObject;
  /** Deadline at (On date) */
  deadlineAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Early completion */
  earlyCompletion?: InputMaybe<Scalars['Int']['input']>;
  /** Early completion unit */
  earlyCompletionUnit?: InputMaybe<TaskEarlyCompletionUnitEnum>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Name */
  name: Scalars['String']['input'];
  /** Priority */
  priority: TaskPriorityEnum;
  /** Recurring rule attributes */
  recurringRule?: InputMaybe<RecurringRuleInputObject>;
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkDeadlineMissedReasonUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateDeadlineMissedReasonInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkSchedulingInput = {
  /** Scheduling params */
  attributes: TaskBulkSchedulingInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Task attributes */
export type TaskBulkSchedulingInputObject = {
  /** Deadline at (On date) */
  deadlineAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Early completion */
  earlyCompletion?: InputMaybe<Scalars['Int']['input']>;
  /** Early completion unit */
  earlyCompletionUnit?: InputMaybe<TaskEarlyCompletionUnitEnum>;
  /** Task kind (standard or on-demand) */
  kind: TaskKindEnum;
  /** Recurring rule attributes */
  recurringRule?: InputMaybe<RecurringRuleInputObject>;
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkTemplateVersionUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateTemplateVersionInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TaskBulkUpdateStatusInput = {
  /** Update attributes */
  attributes: TaskUpdateStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** TaskCollection type */
export type TaskCollection = {
  __typename?: 'TaskCollection';
  /** A collection of paginated TaskCollection */
  collection: Array<Task>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Task completion entity */
export type TaskCompletion = TimestampInterface & {
  __typename?: 'TaskCompletion';
  /** Form Answers collection */
  answers: Maybe<Array<FormAnswer>>;
  canStatusUpdate: AuthorizationResult;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Task Completion ID */
  id: Scalars['ID']['output'];
  /**
   * Performer entity
   * NOTE: if you only need an Object ID, please use the performerId field to reduce the load on the database.
   */
  performer: Maybe<User>;
  /** Performer ID */
  performerId: Maybe<Scalars['ID']['output']>;
  /**
   * Solved date
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  solvedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Result status
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  status: Maybe<TaskCompletionStatusEnum>;
  /**
   * Task entity
   * NOTE: if you only need an Object ID, please use the taskId field to reduce the load on the database.
   */
  task: Maybe<Task>;
  /** Task ID */
  taskId: Maybe<Scalars['ID']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Indicates if task completion is expected to be valid
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint: Maybe<FormTemplateQuestionFieldOptionsValidityHintEnum>;
};

/** TaskCompletionCollection type */
export type TaskCompletionCollection = {
  __typename?: 'TaskCompletionCollection';
  /** A collection of paginated TaskCompletionCollection */
  collection: Array<TaskCompletion>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TaskCompletionCreateInput = {
  /** Create attributes */
  attributes: TaskCompletionCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Task completion attributes */
export type TaskCompletionCreateInputObject = {
  /** Answers attributes array */
  answers: Array<FormAnswerCreateInputObject>;
  /** Task ID */
  taskId: Scalars['ID']['input'];
};

/** Task completion filters */
export type TaskCompletionFilterInputObject = {
  /** Created at */
  createdAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Performer ID
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  performerId?: InputMaybe<FilterIdInputObject>;
  /**
   * Validity hint
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  validityHint?: InputMaybe<FilterInputObject>;
};

/** Task completion sorts */
export type TaskCompletionSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Performer full name */
  performerFullName?: InputMaybe<SortDirectionEnum>;
  /** Solved at */
  solvedAt?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
};

/** Available task completion statuses */
export enum TaskCompletionStatusEnum {
  InProgress = 'IN_PROGRESS',
  Solved = 'SOLVED',
  Unsolved = 'UNSOLVED'
}

/** Description from base input object. Please set your description for child object. */
export type TaskCompletionStatusUpdateInput = {
  /** Update attributes */
  attributes: TaskCompletionUpdateStatusInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  taskId: Scalars['ID']['input'];
};

/** Task completion attributes */
export type TaskCompletionUpdateStatusInputObject = {
  /** Status */
  status: TaskCompletionStatusEnum;
};

/** Available deadline missed reasons */
export enum TaskDeadlineMissedReasonEnum {
  Inaccessible = 'INACCESSIBLE',
  Other = 'OTHER',
  SiteClosed = 'SITE_CLOSED',
  StaffProblem = 'STAFF_PROBLEM',
  UnderConstruction = 'UNDER_CONSTRUCTION'
}

/** Description from base input object. Please set your description for child object. */
export type TaskDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  id: Scalars['ID']['input'];
};

/** Available early completion units */
export enum TaskEarlyCompletionUnitEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** Task filters */
export type TaskFilterInputObject = {
  /** Asset code */
  assetCode?: InputMaybe<FilterInputObject>;
  /** Asset ID */
  assetId?: InputMaybe<FilterIdInputObject>;
  /** Asset name */
  assetName?: InputMaybe<FilterInputObject>;
  /** Asset QR prefix */
  assetQrPrefix?: InputMaybe<FilterInputObject>;
  /** Completed at */
  completedAt?: InputMaybe<FilterDateInputObject>;
  /**
   * Completion validity hint
   * ATTENTION: Access allowed for users: [TASKS_MANAGEMENT:READ].
   */
  completionValidityHint?: InputMaybe<FilterInputObject>;
  /** Deadline at */
  deadlineAt?: InputMaybe<FilterDateInputObject>;
  /** Form Category ID */
  formCategoryId?: InputMaybe<FilterIdInputObject>;
  /** Form Category name */
  formCategoryName?: InputMaybe<FilterInputObject>;
  /** Task kind */
  kind?: InputMaybe<FilterIntInputObject>;
  /** Task name */
  name?: InputMaybe<FilterInputObject>;
  /** Task priority */
  priority?: InputMaybe<FilterIntInputObject>;
  /** Site Area code */
  siteAreaCode?: InputMaybe<FilterInputObject>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<FilterIdInputObject>;
  /** Site Area name */
  siteAreaName?: InputMaybe<FilterInputObject>;
  /** Site code */
  siteCode?: InputMaybe<FilterInputObject>;
  /** Site ID */
  siteId?: InputMaybe<FilterIdInputObject>;
  /** Site name */
  siteName?: InputMaybe<FilterInputObject>;
  /** Form Template ID */
  templateId?: InputMaybe<FilterIdInputObject>;
  /** Form Template Version ID */
  templateVersionId?: InputMaybe<FilterIdInputObject>;
};

/** Available task kinds */
export enum TaskKindEnum {
  OnDemand = 'ON_DEMAND',
  Standard = 'STANDARD'
}

/** Available task priorities */
export enum TaskPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/** Tasks which are linked to form template and grouped by recurring rule */
export type TaskScopeArgsLinkedToFormTemplateGroupedInputObject = {
  /** Form Template ID */
  templateId: Scalars['ID']['input'];
};

/** Custom scope attributes */
export type TaskScopeCustomInputObject = {
  /** Tasks which are linked to form template and grouped by recurring rule */
  linkedToFormTemplateGrouped?: InputMaybe<TaskScopeArgsLinkedToFormTemplateGroupedInputObject>;
};

/** Task scope attributes */
export type TaskScopeInputObject = {
  /** Custom scope attributes */
  custom?: InputMaybe<TaskScopeCustomInputObject>;
  /** Scope name */
  name?: InputMaybe<TaskScopeNameEnum>;
};

/** Available task scope names */
export enum TaskScopeNameEnum {
  /** Current active tasks (not completed yet but validated) */
  Active = 'ACTIVE',
  /** Archived tasks */
  Archived = 'ARCHIVED',
  /** Archived tasks grouped by recurrence */
  ArchivedGrouped = 'ARCHIVED_GROUPED',
  /** Completed tasks */
  Completed = 'COMPLETED',
  /** Completed tasks grouped by recurrence */
  CompletedGrouped = 'COMPLETED_GROUPED',
  /** All tasks for dashboard */
  DashboardAll = 'DASHBOARD_ALL',
  /** All tasks for dashboard and grouped by recurring rule */
  DashboardAllGrouped = 'DASHBOARD_ALL_GROUPED',
  /** Tasks with missed deadline */
  DeadlineMissed = 'DEADLINE_MISSED',
  /** Tasks with missed deadline without selected deadline missed reason */
  DeadlineMissedWithoutReason = 'DEADLINE_MISSED_WITHOUT_REASON',
  /** Completed tasks with failure result */
  Failure = 'FAILURE',
  /** Solved completed tasks with failure result */
  FailureSolved = 'FAILURE_SOLVED',
  /** Unsolved completed tasks with failure result */
  FailureUnsolved = 'FAILURE_UNSOLVED',
  /** Current tasks need to be validated */
  MyApprovals = 'MY_APPROVALS',
  /** Completed tasks assigned to me */
  MyCompleted = 'MY_COMPLETED',
  /** Tasks assigned to me and available to complete */
  MyTodoAvailableToComplete = 'MY_TODO_AVAILABLE_TO_COMPLETE',
  /** Tasks assigned to me and not available to complete yet because of deadline date */
  MyTodoUpcoming = 'MY_TODO_UPCOMING',
  /** Completed tasks with non success result and without intervention */
  NonSuccessWithoutIntervention = 'NON_SUCCESS_WITHOUT_INTERVENTION',
  /** Tasks which have not processed yet and grouped by recurring rule */
  NotProcessedGrouped = 'NOT_PROCESSED_GROUPED',
  /** Current tasks that are on validation or validated */
  OnValidationOrValidated = 'ON_VALIDATION_OR_VALIDATED',
  /** Current pending tasks (not completed nor validated yet) */
  Pending = 'PENDING',
  /** Solved completed tasks (with warning or failure result) */
  Solved = 'SOLVED',
  /** Completed tasks with success result */
  Success = 'SUCCESS',
  /** Completed tasks with warning result */
  Warning = 'WARNING',
  /** Solved completed tasks with warning result */
  WarningSolved = 'WARNING_SOLVED',
  /** Unsolved completed tasks with warning result */
  WarningUnsolved = 'WARNING_UNSOLVED'
}

/** Task sorts */
export type TaskSortInputObject = {
  /** Archived at */
  archivedAt?: InputMaybe<SortDirectionEnum>;
  /** Asset name */
  assetName?: InputMaybe<SortDirectionEnum>;
  /** Completed at */
  completedAt?: InputMaybe<SortDirectionEnum>;
  /** Completion solved at */
  completionSolvedAt?: InputMaybe<SortDirectionEnum>;
  /** Completion status */
  completionStatus?: InputMaybe<SortDirectionEnum>;
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Deadline date (On date or Next check - for non completed tasks) */
  deadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Deadline missed reason */
  deadlineMissedReason?: InputMaybe<SortDirectionEnum>;
  /** Form Category name */
  formCategoryName?: InputMaybe<SortDirectionEnum>;
  /** Task kind */
  kind?: InputMaybe<SortDirectionEnum>;
  /** Last check at */
  lastCheckAt?: InputMaybe<SortDirectionEnum>;
  /** Last deadline date */
  lastDeadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Shows how many days the missed deadline. If the task is not missed, the value is null. */
  lateFor?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Next deadline date (Next check date - for recurring tasks which have the next created task) */
  nextDeadlineAt?: InputMaybe<SortDirectionEnum>;
  /** Priority */
  priority?: InputMaybe<SortDirectionEnum>;
  /** Site Area name */
  siteAreaName?: InputMaybe<SortDirectionEnum>;
  /** Site name */
  siteName?: InputMaybe<SortDirectionEnum>;
  /** Status */
  status?: InputMaybe<SortDirectionEnum>;
  /** Form Template name */
  templateName?: InputMaybe<SortDirectionEnum>;
  /** Form Template Version version */
  templateVersionVersion?: InputMaybe<SortDirectionEnum>;
};

/** Available task statuses */
export enum TaskStatusEnum {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  OnValidation = 'ON_VALIDATION',
  Rejected = 'REJECTED',
  Validated = 'VALIDATED'
}

/** Task timeline */
export type TaskTimeline = {
  __typename?: 'TaskTimeline';
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Timeline rows */
  rows: Array<TaskTimelineRow>;
};

/** Available timeline completion group by options */
export enum TaskTimelineCompletionGroupByEnum {
  FormCategory = 'FORM_CATEGORY',
  FormTemplate = 'FORM_TEMPLATE',
  SiteArea = 'SITE_AREA'
}

/** Available timeline frames */
export enum TaskTimelineFrameEnum {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Available timeline group by options */
export enum TaskTimelineGroupByEnum {
  Day = 'DAY',
  Month = 'MONTH'
}

/** Timeline query data attributes */
export type TaskTimelineQueryDataInputObject = {
  /** Date range */
  dateRange: DateRangeInputObject;
  /** Group by */
  groupBy: TaskTimelineGroupByEnum;
  /** Validity hints */
  validityHints?: InputMaybe<Array<FormTemplateQuestionFieldOptionsValidityHintEnum>>;
};

/** Timeline report attributes */
export type TaskTimelineReportCreateInputObject = {
  /** Completion group by */
  completionGroupBy: TaskTimelineCompletionGroupByEnum;
  /** Message to recipient */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Query data */
  queryData: TaskTimelineQueryDataInputObject;
  /** Task IDs */
  taskIds: Array<Scalars['ID']['input']>;
  /** Time frame */
  timeFrame: TaskTimelineFrameEnum;
  /** Recipient user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Timeline row */
export type TaskTimelineRow = {
  __typename?: 'TaskTimelineRow';
  /** Date */
  date: Scalars['String']['output'];
  /** Validity hint counters */
  validityHintCounters: TaskTimelineValidityHintCounter;
};

/** Validity hint counter */
export type TaskTimelineValidityHintCounter = {
  __typename?: 'TaskTimelineValidityHintCounter';
  /** Failure */
  failure: Maybe<Scalars['Int']['output']>;
  /** Hint is absent (no answers where hint was set) */
  none: Maybe<Scalars['Int']['output']>;
  /** Success */
  success: Maybe<Scalars['Int']['output']>;
  /** Warning */
  warning: Maybe<Scalars['Int']['output']>;
};

/** Task attributes */
export type TaskUpdateDeadlineMissedReasonInputObject = {
  /** Deadline missed reason */
  deadlineMissedReason: TaskDeadlineMissedReasonEnum;
};

/** Description from base input object. Please set your description for child object. */
export type TaskUpdateInput = {
  /** Update attributes */
  attributes: TaskUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task ID */
  id: Scalars['ID']['input'];
};

/** Task attributes */
export type TaskUpdateInputObject = {
  /** Approver ID */
  approverId?: InputMaybe<Scalars['ID']['input']>;
  /** Asset ID */
  assetId?: InputMaybe<Scalars['ID']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Priority */
  priority?: InputMaybe<TaskPriorityEnum>;
  /** Site Area ID */
  siteAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Template ID */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Form Template Version ID */
  templateVersionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Task attributes */
export type TaskUpdateStatusInputObject = {
  /** Status */
  status: TaskStatusEnum;
};

/** Task attributes */
export type TaskUpdateTemplateVersionInputObject = {
  /** Form Template Version ID */
  templateVersionId: Scalars['ID']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TasksTimelineReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Params */
  params: TaskTimelineReportCreateInputObject;
};

/** Task entity */
export type TasksTodoCompletableByDateData = {
  __typename?: 'TasksTodoCompletableByDateData';
  /** Task ID */
  id: Scalars['ID']['output'];
  /** Important data digest for todo tasks (changes when the data is changed) [NULL means that not implemented for the query] */
  offlineImportantDataDigest: Scalars['String']['output'];
};

/** Team entity */
export type Team = TimestampInterface & {
  __typename?: 'Team';
  /** Related accesses */
  accesses: Array<Access>;
  canDestroy: AuthorizationResult;
  /** Color */
  color: Scalars['String']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Team ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Maybe<Scalars['String']['output']>;
  /** Indicates if team is read only (default system team) */
  readOnly: Scalars['Boolean']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Assigned users count (only visible by site memberships) */
  visibleUsersCount: Maybe<Scalars['Int']['output']>;
};

/** TeamCollection type */
export type TeamCollection = {
  __typename?: 'TeamCollection';
  /** A collection of paginated TeamCollection */
  collection: Array<Team>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TeamCreateInput = {
  /** Create attributes */
  attributes: TeamCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Team attributes */
export type TeamCreateInputObject = {
  /** Accesses attributes array */
  accesses: Array<AccessCuInputObject>;
  /** Color */
  color: Scalars['String']['input'];
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name: Scalars['String']['input'];
  /** Users attributes array */
  users?: InputMaybe<Array<LinkingInputObject>>;
};

/** Description from base input object. Please set your description for child object. */
export type TeamDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team ID */
  id: Scalars['ID']['input'];
};

/** Team filters */
export type TeamFilterInputObject = {
  /** Name */
  name?: InputMaybe<FilterInputObject>;
  /** Users full name */
  usersFullName?: InputMaybe<FilterInputObject>;
};

/** Team sorts */
export type TeamSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Assigned users count (only visible by site memberships) */
  visibleUsersCount?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type TeamUpdateInput = {
  /** Update attributes */
  attributes: TeamUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team ID */
  id: Scalars['ID']['input'];
};

/** Team attributes */
export type TeamUpdateInputObject = {
  /** Accesses attributes array */
  accesses?: InputMaybe<Array<AccessCuInputObject>>;
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Users attributes array */
  users?: InputMaybe<Array<LinkingInputObject>>;
};

/** Technical pause entity */
export type TechnicalPause = TimestampInterface & {
  __typename?: 'TechnicalPause';
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Created by */
  createdBy: SystemAdmin;
  /** Early terminated at */
  earlyTerminatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** End time of the technical pause */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** Technical pause ID */
  id: Scalars['ID']['output'];
  /** Start time of the technical pause */
  startAt: Scalars['ISO8601DateTime']['output'];
  /** Status */
  status: TechnicalPauseStatusEnum;
  /** Time left to start/end of the technical pause */
  time: Maybe<Scalars['Int']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** TechnicalPauseCollection type */
export type TechnicalPauseCollection = {
  __typename?: 'TechnicalPauseCollection';
  /** A collection of paginated TechnicalPauseCollection */
  collection: Array<TechnicalPause>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseCreateInput = {
  /** Create attributes */
  attributes: TechnicalPauseCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
};

/** Technical Pause attributes */
export type TechnicalPauseCreateInputObject = {
  /** End at */
  endAt: Scalars['ISO8601DateTime']['input'];
  /** Start at */
  startAt: Scalars['ISO8601DateTime']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Technical Pause ID */
  id: Scalars['ID']['input'];
};

/** Technical Pause sorts */
export type TechnicalPauseSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Created by full name */
  createdByFullName?: InputMaybe<SortDirectionEnum>;
  /** End at */
  endAt?: InputMaybe<SortDirectionEnum>;
  /** Start at */
  startAt?: InputMaybe<SortDirectionEnum>;
};

/** Available statuses */
export enum TechnicalPauseStatusEnum {
  Completed = 'COMPLETED',
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED'
}

/** Description from base input object. Please set your description for child object. */
export type TechnicalPauseUpdateInput = {
  /** Update attributes */
  attributes: TechnicalPauseUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 2FA code for verification */
  code: Scalars['String']['input'];
  /** Type of code (totp, email, backup) */
  codeType: AuthenticationTwoFactorCodeTypeEnum;
  /** Technical Pause ID */
  id: Scalars['ID']['input'];
};

/** Technical Pause attributes */
export type TechnicalPauseUpdateInputObject = {
  /** Early terminated */
  earlyTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  /** End at */
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Start at */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Shows timestamp */
export type TimestampInterface = {
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Two-factor authentication fields */
export type TwoFactorAuthenticatableInterface = {
  /** Number of available backup codes */
  twoFactorBackupCodesCount: Scalars['Int']['output'];
  /** Indicates if email OTP method is enabled */
  twoFactorEmailOtpEnabled: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication is enabled */
  twoFactorEnabled: Scalars['Boolean']['output'];
  /** List of enabled two-factor authentication methods */
  twoFactorEnabledMethods: Array<AuthenticationTwoFactorOtpMethodEnum>;
  /** Timestamp of last successful two-factor verification */
  twoFactorLastVerifiedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if two-factor authentication is required for this account */
  twoFactorRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication reset is required */
  twoFactorResetRequired: Scalars['Boolean']['output'];
  /** Indicates if two-factor authentication setup is required */
  twoFactorSetupRequired: Scalars['Boolean']['output'];
  /** Indicates if TOTP (authenticator app) method is enabled */
  twoFactorTotpEnabled: Scalars['Boolean']['output'];
};

/** Backup codes information */
export type TwoFactorBackupCodes = {
  __typename?: 'TwoFactorBackupCodes';
  /** List of backup codes */
  codes: Array<Scalars['String']['output']>;
  /** Number of backup codes */
  count: Scalars['Int']['output'];
};

/** Two-factor authentication setup result */
export type TwoFactorSetupResult = {
  __typename?: 'TwoFactorSetupResult';
  /** Generated backup codes (if requested) */
  backupCodes: Array<Scalars['String']['output']>;
  /** Number of generated backup codes */
  backupCodesCount: Scalars['Int']['output'];
};

/** TOTP setup information */
export type TwoFactorTotpSetup = {
  __typename?: 'TwoFactorTotpSetup';
  /** TOTP secret key */
  secret: Scalars['String']['output'];
  /** TOTP URI for QR code generation */
  uri: Scalars['String']['output'];
};

/** User entity */
export type User = TimestampInterface & UserInterface & {
  __typename?: 'User';
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Indicates if user accepted the Code of Conduct */
  codeOfConductAccepted: Scalars['Boolean']['output'];
  /**
   * Company
   * NOTE: if you only need an Object ID, please use the companyId field to reduce the load on the database.
   */
  company: Company;
  /** Company ID */
  companyId: Scalars['ID']['output'];
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** Final Access setup */
  finalAccesses: Maybe<Array<Access>>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** User ID */
  id: Scalars['ID']['output'];
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Owned company */
  ownedCompany: Maybe<Company>;
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Related personal accesses */
  personalAccesses: Array<Access>;
  /** Personal ID */
  personalId: Maybe<Scalars['String']['output']>;
  /** Phone number in E.164 format */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** Role */
  role: UserRoleEnum;
  /** Sectors collection */
  sectors: SectorCollection;
  /** Sites collection */
  sites: SiteCollection;
  /**
   * Team entity
   * NOTE: if you only need an Object ID, please use the teamId field to reduce the load on the database.
   */
  team: Team;
  /** Team ID */
  teamId: Maybe<Scalars['ID']['output']>;
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Username */
  username: Maybe<Scalars['String']['output']>;
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};


/** User entity */
export type UserSectorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** User entity */
export type UserSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserBulkActivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserBulkDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** IDs */
  ids: Array<Scalars['ID']['input']>;
};

/** Description from base input object. Please set your description for child object. */
export type UserCodeOfConductAcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if user accepted the Code of Conduct */
  codeOfConductAccepted: Scalars['Boolean']['input'];
};

/** UserCollection type */
export type UserCollection = {
  __typename?: 'UserCollection';
  /** A collection of paginated UserCollection */
  collection: Array<User>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type UserCreateInput = {
  /** Create attributes */
  attributes: UserCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm registration */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type UserCreateInputObject = {
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role: UserRoleEnum;
  /** Sector memberships attributes array */
  sectorMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Site memberships attributes array */
  siteMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** User attributes */
export type UserCreateOwnerInputObject = {
  /** Email */
  email: Scalars['String']['input'];
  /** First name */
  firstName: Scalars['String']['input'];
  /** Last name */
  lastName: Scalars['String']['input'];
};

/** Description from base input object. Please set your description for child object. */
export type UserDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User ID */
  id: Scalars['ID']['input'];
};

/** User filters */
export type UserFilterInputObject = {
  /** User email */
  email?: InputMaybe<FilterInputObject>;
  /** User full name */
  fullName?: InputMaybe<FilterInputObject>;
  /** Intervention Action assignees */
  interventionActionAssigneesActionId?: InputMaybe<FilterIdInputObject>;
  /** Intervention Action mentioned users */
  interventionActionsTextMentionsId?: InputMaybe<FilterIdInputObject>;
  /** Intervention assignees */
  interventionAssigneesInterventionId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Sector ID */
  memberAssignedSectorsId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Sector name */
  memberAssignedSectorsName?: InputMaybe<FilterInputObject>;
  /** Assigned Site ID */
  memberAssignedSitesId?: InputMaybe<FilterIdInputObject>;
  /** Assigned Site name */
  memberAssignedSitesName?: InputMaybe<FilterInputObject>;
  /** User personal ID */
  personalId?: InputMaybe<FilterInputObject>;
  /** User role */
  role?: InputMaybe<FilterIntInputObject>;
  /** Sector memberships ID */
  sectorMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** Site memberships ID */
  siteMembershipsId?: InputMaybe<FilterIdInputObject>;
  /** Team ID */
  teamId?: InputMaybe<FilterIdInputObject>;
  /** Team name */
  teamName?: InputMaybe<FilterInputObject>;
  /** User username */
  username?: InputMaybe<FilterInputObject>;
};

/** Common user fields */
export type UserInterface = {
  /** Avatar */
  avatarAttached: Maybe<Attachment>;
  /** Deactivation time */
  deactivatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time until debug mode is active */
  debugModeUntil: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName: Scalars['String']['output'];
  /** Indicates if user has a password set */
  hasPassword: Scalars['Boolean']['output'];
  /** Preferred language */
  lang: LanguageEnum;
  /** Last name */
  lastName: Scalars['String']['output'];
  /** Indicates if user needs to set up password */
  passwordSetupRequired: Scalars['Boolean']['output'];
  /**
   * Last password update time
   * ATTENTION: Access allowed for current resource only.
   */
  passwordUpdatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email awaiting confirmation */
  unconfirmedEmail: Maybe<Scalars['String']['output']>;
  /** Indicates if user has verified email */
  verified: Maybe<Scalars['Boolean']['output']>;
};

/** Available roles */
export enum UserRoleEnum {
  FullAdmin = 'FULL_ADMIN',
  User = 'USER'
}

/** User access */
export type UserScopeArgsAccessInputObject = {
  /** Component name */
  component: AccessComponentEnum;
  /** Min level of access (Means provided value or higher) */
  level: AccessLevelEnum;
  /** Sourceable ID */
  sourceableId?: InputMaybe<Scalars['ID']['input']>;
};

/** Users core filter */
export type UserScopeArgsByCoreInputObject = {
  /** User access */
  access?: InputMaybe<UserScopeArgsAccessInputObject>;
  /** When set to `true`, this filter ensures that only users who have access to **every site** listed in the `siteId` array are returned. If a user lacks access to any one of the specified sites, they will be excluded from the results. */
  allSitesAccessible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only active users */
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Site ID or array of site IDs */
  siteId?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Custom scope attributes */
export type UserScopeCustomInputObject = {
  /** Users core filter */
  byCore?: InputMaybe<UserScopeArgsByCoreInputObject>;
};

/** User scope attributes */
export type UserScopeInputObject = {
  /** Custom scope attributes */
  custom?: InputMaybe<UserScopeCustomInputObject>;
  /** Scope name */
  name?: InputMaybe<UserScopeNameEnum>;
};

/** Available user scope names */
export enum UserScopeNameEnum {
  /** Active users */
  Active = 'ACTIVE'
}

/** Description from base input object. Please set your description for child object. */
export type UserSelfUpdateInput = {
  /** Update attributes */
  attributes: UserSelfUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  redirectUrl: Scalars['String']['input'];
};

/** User attributes */
export type UserSelfUpdateInputObject = {
  /** Avatar */
  avatarAttached?: InputMaybe<AttachmentCuInputObject>;
  /** Cancel email changing */
  cancelConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Interface preferred language */
  lang?: InputMaybe<LanguageEnum>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** User sorts */
export type UserSortInputObject = {
  /** Created at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** User email */
  email?: InputMaybe<SortDirectionEnum>;
  /** Full name */
  fullName?: InputMaybe<SortDirectionEnum>;
  /** Personal ID */
  personalId?: InputMaybe<SortDirectionEnum>;
  /** Role */
  role?: InputMaybe<SortDirectionEnum>;
  /** Team name */
  teamName?: InputMaybe<SortDirectionEnum>;
  /** User username */
  username?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type UserUpdateInput = {
  /** Update attributes */
  attributes: UserUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Url to confirm new email */
  confirmEmailRedirectUrl: Scalars['String']['input'];
  /** Url to finish registration */
  finishRegistrationRedirectUrl: Scalars['String']['input'];
  /** User ID */
  id: Scalars['ID']['input'];
};

/** User attributes */
export type UserUpdateInputObject = {
  /** Accesses attributes array */
  accesses?: InputMaybe<Array<AccessCuInputObject>>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Personal ID */
  personalId?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role?: InputMaybe<UserRoleEnum>;
  /** Sector memberships attributes array */
  sectorMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Site memberships attributes array */
  siteMemberships?: InputMaybe<Array<LinkingInputObject>>;
  /** Team ID */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Current resource */
export type Whoami = {
  __typename?: 'Whoami';
  /** Entrypoint entity */
  entrypoint: AuthenticationEntrypointUnion;
  /** Resource entity */
  resource: AuthenticationWhoamiUnion;
};

/** Widget entity */
export type Widget = TimestampInterface & {
  __typename?: 'Widget';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description: Maybe<Scalars['String']['output']>;
  /** Widget fields configuration */
  fields: WidgetsField;
  /** Widget grid configuration */
  grid: Scalars['JSON']['output'];
  /** Home Page ID */
  homePageId: Scalars['ID']['output'];
  /** Widget ID */
  id: Scalars['ID']['output'];
  /** Widget kind */
  kind: WidgetsKindEnum;
  /** Position */
  position: Scalars['Int']['output'];
  /** Title */
  title: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Widget Template ID */
  widgetTemplateId: Maybe<Scalars['ID']['output']>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetBulkUpdateInput = {
  /** Update attributes */
  attributes: Array<WidgetUpdateInputObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Home Page ID */
  homePageId: Scalars['ID']['input'];
};

/** Widget button item configuration */
export type WidgetFieldsButtonItemInputObject = {
  /** Indicates if button is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last update timestamp for the button */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Widget buttons configuration */
export type WidgetFieldsButtonsInputObject = {
  /** Asset button configuration */
  asset?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Form template button configuration */
  formTemplate?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Intervention button configuration */
  intervention?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Site button configuration */
  site?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Task button configuration */
  task?: InputMaybe<WidgetFieldsButtonItemInputObject>;
  /** Team member button configuration */
  teamMember?: InputMaybe<WidgetFieldsButtonItemInputObject>;
};

/** Widget fields configuration */
export type WidgetFieldsInputObject = {
  /** Background color */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Widget buttons configuration */
  buttons?: InputMaybe<WidgetFieldsButtonsInputObject>;
  /** End at */
  endAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Link */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Location */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Only my */
  onlyMy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start at */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template entity */
export type WidgetTemplate = TimestampInterface & {
  __typename?: 'WidgetTemplate';
  /** Attachments */
  attachmentsAttached: Array<Attachment>;
  /** Time when was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Subtitle */
  description: Maybe<Scalars['String']['output']>;
  /** Widget Template fields configuration */
  fields: WidgetTemplatesField;
  /** Widget Template ID */
  id: Scalars['ID']['output'];
  /** Is default template */
  isDefault: Scalars['Boolean']['output'];
  /** Widget Template kind */
  kind: WidgetTemplatesKindEnum;
  /** Title */
  title: Maybe<Scalars['String']['output']>;
  /** Last update time */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User ID (creator) */
  userId: Maybe<Scalars['ID']['output']>;
  /** Visibility */
  visibility: WidgetTemplatesVisibilityEnum;
};

/** WidgetTemplateCollection type */
export type WidgetTemplateCollection = {
  __typename?: 'WidgetTemplateCollection';
  /** A collection of paginated WidgetTemplateCollection */
  collection: Array<WidgetTemplate>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateCreateInput = {
  /** Widget Template creation attributes */
  attributes: WidgetTemplateCreateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template attributes */
export type WidgetTemplateCreateInputObject = {
  /** Attachments (icon and/or image) */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Subtitle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template fields configuration */
  fields?: InputMaybe<WidgetTemplateFieldsInputObject>;
  /** Widget Template kind */
  kind: WidgetTemplatesKindEnum;
  /** Title */
  title: Scalars['String']['input'];
  /** Visibility (prv for private, pub for public) */
  visibility?: InputMaybe<WidgetTemplatesVisibilityEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  id: Scalars['ID']['input'];
};

/** Widget Template fields configuration */
export type WidgetTemplateFieldsInputObject = {
  /** Background color (for announcement only) */
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  /** Rich text content (for announcement only) */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Link URL (for external_link only) */
  link?: InputMaybe<Scalars['String']['input']>;
};

/** Widget Template filters */
export type WidgetTemplateFilterInputObject = {
  /** Is default filter */
  isDefault?: InputMaybe<FilterInputObject>;
  /** Kind filter */
  kind?: InputMaybe<FilterInputObject>;
  /** Title filter */
  title?: InputMaybe<FilterInputObject>;
  /** Visibility filter */
  visibility?: InputMaybe<FilterInputObject>;
};

/** Widget Template sorting */
export type WidgetTemplateSortInputObject = {
  /** Sort by title */
  title?: InputMaybe<SortDirectionEnum>;
};

/** Description from base input object. Please set your description for child object. */
export type WidgetTemplateUpdateInput = {
  /** Widget Template update attributes */
  attributes: WidgetTemplateUpdateInputObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  id: Scalars['ID']['input'];
};

/** Widget Template attributes */
export type WidgetTemplateUpdateInputObject = {
  /** Attachments (icon and/or image) */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Subtitle */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template fields configuration */
  fields?: InputMaybe<WidgetTemplateFieldsInputObject>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Visibility (prv for private, pub for public) */
  visibility?: InputMaybe<WidgetTemplatesVisibilityEnum>;
};

/** Widget Template fields configuration */
export type WidgetTemplatesField = {
  __typename?: 'WidgetTemplatesField';
  /** Background color */
  backgroundColor: Maybe<Scalars['String']['output']>;
  /** Rich text content */
  content: Maybe<Scalars['String']['output']>;
  /** Link URL */
  link: Maybe<Scalars['String']['output']>;
};

/** Available widget template kinds */
export enum WidgetTemplatesKindEnum {
  ActiveInterventions = 'ACTIVE_INTERVENTIONS',
  Announcement = 'ANNOUNCEMENT',
  Clock = 'CLOCK',
  ExternalLink = 'EXTERNAL_LINK',
  QuickCreation = 'QUICK_CREATION',
  SectorsPerformanceMetricsByDeadlinesMissed = 'SECTORS_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  SitesMap = 'SITES_MAP',
  SitesPerformanceMetricsByDeadlinesMissed = 'SITES_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  WeatherToday = 'WEATHER_TODAY',
  WeatherWeek = 'WEATHER_WEEK'
}

/** Widget template visibility options (prv for private, pub for public) */
export enum WidgetTemplatesVisibilityEnum {
  Prv = 'PRV',
  Pub = 'PUB'
}

/** Widget attributes */
export type WidgetUpdateInputObject = {
  /** Destroy widget (if true, widget will be destroyed) */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attachments */
  attachmentsAttached?: InputMaybe<Array<AttachmentCuInputObject>>;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Widget fields configuration */
  fields?: InputMaybe<WidgetFieldsInputObject>;
  /** Widget grid configuration */
  grid?: InputMaybe<Scalars['JSON']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind */
  kind?: InputMaybe<WidgetsKindEnum>;
  /** Position */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Widget Template ID */
  widgetTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Widget fields configuration */
export type WidgetsField = {
  __typename?: 'WidgetsField';
  /** Background color */
  backgroundColor: Maybe<Scalars['String']['output']>;
  /** Widget fields buttons configuration */
  buttons: Maybe<WidgetsFieldsButtons>;
  /** End at */
  endAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Link */
  link: Maybe<Scalars['String']['output']>;
  /** Location */
  location: Maybe<Scalars['String']['output']>;
  /** Only my */
  onlyMy: Maybe<Scalars['Boolean']['output']>;
  /** Start at */
  startAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timezone */
  timezone: Maybe<Scalars['String']['output']>;
};

/** Widget button item configuration */
export type WidgetsFieldsButtonItem = {
  __typename?: 'WidgetsFieldsButtonItem';
  /** Indicates if button is enabled */
  enabled: Maybe<Scalars['Boolean']['output']>;
  /** Last update timestamp for the button */
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Widget fields buttons configuration */
export type WidgetsFieldsButtons = {
  __typename?: 'WidgetsFieldsButtons';
  /** Asset button configuration */
  asset: Maybe<WidgetsFieldsButtonItem>;
  /** Form template button configuration */
  formTemplate: Maybe<WidgetsFieldsButtonItem>;
  /** Intervention button configuration */
  intervention: Maybe<WidgetsFieldsButtonItem>;
  /** Site button configuration */
  site: Maybe<WidgetsFieldsButtonItem>;
  /** Task button configuration */
  task: Maybe<WidgetsFieldsButtonItem>;
  /** Team member button configuration */
  teamMember: Maybe<WidgetsFieldsButtonItem>;
};

/** Available widget kinds */
export enum WidgetsKindEnum {
  ActiveInterventions = 'ACTIVE_INTERVENTIONS',
  Announcement = 'ANNOUNCEMENT',
  Clock = 'CLOCK',
  ExternalLink = 'EXTERNAL_LINK',
  QuickCreation = 'QUICK_CREATION',
  SectorsPerformanceMetricsByDeadlinesMissed = 'SECTORS_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  SitesMap = 'SITES_MAP',
  SitesPerformanceMetricsByDeadlinesMissed = 'SITES_PERFORMANCE_METRICS_BY_DEADLINES_MISSED',
  WeatherToday = 'WEATHER_TODAY',
  WeatherWeek = 'WEATHER_WEEK'
}

export type AuthenticationConfirmationsEmailConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsEmailConfirmationInput;
}>;


export type AuthenticationConfirmationsEmailConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationConfirmationsRegistrationConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsRegistrationConfirmationInput;
}>;


export type AuthenticationConfirmationsRegistrationConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationConfirmationsResendEmailConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsResendEmailConfirmationInput;
}>;


export type AuthenticationConfirmationsResendEmailConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables = Exact<{
  input: AuthenticationConfirmationsResendRegistrationConfirmationInput;
}>;


export type AuthenticationConfirmationsResendRegistrationConfirmationMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationPasswordsForgotMutationVariables = Exact<{
  input: AuthenticationPasswordsForgotInput;
}>;


export type AuthenticationPasswordsForgotMutation = { __typename?: 'Mutation', data: { __typename?: 'ResponseMessage', message: string } };

export type AuthenticationPasswordsResetMutationVariables = Exact<{
  input: AuthenticationPasswordsResetInput;
}>;


export type AuthenticationPasswordsResetMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationPasswordsUpdateMutationVariables = Exact<{
  input: AuthenticationPasswordsUpdateInput;
}>;


export type AuthenticationPasswordsUpdateMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationSessionCreateMutationVariables = Exact<{
  input: AuthenticationSessionCreateInput;
}>;


export type AuthenticationSessionCreateMutation = { __typename?: 'Mutation', data: { __typename?: 'Whoami', resource: { __typename?: 'SystemAdmin', id: string } | { __typename?: 'User' } } };

export type AuthenticationSessionEndMutationVariables = Exact<{
  input: AuthenticationSessionEndInput;
}>;


export type AuthenticationSessionEndMutation = { __typename?: 'Mutation', data: boolean | null };

export type WhoamiQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoamiQuery = { __typename?: 'Query', whoami: { __typename?: 'Whoami', resource: { __typename: 'SystemAdmin' } | { __typename: 'User', deactivatedAt: any | null, createdAt: any, email: string | null, firstName: string, id: string, lang: LanguageEnum, lastName: string, personalId: string | null, passwordSetupRequired: boolean, unconfirmedEmail: string | null, updatedAt: any, username: string | null, verified: boolean | null, phoneNumber: string | null, role: UserRoleEnum, codeOfConductAccepted: boolean, avatarAttached: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null } | null, sites: { __typename?: 'SiteCollection', collection: Array<{ __typename?: 'Site', id: string, name: string }> } } } };

export type AttachmentFragmentFragment = { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null };

export type MetadataFragmentFragment = { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number };

export type AuthorizationResultFragmentFragment = { __typename?: 'AuthorizationResult', value: boolean, message: string | null, reasons: { __typename?: 'FailureReasons', details: string, fullMessages: Array<string> } | null };

export type AuthenticationSsoCheckQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AuthenticationSsoCheckQuery = { __typename?: 'Query', data: { __typename?: 'SsoCheck', ssoEnabled: boolean, passwordAllowed: boolean, ssoIntegrations: Array<{ __typename?: 'SsoIntegrationPreview', code: string, name: string, providerPreset: SsoIntegrationProviderPresetEnum, icon: { __typename?: 'Attachment', id: string, processed: boolean, fileTag: string | null, fileData: any | null, filename: string | null, urls: { __typename?: 'AttachmentUrl', large: string | null, medium: string | null, original: string | null, small: string | null, imagePreview: string | null, originalDirectDownload: string | null } | null } | null }> } };

export type AuthenticationPasswordSetupMutationVariables = Exact<{
  input: AuthenticationPasswordSetupInput;
}>;


export type AuthenticationPasswordSetupMutation = { __typename?: 'Mutation', data: boolean };

export const AttachmentFragmentFragmentDoc = gql`
    fragment attachmentFragment on Attachment {
  id
  processed
  fileTag
  fileData
  filename
  urls {
    large
    medium
    original
    small
    imagePreview
    originalDirectDownload
  }
}
    `;
export const MetadataFragmentFragmentDoc = gql`
    fragment metadataFragment on CollectionMetadata {
  currentPage
  limitValue
  totalCount
  totalPages
}
    `;
export const AuthorizationResultFragmentFragmentDoc = gql`
    fragment authorizationResultFragment on AuthorizationResult {
  value
  message
  reasons {
    details
    fullMessages
  }
}
    `;
export const AuthenticationConfirmationsEmailConfirmationDocument = gql`
    mutation authenticationConfirmationsEmailConfirmation($input: AuthenticationConfirmationsEmailConfirmationInput!) {
  data: authenticationConfirmationsEmailConfirmation(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;
export type AuthenticationConfirmationsEmailConfirmationMutationFn = Apollo.MutationFunction<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>;

/**
 * __useAuthenticationConfirmationsEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsEmailConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsEmailConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>(AuthenticationConfirmationsEmailConfirmationDocument, options);
      }
export type AuthenticationConfirmationsEmailConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsEmailConfirmationMutation>;
export type AuthenticationConfirmationsEmailConfirmationMutationResult = Apollo.MutationResult<AuthenticationConfirmationsEmailConfirmationMutation>;
export type AuthenticationConfirmationsEmailConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthenticationConfirmationsEmailConfirmationMutation, AuthenticationConfirmationsEmailConfirmationMutationVariables>;
export const AuthenticationConfirmationsRegistrationConfirmationDocument = gql`
    mutation authenticationConfirmationsRegistrationConfirmation($input: AuthenticationConfirmationsRegistrationConfirmationInput!) {
  data: authenticationConfirmationsRegistrationConfirmation(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;
export type AuthenticationConfirmationsRegistrationConfirmationMutationFn = Apollo.MutationFunction<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>;

/**
 * __useAuthenticationConfirmationsRegistrationConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsRegistrationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsRegistrationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsRegistrationConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsRegistrationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsRegistrationConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>(AuthenticationConfirmationsRegistrationConfirmationDocument, options);
      }
export type AuthenticationConfirmationsRegistrationConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsRegistrationConfirmationMutationResult = Apollo.MutationResult<AuthenticationConfirmationsRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsRegistrationConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthenticationConfirmationsRegistrationConfirmationMutation, AuthenticationConfirmationsRegistrationConfirmationMutationVariables>;
export const AuthenticationConfirmationsResendEmailConfirmationDocument = gql`
    mutation authenticationConfirmationsResendEmailConfirmation($input: AuthenticationConfirmationsResendEmailConfirmationInput!) {
  data: authenticationConfirmationsResendEmailConfirmation(input: $input) {
    message
  }
}
    `;
export type AuthenticationConfirmationsResendEmailConfirmationMutationFn = Apollo.MutationFunction<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>;

/**
 * __useAuthenticationConfirmationsResendEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsResendEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsResendEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsResendEmailConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsResendEmailConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsResendEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>(AuthenticationConfirmationsResendEmailConfirmationDocument, options);
      }
export type AuthenticationConfirmationsResendEmailConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsResendEmailConfirmationMutation>;
export type AuthenticationConfirmationsResendEmailConfirmationMutationResult = Apollo.MutationResult<AuthenticationConfirmationsResendEmailConfirmationMutation>;
export type AuthenticationConfirmationsResendEmailConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthenticationConfirmationsResendEmailConfirmationMutation, AuthenticationConfirmationsResendEmailConfirmationMutationVariables>;
export const AuthenticationConfirmationsResendRegistrationConfirmationDocument = gql`
    mutation authenticationConfirmationsResendRegistrationConfirmation($input: AuthenticationConfirmationsResendRegistrationConfirmationInput!) {
  data: authenticationConfirmationsResendRegistrationConfirmation(input: $input) {
    message
  }
}
    `;
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationFn = Apollo.MutationFunction<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>;

/**
 * __useAuthenticationConfirmationsResendRegistrationConfirmationMutation__
 *
 * To run a mutation, you first call `useAuthenticationConfirmationsResendRegistrationConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationConfirmationsResendRegistrationConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationConfirmationsResendRegistrationConfirmationMutation, { data, loading, error }] = useAuthenticationConfirmationsResendRegistrationConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationConfirmationsResendRegistrationConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>(AuthenticationConfirmationsResendRegistrationConfirmationDocument, options);
      }
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationHookResult = ReturnType<typeof useAuthenticationConfirmationsResendRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationResult = Apollo.MutationResult<AuthenticationConfirmationsResendRegistrationConfirmationMutation>;
export type AuthenticationConfirmationsResendRegistrationConfirmationMutationOptions = Apollo.BaseMutationOptions<AuthenticationConfirmationsResendRegistrationConfirmationMutation, AuthenticationConfirmationsResendRegistrationConfirmationMutationVariables>;
export const AuthenticationPasswordsForgotDocument = gql`
    mutation authenticationPasswordsForgot($input: AuthenticationPasswordsForgotInput!) {
  data: authenticationPasswordsForgot(input: $input) {
    message
  }
}
    `;
export type AuthenticationPasswordsForgotMutationFn = Apollo.MutationFunction<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>;

/**
 * __useAuthenticationPasswordsForgotMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsForgotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsForgotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsForgotMutation, { data, loading, error }] = useAuthenticationPasswordsForgotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsForgotMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>(AuthenticationPasswordsForgotDocument, options);
      }
export type AuthenticationPasswordsForgotMutationHookResult = ReturnType<typeof useAuthenticationPasswordsForgotMutation>;
export type AuthenticationPasswordsForgotMutationResult = Apollo.MutationResult<AuthenticationPasswordsForgotMutation>;
export type AuthenticationPasswordsForgotMutationOptions = Apollo.BaseMutationOptions<AuthenticationPasswordsForgotMutation, AuthenticationPasswordsForgotMutationVariables>;
export const AuthenticationPasswordsResetDocument = gql`
    mutation authenticationPasswordsReset($input: AuthenticationPasswordsResetInput!) {
  data: authenticationPasswordsReset(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;
export type AuthenticationPasswordsResetMutationFn = Apollo.MutationFunction<AuthenticationPasswordsResetMutation, AuthenticationPasswordsResetMutationVariables>;

/**
 * __useAuthenticationPasswordsResetMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsResetMutation, { data, loading, error }] = useAuthenticationPasswordsResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsResetMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationPasswordsResetMutation, AuthenticationPasswordsResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationPasswordsResetMutation, AuthenticationPasswordsResetMutationVariables>(AuthenticationPasswordsResetDocument, options);
      }
export type AuthenticationPasswordsResetMutationHookResult = ReturnType<typeof useAuthenticationPasswordsResetMutation>;
export type AuthenticationPasswordsResetMutationResult = Apollo.MutationResult<AuthenticationPasswordsResetMutation>;
export type AuthenticationPasswordsResetMutationOptions = Apollo.BaseMutationOptions<AuthenticationPasswordsResetMutation, AuthenticationPasswordsResetMutationVariables>;
export const AuthenticationPasswordsUpdateDocument = gql`
    mutation authenticationPasswordsUpdate($input: AuthenticationPasswordsUpdateInput!) {
  data: authenticationPasswordsUpdate(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;
export type AuthenticationPasswordsUpdateMutationFn = Apollo.MutationFunction<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>;

/**
 * __useAuthenticationPasswordsUpdateMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordsUpdateMutation, { data, loading, error }] = useAuthenticationPasswordsUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>(AuthenticationPasswordsUpdateDocument, options);
      }
export type AuthenticationPasswordsUpdateMutationHookResult = ReturnType<typeof useAuthenticationPasswordsUpdateMutation>;
export type AuthenticationPasswordsUpdateMutationResult = Apollo.MutationResult<AuthenticationPasswordsUpdateMutation>;
export type AuthenticationPasswordsUpdateMutationOptions = Apollo.BaseMutationOptions<AuthenticationPasswordsUpdateMutation, AuthenticationPasswordsUpdateMutationVariables>;
export const AuthenticationSessionCreateDocument = gql`
    mutation authenticationSessionCreate($input: AuthenticationSessionCreateInput!) {
  data: authenticationSessionCreate(input: $input) {
    resource {
      ... on SystemAdmin {
        id
      }
    }
  }
}
    `;
export type AuthenticationSessionCreateMutationFn = Apollo.MutationFunction<AuthenticationSessionCreateMutation, AuthenticationSessionCreateMutationVariables>;

/**
 * __useAuthenticationSessionCreateMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionCreateMutation, { data, loading, error }] = useAuthenticationSessionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationSessionCreateMutation, AuthenticationSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationSessionCreateMutation, AuthenticationSessionCreateMutationVariables>(AuthenticationSessionCreateDocument, options);
      }
export type AuthenticationSessionCreateMutationHookResult = ReturnType<typeof useAuthenticationSessionCreateMutation>;
export type AuthenticationSessionCreateMutationResult = Apollo.MutationResult<AuthenticationSessionCreateMutation>;
export type AuthenticationSessionCreateMutationOptions = Apollo.BaseMutationOptions<AuthenticationSessionCreateMutation, AuthenticationSessionCreateMutationVariables>;
export const AuthenticationSessionEndDocument = gql`
    mutation authenticationSessionEnd($input: AuthenticationSessionEndInput!) {
  data: authenticationSessionEnd(input: $input)
}
    `;
export type AuthenticationSessionEndMutationFn = Apollo.MutationFunction<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>;

/**
 * __useAuthenticationSessionEndMutation__
 *
 * To run a mutation, you first call `useAuthenticationSessionEndMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSessionEndMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationSessionEndMutation, { data, loading, error }] = useAuthenticationSessionEndMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationSessionEndMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>(AuthenticationSessionEndDocument, options);
      }
export type AuthenticationSessionEndMutationHookResult = ReturnType<typeof useAuthenticationSessionEndMutation>;
export type AuthenticationSessionEndMutationResult = Apollo.MutationResult<AuthenticationSessionEndMutation>;
export type AuthenticationSessionEndMutationOptions = Apollo.BaseMutationOptions<AuthenticationSessionEndMutation, AuthenticationSessionEndMutationVariables>;
export const WhoamiDocument = gql`
    query Whoami {
  whoami {
    resource {
      __typename
      ... on User {
        avatarAttached {
          ...attachmentFragment
        }
        deactivatedAt
        createdAt
        email
        firstName
        id
        lang
        lastName
        personalId
        passwordSetupRequired
        unconfirmedEmail
        updatedAt
        username
        verified
        phoneNumber
        role
        sites {
          collection {
            id
            name
          }
        }
        codeOfConductAccepted
      }
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useWhoamiQuery__
 *
 * To run a query within a React component, call `useWhoamiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoamiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoamiQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoamiQuery(baseOptions?: Apollo.QueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
      }
export function useWhoamiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
export type WhoamiQueryHookResult = ReturnType<typeof useWhoamiQuery>;
export type WhoamiLazyQueryHookResult = ReturnType<typeof useWhoamiLazyQuery>;
export type WhoamiQueryResult = Apollo.QueryResult<WhoamiQuery, WhoamiQueryVariables>;
export function refetchWhoamiQuery(variables?: WhoamiQueryVariables) {
      return { query: WhoamiDocument, variables: variables }
    }
export const AuthenticationSsoCheckDocument = gql`
    query authenticationSsoCheck($email: String!) {
  data: authenticationSsoCheck(email: $email) {
    ssoEnabled
    passwordAllowed
    ssoIntegrations {
      code
      icon {
        ...attachmentFragment
      }
      name
      providerPreset
    }
  }
}
    ${AttachmentFragmentFragmentDoc}`;

/**
 * __useAuthenticationSsoCheckQuery__
 *
 * To run a query within a React component, call `useAuthenticationSsoCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationSsoCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticationSsoCheckQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAuthenticationSsoCheckQuery(baseOptions: Apollo.QueryHookOptions<AuthenticationSsoCheckQuery, AuthenticationSsoCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticationSsoCheckQuery, AuthenticationSsoCheckQueryVariables>(AuthenticationSsoCheckDocument, options);
      }
export function useAuthenticationSsoCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticationSsoCheckQuery, AuthenticationSsoCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticationSsoCheckQuery, AuthenticationSsoCheckQueryVariables>(AuthenticationSsoCheckDocument, options);
        }
export type AuthenticationSsoCheckQueryHookResult = ReturnType<typeof useAuthenticationSsoCheckQuery>;
export type AuthenticationSsoCheckLazyQueryHookResult = ReturnType<typeof useAuthenticationSsoCheckLazyQuery>;
export type AuthenticationSsoCheckQueryResult = Apollo.QueryResult<AuthenticationSsoCheckQuery, AuthenticationSsoCheckQueryVariables>;
export function refetchAuthenticationSsoCheckQuery(variables: AuthenticationSsoCheckQueryVariables) {
      return { query: AuthenticationSsoCheckDocument, variables: variables }
    }
export const AuthenticationPasswordSetupDocument = gql`
    mutation authenticationPasswordSetup($input: AuthenticationPasswordSetupInput!) {
  data: authenticationPasswordSetup(input: $input)
}
    `;
export type AuthenticationPasswordSetupMutationFn = Apollo.MutationFunction<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>;

/**
 * __useAuthenticationPasswordSetupMutation__
 *
 * To run a mutation, you first call `useAuthenticationPasswordSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationPasswordSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationPasswordSetupMutation, { data, loading, error }] = useAuthenticationPasswordSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationPasswordSetupMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>(AuthenticationPasswordSetupDocument, options);
      }
export type AuthenticationPasswordSetupMutationHookResult = ReturnType<typeof useAuthenticationPasswordSetupMutation>;
export type AuthenticationPasswordSetupMutationResult = Apollo.MutationResult<AuthenticationPasswordSetupMutation>;
export type AuthenticationPasswordSetupMutationOptions = Apollo.BaseMutationOptions<AuthenticationPasswordSetupMutation, AuthenticationPasswordSetupMutationVariables>;